import {kinks} from '@turf/turf';
import * as turf from '@turf/turf';
import {Injectable, NgZone} from '@angular/core';
import {
  GOOGLE_SATELLITE_TILE_URL,
  GOOGLE_TILE_SUBDOMAINS,
  isDisableBabyNumber,
  isDisablePreload,
  isLocal,
  isViewMode
} from '../../../configs/view_only';
import {CadMarker} from '../../models/CadMarker';
import {PreloadService} from '../preloadService/preload.service';
import {ItemConfig} from '../../models/ItemConfig';
import {asyncScheduler, BehaviorSubject, fromEvent, interval, Observable, of, ReplaySubject, Subject, timer} from 'rxjs';
import {ToolsService} from "../toolsService/tools.service";
import {appInjector} from "../../classes/appInjector";
import {LoggerService} from "../../../logger/logger.service";
import {MapPosition} from "../../models/MapPosition";
import {Orientation} from "../../models/Orientation";
import {Polyline} from "../../classes/figures/Polyline";
import {ThreeDModel} from "../../classes/figures/ThreeDModel";
import {DynamicBillboardEntity} from "../../classes/figures/DynamicBillboardEntity";
import {DynamicBillboardPrimitive} from "../../classes/figures/DynamicBillboardPrimitive";

import {Polygon} from "../../classes/figures/Polygon";
import {Cartesian3, Rectangle, HeightReference, Cartesian2, CallbackProperty} from "cesium";
import {ObjectConfig} from "../../models/ObjectConfig";
import {ConcreteLayer} from "../../classes/concreteLayers/ConcreteLayer";
import {concreteFigures} from "../../models/concreteFigures";
import {UiAdapterService} from "../uiAdapterService/ui-adapter.service";
import {Circle} from "../../classes/figures/Circle";
import {debounceTime, filter, take, takeLast, throttleTime} from "rxjs/operators";
import {RotateObjectService} from "../rotateService/rotate-object.service";
import html2canvas from "html2canvas";
import {Overlay} from "../overlay/Overlay";

import {ItemsTilesManager} from '../../classes/ItemsTiles/ItemsTilesManager';
import {ItemsTileImageryProvider} from '../../classes/ItemsTiles/ItemsTileImageryProvider';
import {CanvasLabelsManager} from '../../classes/CanvasLabels/CanvasLabelsManager';
import {ItemsManagerInterface} from '../../classes/ItemsManager/ItemsManagerInterface';
import {CookieService} from '../coockieService/coockie.service';
import {GlobalEventsService} from '@src/app/services/global-events.service';

declare var google;
declare const Yiit;
const $ = window['jQuery'];

// for google imagery providery
let mapZoom = 0;
let nearmapService = null;
let doubleClickTimer = null;
//{
//   providedIn: 'root'
// }
@Injectable()

export class CesiumAdapterService {

  private overlayPrimitiveCollection = new Cesium.PrimitiveCollection();
  private overlayCollectionIndex = 0;
  private visibleOverlays = [];
  private _tilesLoaded = new BehaviorSubject(false);
  private disableSvgPreRender: boolean;
  private isDraggingObjectCopy: boolean;
  private additionalMapRotationByEvents:number = 0;
  private originalViewerHeadingBeforeMove:number = 0;
  private isRotating:boolean = false;
  private _onOpenAlert$ = new Subject<string>();
  private _hideOverlaysObject$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  private _isChangingColor = false;
  public overridedZoomValue: any;
  private isMacOrIOSEnabled = window['isMac']() || window['isIOS']();
  public w3wBillboardId: string = null
  private _updateBWStatus$: Subject<boolean> = new Subject<boolean>();

  // Drag and drop object
  private isMouseDown: boolean = false;
  private mouseDownPosition: Cartesian2;
  private pickedObject: any = null;
  private DRAG_THRESHOLD: number = 4;
  private isDragging: boolean = false;

  get updateBWStatus$(){
    return this._updateBWStatus$.asObservable();
  }


  get hideOverlaysObject$() {
    return this._hideOverlaysObject$.asObservable();
  }

  get onOpenAlert$() {
    return this._onOpenAlert$.asObservable();
  }

  get tilesLoaded() {
    return this._tilesLoaded.asObservable();
  }

  get isChangingColor() {
    return this._isChangingColor;
  }

  set isChangingColor(val) {
    this._isChangingColor = val;
  }

  set tilesLoaded(val: any) {
    this._tilesLoaded.next(val);
  }
  private overlayGroundPrimitiveCollection = new Cesium.PrimitiveCollection();
  public adapterInitialized: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public currentToolSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  private rotatingObjectId = null;
  private rotatingObjectPosition = null;
  private rotateService:RotateObjectService = null;
  private groupService = null;
  public northHeading:number;
  public viewer;
  public activeOverlayId;
  public selectedOverlay;
  public drawingTool;
  public cesiumConverter;
  public concreteFigures;
  public hoverEntity;
  public hintEntity;
  public vertexHints = [];
  public shiftKeyPressed = false;
  public ctrlKeyPressed = false;
  public keepDrawing = false;
  public removeEditablePointEntity;

  public entityAdded: Subject<any> = new Subject<{tool, position, id, radius}>();

  // To request object duplication during line break.
  // Can't use itemManager directly because of circular dependency
  public entityCopyRequested: Subject<any> = new Subject<{id, objectConfigUpdate}>();
  public editingCancelled: Subject<any> = new Subject<boolean>();

  public dragStart: Subject<any> = new Subject<any>();
  public dragStartPosition: any;
  public dragEnd: Subject<any> = new Subject<any>();

  public clickOnObject: Subject<any> = new Subject<any>();

  private _sceneRotatedDegrees:number = 0;
  get sceneRotatedDegrees(){
    return this._sceneRotatedDegrees;
  }
  private _sceneRotated$: BehaviorSubject<any> = new BehaviorSubject<number>(0);
  get sceneRotated$(){
    return this._sceneRotated$.asObservable();
  }

  private _clickOnPrimitive$: Subject<any> = new Subject<any>();
  get clickOnPrimitive$(): Observable<any> {
    return this._clickOnPrimitive$.asObservable();
  }

  private _clickOnMap: Subject<any> = new Subject<MapPosition>();
  get clickOnMap(): Observable<MapPosition> {
    return this._clickOnMap.asObservable();
  }

  private _emptyClick$ = new Subject<boolean>();
  get onEmptyClick$(){
    return this._emptyClick$.asObservable();
  }

  public hoverOnObject: Subject<any> = new Subject<any>();
  private hoverObjId = null;
  private hoverObj$ = new Subject();
  private hideHoverObj = true;
  public imageryLayers = {};
  public currentLayer = {name: null, layer: null};
  public OSMLoaded: Subject<boolean> = new Subject<boolean>();
  public OSMBuildings = null;
  public entityTextToBeRepositioned: Map<string, Polyline> = new Map<string, Polyline>();
  public entitySvgToBeRepositioned: Map<string, Polyline> = new Map<string, Polyline>();

  private svgLinesId = [];
  private canvasSvgLines = [];

  protected overlayHeights = {};
  protected currentOverlayHeight = 0;
  protected overlayHeightStep = 0.1;
  public htmlClicked = false;

  private _overlayDragged$ = new Subject();
  get $overlayDragged$(){
    return this._overlayDragged$.asObservable();
  }

  private _overlayOnChangePosition = new Subject<{id, pos}>();
  public isThreeDModeEnabled = new BehaviorSubject<boolean>(!window['isNewDesign21']);
  get isThreeDMode(){
    return this.isThreeDModeEnabled.asObservable();
  }

  private _showOverlay = new Subject<any>();
  get overlayShowChanged(){
    return this._showOverlay.asObservable();
  }

  private _updateModelOverlay$ = new Subject<any>();
  get overlayUpdateChanged(){
    return this._updateModelOverlay$.asObservable();
  }

  public cameraOldPos = new BehaviorSubject<boolean>(false);
  public editStart:Subject<any> = new Subject<any>();
  private _startRotate$:Subject<any> = new Subject<any>();
  get startRotate$(){
    return this._startRotate$.asObservable();
  }
  public isBwActive = false;
  public imageryProvidersProvider: BehaviorSubject<any> = new BehaviorSubject<any>({});
  public currentImageryProvider: ReplaySubject<any> = new ReplaySubject<any>(1);
  public get currentImageryProvider$(){
    return this.currentImageryProvider.asObservable();
  }
  public selectedImageryProvider;
  private isMultiDrop = false;
  public DEFAULT_BW_PROVIDER_ID = '4';
  private isDrawingConcrete = false;
  public imageryProviders: {[key: string]:any};


  public enabledImageryProviders = ["-1", "4", "6"];

  private isEditing;
  public editingObjectId; // map object id
  public editingEntityId; // map entity id
  private isDrawing;
  public startedDrawingAt;
  private _isDrawingFigureChanged = new Subject<boolean>();
  private _isOverlayMouseDownFires = new Subject();
  get isOverlayMouseDownFires(){
    return this._isOverlayMouseDownFires.asObservable();
  }
  private isOverlayMouseDown = false;
  private isOverlayMouseMoved = false;
  private _overlayChangePosition$ = new Subject<{id:string, position:MapPosition}>();
  public get onOverlayChangePosition(){
    return this._overlayChangePosition$.asObservable();
  }
  private draggableOverlay = null;

  get isDrawingFigure(){
    return this._isDrawingFigureChanged.asObservable();
  }

  get isDrawingNow(){
    return this.isDrawing;
  }
  get isFirstPointSet(){
    return this.currentPositions.length >0 && this.currentTool && this.toolType.toLowerCase().indexOf('poly') >= 0
  }

  private isLeftDown;
  private isChangeCameraMode = false;
  private currentTool = null;
  private toolType;
  private handler;
  get eventsHandler(){
    return this.handler;
  }
  private currentPositions = [];
  private currentObject;
  private toolProvider;
  private draggingObject = null;
  private draggingObjectPos = null;
  private onDrawingMouseMoved: Subject<MapPosition> = new Subject<MapPosition>();
  private _onMouseMovedDifference$: Subject<MapPosition> = new Subject<MapPosition>();
  private isObjectMoved = null;
  private _removeDragHighlight$ = new Subject<{id: string}>();
  get removeDragHighlight$(){
    return this._removeDragHighlight$.asObservable();
  }
  get onMouseMovedDifference$(){
    return this._onMouseMovedDifference$.asObservable();
  }

  private _cameraEventMoveStart: Subject<any> = new Subject<any>();
  get cameraEventMoveStart():Observable<any>{
    return this._cameraEventMoveStart.asObservable();
  }

  private _cameraEventMove: Subject<any> = new Subject<any>();
  get cameraEventMove():Observable<any>{
    return this._cameraEventMove.asObservable();
  }

  private _cameraEventMoveEnd: Subject<any> = new Subject<any>();
  get cameraEventMoveEnd():Observable<any>{
    return this._cameraEventMoveEnd.asObservable();
  }

  // private _cameraEventFires: Subject<{key, val}> = new Subject<{key, val}>();
  // get cameraEventFires():Observable<{key, val}>{
  //   return this._cameraEventFires.asObservable();
  // }

  private _drawingMouseMoveWithPath: Subject<{pos, path}> = new Subject<{pos, path}>();
  get drawingMouseMoveWithPath(){
    return this._drawingMouseMoveWithPath.asObservable();
  }

  private logger = null;
  private zoomLevelHeights = null;
  public _zoom:BehaviorSubject<number> = new BehaviorSubject<number>(0);
  private _eventsHandlerLoaded = new BehaviorSubject(false);
  get isEventsHandlerLoaded(){
    return this._eventsHandlerLoaded.asObservable();
  }

  get zoom():Observable<number> {
    if(this.overridedZoomValue) {
      return new Observable((observer)=>{
        let val = (this.overridedZoomValue < 19) ? this.overridedZoomValue+1 : this.overridedZoomValue;
        observer.next(val);
      })
    }
   return this._zoom.asObservable();
  }

  get currentZoom(){
     if (this.overridedZoomValue){
      return (this.overridedZoomValue < 19) ? this.overridedZoomValue+1 : this.overridedZoomValue;
    }
    return this._zoom.getValue();
  }

  getCurrentZoom() {
     if (this.overridedZoomValue) {
      return (this.overridedZoomValue < 19) ? this.overridedZoomValue+1 : this.overridedZoomValue;
    }
    return this._zoom.getValue();
  }
  private assetList = [];
  // private additionalAssetList = ['http://frontend.events.localhost/map-object/42/beb17202bce07781ccf9c74ef86a3ec4-v3.gltf'];
  private selectedConcreteFigure = null;

  public itemsManager: ItemsManagerInterface = undefined;
  public itemsTilesLayer = undefined;

  protected drawingPolygonCallback: (positions: MapPosition[]) => any; // callback for canvas store

  public hdMapRectangle = null;

  constructor(
      private ngZone: NgZone,
      private ui: UiAdapterService,
      private preload: PreloadService,
      private cookie: CookieService,
      private globalEventsNotification: GlobalEventsService
    ) {
    this.toolProvider = appInjector.get(ToolsService);
    this.logger = appInjector.get(LoggerService);
    this.rotateService = appInjector.get(RotateObjectService);


    if(isLocal){
      this.enabledImageryProviders.push(this.getDefaultImageryProviderId());
    }

    window['HD_MAP_HASH'] = '';
    if (window.hasOwnProperty('NEARMAP_IS_USE') || window.hasOwnProperty('METROMAP_IS_USE')) {
       window['HD_MAP_HASH'] = this.cookie.getCookie('advanced-frontend');
    }

    const tilingScheme = new Cesium.WebMercatorTilingScheme();
    this.hdMapRectangle = tilingScheme.rectangle;
    if (window['HD_MAP_AREA']) {
      try {
        const area = JSON.parse(window['HD_MAP_AREA']);
        this.hdMapRectangle = Cesium.Rectangle.fromDegrees(area[0].lng, area[1].lat, area[1].lng, area[0].lat);
      } catch (e) {
        console.error('Invalid "HD_MAP_AREA" coordinates');
        this.hdMapRectangle = tilingScheme.rectangle;
      }
    }

    this.initImageryProviders(tilingScheme).then(() => {
      this.adapterInitialized.pipe(filter( loaded => loaded)).subscribe(()=>{
        if (this.viewer){
          this.selectViewMode(this.getDefaultImageryProviderId());
        }
      })
    });
    this.concreteFigures = concreteFigures;

    window['overlayPrimitiveCollection'] = this.overlayPrimitiveCollection;
    window['overlayGroundPrimitiveCollection'] = this.overlayGroundPrimitiveCollection;
    // console.log('isNewDEsign', window['isNewDesign21'])
  }

  public setGroupService (groupService) {
    this.groupService = groupService;
    if (this.groupService._itemsLoadedVal) {
      this.viewer.scene.screenSpaceCameraController.enableRotate = true;
    } else {
      this.groupService.itemsLoaded$.subscribe(_ => {
        this.viewer.scene.screenSpaceCameraController.enableRotate = true;
      });
    }
  }

  public setNearmapService(v) {
    nearmapService = v;
  }

  public getViewRectangle() {
    let radianRectangle = this.viewer.camera.computeViewRectangle();
    if (radianRectangle === undefined) {
      var ellipsoid = Cesium.Ellipsoid.WGS84;
      var cl2 = new Cesium.Cartesian2(0, 0);
      var leftTop = this.viewer.scene.camera.pickEllipsoid(cl2, ellipsoid);

      var cr2 = new Cesium.Cartesian2(this.viewer.scene.canvas.width, this.viewer.scene.canvas.height);
      var rightDown = this.viewer.scene.camera.pickEllipsoid(cr2, ellipsoid);

      leftTop = ellipsoid.cartesianToCartographic(leftTop);
      rightDown = ellipsoid.cartesianToCartographic(rightDown);
      radianRectangle = new Cesium.Rectangle(leftTop.longitude, rightDown.latitude, rightDown.longitude, leftTop.latitude);
    }
    let degreesRectangle:any = {};
    degreesRectangle.west = Cesium.Math.toDegrees(radianRectangle.west);
    degreesRectangle.east = Cesium.Math.toDegrees(radianRectangle.east);
    degreesRectangle.north = Cesium.Math.toDegrees(radianRectangle.north);
    degreesRectangle.south = Cesium.Math.toDegrees(radianRectangle.south);
    return degreesRectangle;
  }

  public getViewRectangleAlt() {
    var ellipsoid = Cesium.Ellipsoid.WGS84;
    var cl2 = new Cesium.Cartesian2(0, 0);
    var leftTop = this.viewer.scene.camera.pickEllipsoid(cl2, ellipsoid);

    var cr2 = new Cesium.Cartesian2(this.viewer.scene.canvas.width, this.viewer.scene.canvas.height);
    var rightDown = this.viewer.scene.camera.pickEllipsoid(cr2, ellipsoid);

    if (leftTop != null && rightDown != null) {
        leftTop = ellipsoid.cartesianToCartographic(leftTop);
        rightDown = ellipsoid.cartesianToCartographic(rightDown);
        let rect = new Cesium.Rectangle(leftTop.longitude, rightDown.latitude, rightDown.longitude, leftTop.latitude);
        return rect;
    } else {//The sky is visible in 3D
        console.log("Sky is visible");
        return null;
    }
}

public getViewRectangleFromCentrepoint(coords:any=null, w:any=false, h:any = false) {


    if(!coords){
      coords = this.getCameraPosition();
    }

    if(!w) w = $('.cesium-viewer').width();
    if(!h) h = $('.cesium-viewer').height();

    var topLeftPixel = new Cesium.Cartesian2();

    if(!topLeftPixel){
      return null;
    }

    topLeftPixel.x = 0;
    topLeftPixel.y = 0;
    var topLeftRay = this.viewer.camera.getPickRay(topLeftPixel);
    if(!topLeftRay){
      return null;
    }
    var topLeftCartesian = this.viewer.scene.globe.pick(topLeftRay, this.viewer.scene);
    if(!topLeftCartesian){
      return null;
    }
    var topLeftCarto = Cesium.Cartographic.fromCartesian(topLeftCartesian);
    if(!topLeftCarto){
      return null;
    }
    var north = Cesium.Math.toDegrees(topLeftCarto.latitude); // north
    var west = Cesium.Math.toDegrees(topLeftCarto.longitude); // west


    var botRightPixel = new Cesium.Cartesian2();
    botRightPixel.x = w;
    botRightPixel.y = h;
    var botRightRay = this.viewer.camera.getPickRay(botRightPixel);
    var botRightCartesian = this.viewer.scene.globe.pick(botRightRay, this.viewer.scene);
    var botRightCarto = Cesium.Cartographic.fromCartesian(botRightCartesian);
    var south = Cesium.Math.toDegrees(botRightCarto.latitude); // south
    var east = Cesium.Math.toDegrees(botRightCarto.longitude); // east

    var topRightPixel = new Cesium.Cartesian2();
    topRightPixel.x = w;
    topRightPixel.y = 0;
    var topRightRay = this.viewer.camera.getPickRay(topRightPixel);
    var topRightCartesian = this.viewer.scene.globe.pick(topRightRay, this.viewer.scene);
    var topRightCarto = Cesium.Cartographic.fromCartesian(topRightCartesian);
    var north2 = Cesium.Math.toDegrees(topRightCarto.latitude); // north 2
    var east2 = Cesium.Math.toDegrees(topRightCarto.longitude); // east 2

    var botLeftPixel = new Cesium.Cartesian2();
    botLeftPixel.x = 0;
    botLeftPixel.y = h;
    var botLeftRay = this.viewer.camera.getPickRay(botLeftPixel);
    var botLeftCartesian = this.viewer.scene.globe.pick(botLeftRay, this.viewer.scene);
    var botLeftCarto = Cesium.Cartographic.fromCartesian(botLeftCartesian);
    var south2 = Cesium.Math.toDegrees(botLeftCarto.latitude); // south 2
    var west2 = Cesium.Math.toDegrees(botLeftCarto.longitude); // west 2

    return {
      south: south, west: west, north: north, east: east,
      south2: south2, west2: west2, north2: north2, east2: east2
    };

    // return {
    //   bounds: {
    //     south: south,
    //     west: west,
    //     north: north,
    //     east: east,
    //   },
    //   coords: coords,
    //   w: w,
    //   h: h,
    // };


}

public getViewHeading() {
  return this.viewer.camera.heading;
}
public setViewHeading(val) {
  let start_heading = this.viewer.scene.camera.heading;
  let diff = start_heading-val;
  // var camPos = this.viewer.scene.camera.positionCartographic;
  var camPos = this.viewer.scene.camera.position;
  console.log('camPos', camPos);
  // let pitch = 0;
  // let range = 0;
  // let heading = val;
  this.viewer.scene.camera.rotateRight(diff);


  //this.setupCamera(camPos, {heading : val, pitch : Cesium.Math.toRadians(-90), roll : 0.0}, 10);

  // let pos = this.getCameraPosition();

  // let orientation = {
  //   heading: val,
  //   pitch: Cesium.Math.toRadians(-90),
  //   roll: 0.0,
  // };

  // this.setupCamera(pos, orientation, .1);

  // this.viewer.scene.camera.rotate(camPos, diff);
  // this.viewer.scene.camera.lookAt(camPos, new Cesium.HeadingPitchRange(heading, pitch, range));
  // this.viewer.scene.camera.setView({
  //       orientation: {
  //             heading : val,
  //         }
  //     });
//   console.log('set heading to:', val);
//   this.viewer.scene.camera.setView({
//     destination : Cesium.Cartesian3.fromDegrees(camPos.longitude, camPos.latitude, camPos.height),
//     orientation : {
//         heading : val,
//         pitch : Cesium.Math.toRadians(-90),    // default value (looking down)
//         roll : 0.0                             // default value
//     }
// });
  let end_heading = this.viewer.scene.camera.heading;
  return {start_heading:start_heading, diff:diff, end_heading: end_heading, val:val};
}

public getViewRectangleAsync() {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      let res:any = this.getViewRectangleFromCentrepoint();
      resolve(res);
    }, 500);
  });
}

  private adjustLighting(event?) {

    this.viewer.scene.globe.enableLighting = true;
    this.viewer.scene.globe.dynamicAtmosphereLighting = false;
    var viewer = this.viewer;
    var camera = viewer.camera;
    var canvas = viewer.scene.canvas;

    var ray = camera.getPickRay(new Cesium.Cartesian2(
      Math.round(canvas.clientWidth / 2),
      Math.round(canvas.clientHeight / 2)
    ));

    var position = viewer.scene.globe.pick(ray, viewer.scene);
    if (Cesium.defined(position)) {
      var cpos = Cesium.Ellipsoid.WGS84.cartesianToCartographic(position);

      // var cpos = Cesium.Rectangle.center(rect);
      var long = (cpos.longitude * 180 / Cesium.Math.PI);
      if (long < 0) {
        long = 360 + long;
      }
      var offset = long * 24 / 360;
      var targetTime = '2021-06-03T12:00:00';
      var prefix = '';
      if (Math.floor(offset) > 0) {
        if (Math.floor(offset) < 10) { prefix = '0'; }
        targetTime+= '+' + prefix + Math.floor(offset) + ':00';
      } else if (Math.floor(offset) < 0) {
        if (Math.floor(offset) > -10) { prefix = '0'; }
        targetTime+= '-' + prefix + Math.abs(Math.floor(offset)) + ':00';
      }

      var d = new Date(Date.parse(targetTime));
      this.viewer.clock.currentTime =  Cesium.JulianDate.fromDate(d);
    }
  }

  public setCursorStyle(cursorName){
    this.drawingTool.setCursorStyle(cursorName);
  }

  private initListeners() {
    const self = this;

    window['setViewerZoom'] = this.setZoomLevel.bind(this);
    window['getZoomLevel'] = this.getCurrentZoom.bind(this);
    window['setupCameraHeight'] = this.setupCameraHeight.bind(this);
    window['setupCameraPosition'] = this.setupCamera.bind(this);
    window['getCameraPosition'] = this.getCameraPosition.bind(this);
    window['setCursorStyle'] = this.setCursorStyle.bind(this);

    const helper  = new Cesium.EventHelper();
    helper.add(this.viewer.scene.globe.tileLoadProgressEvent, (event) => {
      this.tilesLoaded = false;
      window['onemapTilesLoaded'] = false;
      if (event == 0) {
        this.tilesLoaded = true;
        window['onemapTilesLoaded'] = true;
      }
    });

    fromEvent(window, 'keydown')
      .pipe(
        throttleTime(500, asyncScheduler, {trailing: true, leading: true}),
        filter(($event: KeyboardEvent) => !!$event.key)
      )
      .subscribe(($event: KeyboardEvent) => {
        if ($event.key.toLowerCase() === 'shift') {
          self.setMultiDrop(true);
          self.shiftKeyPressed = true;
        }
        if ($event.key.toLowerCase() === 'control') {
          self.ctrlKeyPressed = true;
        }
        if (!self.isDrawing && $event.key.toLowerCase() === 'escape') {
          self._emptyClick$.next(true);
        }
      });

    fromEvent(window, 'keyup')
      .pipe(filter(($event: KeyboardEvent) => !!$event.key))
      .subscribe(($event: KeyboardEvent) => {
        if ($event.key.toLowerCase() === 'shift') {
          self.shiftKeyPressed = false;
          self.setMultiDrop(false);
        }
        if ($event.key.toLowerCase() === 'control') {
          self.ctrlKeyPressed = false;
        }
      });

    let container:HTMLElement = document.querySelector('#es-cesium-container .cesium-viewer');
    container.addEventListener('pointermove', function (event: MouseEvent) {
      if (self.draggableOverlay && self.isOverlayMouseDown){
        self.isOverlayMouseMoved = true;
        // let posInCartesian = self.getPosition(event);
        self.draggableOverlay.style.left = event.clientX+'px';
        self.draggableOverlay.style.top = event.clientY-container.offsetTop+'px';
        // let cartographicDegrees = new MapPosition(self.cesiumConverter.convertFromCartesianToCartographic(posInCartesian));
      }
    });

    document.addEventListener('pointerup', function (event) {

      if (self.isOverlayMouseDown && self.draggableOverlay && !self.isOverlayMouseMoved){
        self.isOverlayMouseDown = false;
        self.isOverlayMouseMoved = false;
        if (self.overlayLines.get(self.draggableOverlay.id)) {
          self.overlayLines.get(self.draggableOverlay.id).style.display = 'block';
        }
        self.draggableOverlay = null;
        self.viewer._container.style.cursor = "auto";
        return;
      }

      if (self.isOverlayMouseDown && self.draggableOverlay && self.isOverlayMouseMoved){
        let newEventPosition =  {y: event.clientY - container.offsetTop, x: event.clientX};
        let posInCartesian = self.getPosition(newEventPosition);
        let cartographicDegrees = new MapPosition(self.cesiumConverter.convertFromCartesianToCartographic(posInCartesian));
        self._overlayChangePosition$.next({id: self.draggableOverlay.id, position: cartographicDegrees});
        self.isOverlayMouseDown = false;
        self.isOverlayMouseMoved = false;
        if (self.overlayLines.get(self.draggableOverlay.id)) {
          self.overlayLines.get(self.draggableOverlay.id).style.display = 'block';
        }
        self._overlayDragged$.next(self.draggableOverlay);
        self.draggableOverlay = null;
        self.viewer._container.style.cursor = "auto";

      }

    });

    this.ui.selectedItem$.subscribe((selectedItem) => {
      if (this.isEditing) {
        this.stopEditing();
      }
      this.selectedConcreteFigure = this.getCurrentConcreteFigure(selectedItem);
    });

    this.onDrawingMouseMoved.subscribe((pos: MapPosition) => {
      if (this.isDrawingConcrete) {
        this.drawingTool.drawPrevConcrete(this.currentPositions, pos);
      } else {
        // console.log('[TEST] befor draw toolType', this.toolType);
        const ptsLength = this.currentPositions.length;
        let toolType;
        if (window['isIOS']()) {
          toolType = (ptsLength === 1) ? 'point' :
            (ptsLength === 2) ? 'polyline' :
              (this.toolType) ? this.toolType : 'polygon';
        }

        const color = (this.currentTool && this.currentTool.default_color) ? this.currentTool.default_color : '#EB6432';
        const opacity = (this.currentTool && this.currentTool.default_opacity) ? this.currentTool.default_opacity : 0.6;

          this.drawingTool.drawPreviewEntity(
            window['isIOS']() ? toolType : this.currentTool.type,
            this.currentPositions,
            pos,
            {color, opacity},
          );
      }
    });

    this.rotateService.objectRotated$.subscribe((angleInDegrees) => {
      if (this.rotatingObjectId) {

        // Possible to change next code to mapObject.rotate()
        const object = this.drawingTool.getObjectById(this.rotatingObjectId);
        const type = this.drawingTool.getObjectType(object);

        if (type == 'dynamic-billboard-entity') {
          this.rotateBillboardEntity(this.rotatingObjectId, angleInDegrees);
        } else if (type == 'dynamic-billboard-primitive') {
          const sceneRotatedDegrees = Cesium.Math.toDegrees(this.getCameraOrientation().heading);
          this.rotateBillboardPrimitive(this.rotatingObjectId, angleInDegrees - sceneRotatedDegrees);
        } else {
          this.rotateModel(this.rotatingObjectId, angleInDegrees);
        }
      }
    });

    this.drawingMouseMoveWithPath.subscribe(({pos, path}) => {
      const _path = path.slice(0);
      _path.push(pos);
      if (self.currentTool && self.currentTool.type === 'polyline') {
        self.hintEntity.label.text = self.getHintTextByPath(_path);
        self.updateHintEntityPos(pos);
        self.hintEntity.label.show = true;
      }
      //
      if (self.currentTool && self.currentTool.type === 'circle') {
        self.hintEntity.label.text = self.getHintTextForCircle(_path);
        self.updateHintEntityPos(pos);
        self.hintEntity.label.show = true;
      }
    });

    // for window coordinates calculations
    this.isThreeDModeEnabled.subscribe((flag) => {
      if (flag) {
        this.overlayGroundPrimitiveCollection.show = true;
        this.overlayPrimitiveCollection.show = false;
      } else {
        this.overlayGroundPrimitiveCollection.show = false;
        this.overlayPrimitiveCollection.show = true;
      }
      if (this.drawingTool) {
        this.drawingTool.setPolygonsClampToGroundWithOptions(flag);
      }


      self.overlays.forEach((overlay) => {
        self.displayOverlayInRightPosition(overlay, null, true);
      });

      self.overlayLines.forEach((lineOverlay) => {
        // self.displayOverlayLineInRightPosition(lineOverlay);
        this.recalculateOverlayLabelLinePosition(lineOverlay);
        lineOverlay.style.display = lineOverlay.customParams.beforeMoveDisplay;
      });

      if (!window['CANVAS_LABELS_ALLOWED']) {
        self.babyOverlays.forEach((overlay) => {
          if (!overlay.isOverlayDisabled) {
            self.displayBabyOverlayInRightPosition(overlay);
          }
        });
      }

      this.viewer.scene.requestRender();
    });

    this._overlayOnChangePosition.subscribe((config)=>{
      let labelOverlay = this.overlays.get(config.id);
      let labelLineOverlay = this.overlayLines.get(config.id);
      let babyOverlay = this.babyOverlays.get(config.id);

      if(labelOverlay && labelLineOverlay) {
        this.setOverlayLineLabelPosition(config.id, labelOverlay.customParams.position, {anchor: labelOverlay.customParams.anchor, threshold: labelLineOverlay.customParams.threshold, labelOptions: labelOverlay.customParams.options});
      }
    });

    this.rotateService.hideRotateHandler$.subscribe(()=>{
      this.rotatingObjectId = null;
      this.rotatingObjectPosition = null;
    });

    this.viewer.camera.moveEnd.addEventListener(this.adjustLighting.bind(this));

    this.onEmptyClick$.subscribe(()=>{
      this.ui.hiddenDetailsSidebar = true;
      if(this.w3wBillboardId){
        this.drawingTool.getEntityById(this.w3wBillboardId) ? this.drawingTool.removeObject(this.w3wBillboardId) : null;
        this.viewer.scene.requestRender();
      }
    });

    this.preload.isPreloading$.subscribe((flag)=>{
      this.disableSvgPreRender = flag;
    });
  }

  //be aware that arguments values in px
  getDegreesRectangleCoords(WCRectangle:{leftTop: {x,y}, rightBottom: {x, y}}) {
    let leftTop = this.getPositionFromWindowCoordinates(WCRectangle.leftTop.x, WCRectangle.leftTop.y);
    let leftBottom = this.getPositionFromWindowCoordinates(WCRectangle.leftTop.x, WCRectangle.rightBottom.y);
    let rightTop = this.getPositionFromWindowCoordinates(WCRectangle.rightBottom.x, WCRectangle.leftTop.y);
    let rightBottom = this.getPositionFromWindowCoordinates(WCRectangle.rightBottom.x, WCRectangle.rightBottom.y);

    let leftTopCartographic = Cesium.Cartographic.fromCartesian(leftTop);
    let leftBottomCartographic = Cesium.Cartographic.fromCartesian(leftBottom);
    let rightTopCartographic = Cesium.Cartographic.fromCartesian(rightTop);
    let rightBottomCartographic = Cesium.Cartographic.fromCartesian(rightBottom);

    let leftTopDegrees = new MapPosition({latitude: Cesium.Math.toDegrees(leftTopCartographic.latitude), longitude: Cesium.Math.toDegrees(leftTopCartographic.longitude)});
    let leftBottomDegrees = new MapPosition({latitude: Cesium.Math.toDegrees(leftBottomCartographic.latitude), longitude: Cesium.Math.toDegrees(leftBottomCartographic.longitude)});
    let rightTopDegrees = new MapPosition({latitude: Cesium.Math.toDegrees(rightTopCartographic.latitude), longitude: Cesium.Math.toDegrees(rightTopCartographic.longitude)});
    let rightBottomDegrees = new MapPosition({latitude: Cesium.Math.toDegrees(rightBottomCartographic.latitude), longitude: Cesium.Math.toDegrees(rightBottomCartographic.longitude)});

    return {
      leftTop: leftTopDegrees,
      leftBottom:leftBottomDegrees,
      rightTop:rightTopDegrees,
      rightBottom: rightBottomDegrees
    };
  }

  enableObjectRotate(entityId, position:MapPosition, rotate, cb?){
    this.rotatingObjectId = entityId;
    this.rotatingObjectPosition = position;
    this.calculateRotatePosition(position, rotate, cb );
  }

  private calculateRotatePosition(position = this.rotatingObjectPosition, rotate, cb){
      let wc = this.drawingTool.getWindowCoordinatesFromMapPos(position);
      this.rotateService.setObjectRotateCenterAndOffset(wc, rotate);
      this.rotateService.setCb(cb);
  }

  public calculateHandlerPositionAfterMove(){
    let wc = this.drawingTool.getWindowCoordinatesFromMapPos(this.rotatingObjectPosition);
    this.rotateService.setObjectCenter(wc);
  }

  public setPolylineClampToGround(flag, id){
    if (!id || flag === undefined){
      return;
    }
    if (this.drawingTool){
      this.drawingTool.setPolylineClampToGround(flag, id)
    }
  }

  private getCurrentConcreteFigure(_item){
    let item = _item;
    if (item && item instanceof ConcreteLayer){
      return this.concreteFigures.has(item.id) ? this.concreteFigures.get(item.id)[0] : null;
    }
    return null;
  }

  public async render(position) {
    let promise = new Promise((resolve, reject) => {

      this.ngZone.runOutsideAngular(async () => {
        let self = this;
        console.log('render', position);
        let height = 753;
        var initialPosition = Cesium.Cartesian3.fromDegrees(
          position.lng,
          position.lat,
          height,
        );


        var initialOrientation = new Cesium.HeadingPitchRoll.fromDegrees(
          0,
          -90,
          0,
        );


        // var extent = Cesium.Rectangle.fromDegrees(117.940573,-29.808406,118.313421,-29.468825);

        // Cesium.Camera.DEFAULT_VIEW_RECTANGLE = extent;
        Cesium.Camera.DEFAULT_VIEW_FACTOR = 0;
        Cesium.Camera.DEFAULT_OFFSET = initialOrientation;

        Cesium.Ion.defaultAccessToken = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiIwNDcwYmMwZS00MjlkLTRhMDUtODJiMy1hMmFkYmMwOWQ3ODYiLCJpZCI6MzM2NjgsImlhdCI6MTYwMjgzNzQ0OH0.0PFpnseW9b4KQoGDox6shceKt_O0qU_j281Nsd80sik';

        const viewer = new Cesium.Viewer(document.getElementById('es-cesium-container'), {
          terrainProvider:
            (this.isMacOrIOSEnabled) ?
              await Cesium.CesiumTerrainProvider.fromIonAssetId(1, {
                requestVertexNormals: (location.search.indexOf('vertex=0') < 0), requestWaterMask: false, requestMetadata: false,
              }) :
              new Cesium.CesiumTerrainProvider({
                url: Cesium.IonResource.fromAssetId(1),
                requestVertexNormals: (location.search.indexOf('vertex=0') < 0), requestWaterMask: false, requestMetadata: false,
              }),
          // imageryProvider: this.imageryProviders[this.getDefaultImageryProviderId()].provider, // todo: show default imagery right away
          selectionIndicator: false,
          animation: false,
          fullscreenButton: false,
          timeline: false,
          requestRenderMode: true,
          geocoder: false,
          homeButton: false,
          infoBox: false,
          sceneModePicker: false,
          mapMode2D: Cesium.MapMode2D.ROTATE,
          navigationHelpButton: false,
          navigationInstructionsInitiallyVisible: false,
          skyBox: false,
          terrainShadows: Cesium.ShadowMode.DISABLED,
          maximumRenderTimeChange: Infinity,
          shouldAnimate: false,
          mapProjection: new Cesium.WebMercatorProjection(),
          orderIndependentTranslucency: true,
          // //!this.isIOS()
          contextOptions: {
            webgl: {
              preserveDrawingBuffer: true,
              stencil: true,
              alpha: true,
            },
          },
          baseLayerPicker: false,
        });

        //this.isIOS()
        //this.isIOS()
        viewer.scene.screenSpaceCameraController.enableRotate = false;
        viewer.scene.postProcessStages.fxaa.enabled = true;
        viewer.scene.screenSpaceCameraController.enableZoom = true;
        // viewer.scene.debugShowFramesPerSecond = true;
        if (Cesium.FeatureDetection.supportsImageRenderingPixelated()) {
          viewer.resolutionScale = window.devicePixelRatio;
        }

        viewer.scene.camera.setView({
          destination: initialPosition,
          orientation: initialOrientation,
          endTransform: Cesium.Matrix4.IDENTITY,
        });

        this.northHeading = viewer.scene.camera.heading;

        this.isThreeDModeEnabled.next((viewer.scene.mode == '3'));

        // todo: move initialization to the correct position
        // todo: does not work in 2D

        // changed "changed" event to "moveEnd"
        viewer.camera.moveEnd.addEventListener((event) => {
          // let cameraHeight = Cesium.Cartographic.fromCartesian(viewer.camera.position).height;
          let cameraHeight = viewer.camera.positionCartographic.height;
          self.changeZoomLevel(cameraHeight);
          //self._cameraEventFires.next({key: 'change', val: event}); // we don't use it anywhere
        });


      this.viewer = viewer;

      this.hoverEntity = this.createHoverEntity();
      this.hintEntity = this.createHoverEntity(new Cesium.Cartesian2(-50, -25), Cesium.HorizontalOrigin.RIGHT, Cesium.VerticalOrigin.BOTTOM);

      this.zoomLevelHeights = this.getZoomLevelHeights(1);

      viewer.scene.screenSpaceCameraController.inertiaSpin = 0;
      viewer.scene.screenSpaceCameraController.inertiaTranslate = 0;
      viewer.scene.screenSpaceCameraController.inertiaZoom = 0;
      viewer.scene.globe.tileCacheSize = 1000;
      viewer.scene.highDynamicRange = false;
      viewer.scene.shadows = false;
      viewer.scene.light.intensity = 1.0;

      if (window['MAXIMUM_SCREEN_SPACE_ERROR']) {
        viewer.scene.globe.maximumScreenSpaceError = window['MAXIMUM_SCREEN_SPACE_ERROR'];
      }
      //viewer.resolutionScale = 1;

      if (window['MEMORY_TILE_LABELS_ALLOWED']) {
        viewer.scene.globe.tileCacheSize = 750;
      }

      // Other approach to make model brighter - put sun above the location

      //todo: fix brightness here 1

      // var date = new Date();
      // date.setUTCFullYear(2011, 6, 4);     // July 4, 2011 @ 12:00 UTC
      // date.setUTCHours(12, 0, 0, 0);
      // viewer.scene.globe.enableLighting = true;
      // viewer.clock.currentTime = Cesium.JulianDate.fromDate(date);
      viewer.clock.multiplier = 1;

      // directional flashlight to highlight objects in sight
      // viewer.scene.light = new Cesium.DirectionalLight({
      //   direction: viewer.scene.camera.directionWC,
      // });
      // viewer.scene.preRender.addEventListener(function (scene, time) {
      //   viewer.scene.light.direction = Cesium.Cartesian3.clone(
      //     viewer.scene.camera.directionWC,
      //     viewer.scene.light.direction
      //   );
      // });

      if(window.location.href.indexOf('timeline=puppeteer&') >= 0){
        height = this.getHeightByZoomLevel(19);
        this.setupCameraHeight(height);
      }

      viewer.scene.camera.changed.addEventListener((event)=>{
        this.modelOverlays.forEach((modelOverlay)=>{
          if (modelOverlay != this.draggableOverlay){
            this._updateModelOverlay$.next(modelOverlay);
          }
        })
      });

      viewer.scene.preRender.addEventListener((scene, time) => {
        if (!this.disableSvgPreRender) {
        // if (true){
          this.entityTextToBeRepositioned.forEach((polyline) => {
            this.drawingTool.drawPolylineText(
              polyline.getToolWithAdditionalParams(),
              polyline.path,
              polyline.getViewEntityId(),
              this.currentZoom,
              () => {}
            );
          });
          this.entityTextToBeRepositioned.clear();

          this.entitySvgToBeRepositioned.forEach((polyline) => {
            this.drawingTool.drawPolylineSvgLine(
              polyline.tool,
              polyline.path,
              polyline.getViewEntityId(),
              this.currentZoom,
              () => {}
            );
          });
          this.entitySvgToBeRepositioned.clear();
        }
      });

      // viewer.clock.shouldAnimate = true;
      // Explicitly render a new frame
      viewer.scene.requestRender();

        viewer.scene.screenSpaceCameraController.minimumZoomDistance = 1;

        setTimeout(() => {
          this.currentImageryProvider.next(this.getDefaultImageryProviderId());
          this.selectedImageryProvider = this.getDefaultImageryProviderId();
          this.setAdapterLoaded(viewer);
          this.initOverlayRenderer();
          viewer.scene.primitives.add(this.overlayPrimitiveCollection);
          viewer.scene.primitives.add(this.overlayGroundPrimitiveCollection);

        let helper  = new Cesium.EventHelper();
        helper.add(viewer.scene.globe.tileLoadProgressEvent, (event)=>{
          if (event == 0){
            this.adjustLighting();

            setTimeout(function () {
                if (typeof window['preloader'] !== 'undefined') {
                  window['preloader'].remove();
                }
            }, 1);

            helper.removeAll();
          }
        });

        // tile-generation
        let onemapTilesLoadedHelper  = new Cesium.EventHelper();
        onemapTilesLoadedHelper.add(viewer.scene.globe.tileLoadProgressEvent, (event)=>{
          if (event == 0){
            window['onemapTilesLoaded'] = true;
          } else {
            window['onemapTilesLoaded'] = false;
          }
        });

        onemapTilesLoadedHelper.add(viewer.scene.postRender, (event) => {
          window['lastRenderTime'] = Date.now();
          window['isTilesLoaded'] = viewer.scene.globe.tilesLoaded;
        });

          resolve(true);
        }, 1);
        // }
        // });
      });
    });

    await promise;

    // tile-generation
    window['onemap'] = {
      setZoom: (zoom) => {
        this.moveCameraToZoomLevel(zoom);
      },
      setCenter: (center) => {
        this.viewer.camera.flyTo({
          destination: new Cesium.Cartographic.toCartesian(
            new Cesium.Cartographic(Cesium.Math.toRadians(center.lng), Cesium.Math.toRadians(center.lat), this.viewer.camera.positionCartographic.height)
          )
        })
      }
    };

    window['isRendered'] = (noRenderTime) => {
      if (window['isTilesLoaded'] === true && window['lastRenderTime'] !== null) {
        if (Date.now() - window['lastRenderTime'] > noRenderTime) {
          return true;
        }
      }
      return false;
    };

    this.initListeners();
  }

  private rotateScene(val:number){
    this._sceneRotatedDegrees+=val;
      if(this._sceneRotatedDegrees>= 360 || this._sceneRotatedDegrees <=-360){
        this._sceneRotatedDegrees = this._sceneRotatedDegrees%360;
      }
    this.rotateService.additionalRotate = this._sceneRotatedDegrees;
    this._sceneRotated$.next(this._sceneRotatedDegrees);
  }

  rotateClockWise() {
    this.viewer.scene.camera.setView({
      orientation: {
        heading: this.viewer.scene.camera.heading + Cesium.Math.toRadians(-5.0),
      },
    });
    this.rotateScene(-5);
  }

  rotateCounterClockWise() {
    this.viewer.scene.camera.setView({
      orientation: {
        heading: this.viewer.scene.camera.heading + Cesium.Math.toRadians(5.0),
      }
    });
    this.rotateScene(5);
  }

  public resetCameraToNorth(){
    this.viewer.scene.camera.setView({
      orientation: {
        heading: this.northHeading
      },
    });

    this._sceneRotatedDegrees = Cesium.Math.toDegrees(this.northHeading);
    this.rotateService.additionalRotate = this._sceneRotatedDegrees;
    this._sceneRotated$.next(this._sceneRotatedDegrees);
  }

  public get isNorthHeading():boolean{
    return !this.northHeading || !this.viewer.camera.heading || this.northHeading.toFixed(6) === this.viewer.camera.heading.toFixed(6);
  }

  private initItemManager() {
    if (window['MEMORY_TILE_LABELS_ALLOWED']) {
      this.itemsManager = new ItemsTilesManager(this);
    } else if (window['BILLBOARD_LABELS_ALLOWED']) {
      this.itemsManager = new CanvasLabelsManager(this);
    }

  }

  public drawLabels() {
    if (window['CANVAS_LABELS_ALLOWED']) {
      if (this.itemsManager === undefined) {
        this.initItemManager();
      }
      this.itemsManager.drawAll();
    }
  }

  public disableDrawLabelsMode() {
    if (window['CANVAS_LABELS_ALLOWED']) {
      if (this.itemsManager === undefined) {
        this.initItemManager();
      }
      this.itemsManager.disableDrawMode();
    }
  }

  public getSmoothPolylinePos(entityId):{lat, lng, height?}[]{
    return this.drawingTool.getSmoothPolylinePos(entityId);
  }

  public smoothPolyline(entityId){
    this.drawingTool.smoothPolyline(entityId);
    const entity = this.viewer.entities.getById(entityId);
    this.drawingTool.setPositionsFromCallback(entity);
  }

  public drawPolylineText(tool, path, entityId, cb?) {
    this.drawingTool.drawPolylineText(tool, path, entityId, this.currentZoom, cb);
    if (this.svgLinesId.indexOf(entityId) < 0) {
      this.svgLinesId.push(entityId);
    }
  }

  public drawPolylineSvgLine(tool, path, entityId, cb){
    this.drawingTool.drawPolylineSvgLine(tool, path, entityId, this.currentZoom, cb);
    if(this.svgLinesId.indexOf(entityId) < 0){
      this.svgLinesId.push(entityId);
    }
  }

  public removePolylineText(entityId){
    this.drawingTool.removePolylineText(entityId);
    if (this.svgLinesId.indexOf(entityId) >= 0){
      this.svgLinesId.splice(this.svgLinesId.indexOf(entityId), 1);
    }
  }

  public removePolylineSvgLine(entityId){
    this.drawingTool.removePolylineSvgLine(entityId);
    if (this.svgLinesId.indexOf(entityId) >= 0) {
      this.svgLinesId.splice(this.svgLinesId.indexOf(entityId), 1);
    }
  }

  public setModelBoxTransparentAndImage(entityId, flag){
    this.drawingTool.setModelBoxTransparentAndImage(entityId, flag)
  }

  public onEditingMouseMove(cb){
    this.drawingTool.onEditingMouseMove(cb);
  }

  private createHoverEntity(pixelOffset?, horizontal?, vertical?) {
    return this.viewer.entities.add({
      // heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
      label: {
        show: false,
        showBackground: true,
        eyeOffset :  new Cesium.Cartesian3(0, 0, -10000),
        font: "14px Roboto, Arial, serif",
        heightReference: Cesium.HeightReference.RELATIVE_TO_GROUND,
        horizontalOrigin: horizontal || Cesium.HorizontalOrigin.LEFT,
        verticalOrigin: vertical || Cesium.VerticalOrigin.TOP,
        pixelOffset: pixelOffset || new Cesium.Cartesian2(15, 0),
        // zIndex: 1000
      },
    });
  }

  private changeZoomLevel(cameraHeight){
    let self = this;
    for (let i = self.zoomLevelHeights.length - 1; i >= 0; i--) {
      let l = self.zoomLevelHeights[i];
      if (l.height >= cameraHeight) {
        if (l.level != this._zoom.getValue()) {
          console.log("Zoom level:", l.level, cameraHeight);
          mapZoom = l.level;
          this._zoom.next(l.level);
          this.updateScene();
        }
        return;
      }
    }
    return this._zoom.next(0);
  }

  public forceZoomUpdate(){
    this._zoom.next(this._zoom.getValue());
  }

  public getCurrentZoomLevelHeights() {
    return this.zoomLevelHeights;
  }

  private getZoomLevelByHeight(cameraHeight){
    for (let i = this.zoomLevelHeights.length - 1; i >= 0; i--) {
      let l = this.zoomLevelHeights[i];
      if (l.height >= cameraHeight) {
          return l.level;
      }
    }
    return 0;
  }

  public getHeightByZoomLevel(zoom){
    for (let i = this.zoomLevelHeights.length - 1; i >= 0; i--) {
      let l = this.zoomLevelHeights[i];
      if (l.level == zoom) {
        return l.height;
      }
    }
    return 0;
  }

  public getGlobeHeight(position){
    return this.viewer.scene.globe.getHeight(new Cesium.Cartographic(Cesium.Math.toRadians(position.longitude), Cesium.Math.toRadians(position.latitude)));
  }

  public getPosition(clickPos): Cartesian3 {
    //get position from Cartesian2:{x,y} to Cartesian 3
    return (this.viewer.scene.mode == 3) ? this.viewer.scene.pickPosition(clickPos) : this.viewer.camera.pickEllipsoid(clickPos,this.viewer.scene.globe.ellipsoid);
  }

  public updateHintEntityPos(pos){
    pos.z=1000;
    // console.log('updateHintEntityPos')
    let position = Cesium.Cartesian3.fromDegrees(pos.lng, pos.lat, pos.z);
    if (!this.hintEntity.position){
      this.hintEntity.position = new Cesium.CallbackProperty(function(){
        return position;
      }, false)
    }
    else{
      this.hintEntity.position.setCallback(function () { return position}, false);
    }
    this.hintEntity.label.show = true;
  }

  private pathArrToGooglePath(path:object[]){
    let _path = path.slice(0);
    let _pathTMP = path.slice(0);

    _pathTMP.forEach((position:{lat, lng}, index)=>{
     position = new google.maps.LatLng(position.lat, position.lng);
     _path[index] = position;
    });

    return _path;
  }

  public getHintTextForCircle(path){
    if (!window['GOOGLE_READY']){
      console.error("Geometry service is not available");
      return;
    }
    let _path = this.pathArrToGooglePath(path);

    let radius = google.maps.geometry.spherical.computeLength([_path[0], _path[1]]);
    return `${(Math.PI * Math.pow(radius, 2)).toFixed(3)} m²
        ${(Math.PI * Math.pow(radius*3.2808, 2)).toFixed(3)} ft²
        ${Number(radius).toFixed(3)} m
        ${Number(radius*3.2808).toFixed(3)} ft`;
  }

  public getHintTextByPath(path){
    if (!window['GOOGLE_READY']){
      console.error("Geometry service is not available");
      return;
    }
    let _path = this.pathArrToGooglePath(path);

    let value = Math.round(google.maps.geometry.spherical.computeLength(_path)*1000)/1000;
    return `${Number(value).toFixed(3)} m
        ${Number(value*3.2808).toFixed(3)} ft
        ${Number(value*1.0936).toFixed(3)} yd
        ${Number(value*0.00062).toFixed(3)} mi
        ${Number(value*0.001).toFixed(3)} km `;
  }

  public changeCameraMove(flag) {
    this.viewer.scene.screenSpaceCameraController.enableRotate = flag;
    this.viewer.scene.screenSpaceCameraController.enableTranslate = flag;
    this.viewer.scene.screenSpaceCameraController.enableZoom = flag;
    this.viewer.scene.screenSpaceCameraController.enableTilt = flag;
    this.viewer.scene.screenSpaceCameraController.enableLook = flag;
  }

  public zoomIn(smallZoom?: boolean){
    let pos = this.getCameraPosition();
    let expectedLevel = this.getZoomLevelByHeight(pos.height);
    let smallStep = (expectedLevel >= 20 ? 5 : 100);
    if (smallZoom) {

      let pos = this.getCameraPosition();
      // pos.height-= smallStep;
      this.viewer.camera.zoomIn(smallStep);
    } else {
        if (expectedLevel < this.zoomLevelHeights.length) {
          // this.moveCameraToZoomLevel(expectedLevel);

          if(expectedLevel >= 20){
            this.viewer.camera.zoomIn(smallStep);
          }
          else{
            expectedLevel += 1;
            if (!this.getCameraZoomStepHeight(expectedLevel)){
              this.viewer.camera.zoomIn(smallStep);
              return;
            }
            this.getCameraZoomStepHeight(expectedLevel);
            this.viewer.camera.zoomIn(this.getCameraZoomStepHeight(expectedLevel));
          }
        }
    }
  }

  public zoomOut(smallZoom?: boolean){
    let pos = this.getCameraPosition();
    let expectedLevel = this.getZoomLevelByHeight(pos.height);
    let smallStep = (expectedLevel >= 20 ? 5 : 100);

    if (smallZoom) {
      // let pos = this.getCameraPosition();
      // pos.height+= smallStep;
      //
      // let orientation = {
      //   heading: Cesium.Math.toRadians(0),
      //   pitch: Cesium.Math.toRadians(-90),
      //   roll: 0.0,
      // };

      // this.setupCamera(pos, orientation, .1);
      this.viewer.camera.zoomOut(smallStep);
    } else {
      if (expectedLevel > 1) {
        if(expectedLevel >= 20){
          this.viewer.camera.zoomOut(smallStep);
        }
        else{
          expectedLevel -= 1;
          // this.moveCameraToZoomLevel(expectedLevel);
          this.getCameraZoomStepHeight(expectedLevel);
          let step = this.getCameraZoomStepHeight(expectedLevel);
          step = (step > 0) ? this.getCameraZoomStepHeight(expectedLevel) / 6 : 20;
          this.viewer.camera.zoomOut(step);
        }
      }
    }
  }

  private cameraLookingAtHeight() {
    var viewer = this.viewer;
    var camera = viewer.camera;
    var canvas = viewer.scene.canvas;
    var ray = camera.getPickRay(new Cesium.Cartesian2(
      Math.round(canvas.clientWidth / 2),
      Math.round(canvas.clientHeight / 2)
    ));

    var position = viewer.scene.globe.pick(ray, viewer.scene);
    var height = null;
    if (Cesium.defined(position)) {
      var cartographic = Cesium.Ellipsoid.WGS84.cartesianToCartographic(position);
      height = cartographic.height;
    } else {
      console.log('Looking at space?');
    }
      return height;
  }

  getCameraZoomStepHeight(expectedLevel){
    let pos = this.getCameraPosition();
    let resultHeight = this.zoomLevelHeights[expectedLevel - 1].height - 10;
    let h = Math.abs(pos.height - resultHeight);
    let alphaRad = Math.abs(Cesium.Math.toRadians(90)-Math.abs(this.viewer.camera.pitch));
    let hypotenuse = h / Math.cos(alphaRad);
    let cameraLookingHeight = this.cameraLookingAtHeight();
    if (resultHeight <= cameraLookingHeight){
      return null;
    }
    return hypotenuse;
  }


  private moveCameraToZoomLevel(expectedLevel){
    let pos = this.getCameraPosition();
    let resultHeight = this.zoomLevelHeights[expectedLevel - 1].height;
    pos.height = resultHeight;

    let orientation = {
      heading: Cesium.Math.toRadians(0),
      pitch: Cesium.Math.toRadians(-90),
      roll: 0.0,
    };

    this.setupCamera(pos, orientation, .1);
  }

  private getImageryProvidersTO() {
    let r = {};
    for (let i = 0; i < this.enabledImageryProviders.length; i++) {
      let key = this.enabledImageryProviders[i];
      let value = this.imageryProviders[key];
      r[value.name] = {id:key, icon: value['icon'], image: value['image'], label: value['label'], desc: value['description']};
    }
    return r;
  }

  /* public methods */
  public setAdapterLoaded(viewer){
    let self = this;
    this.viewer = viewer;

    if (Object.keys(this.imageryProvidersProvider.getValue()).length === 0 || !this.viewer){
      timer(200).subscribe(()=>{
        self.setAdapterLoaded(viewer);
      })
      return;
    }


    for (const [key, value] of Object.entries(this.imageryProviders)) {
      // if (key == this.getDefaultImageryProviderId()) {
      //   this.imageryProviders[key].layer = this.viewer.imageryLayers.get(0);
      //   continue;
      // }
      this.imageryProviders[key].layer = new Cesium.ImageryLayer(value.provider, { show: false });
      this.viewer.imageryLayers.add(this.imageryProviders[key].layer);
    }

    if (window['MEMORY_TILE_LABELS_ALLOWED']) {
      // this.viewer.scene.debugShowFramesPerSecond = true;

      // if (window['SHOW_GREED']) {
      //   this.viewer.imageryLayers.addImageryProvider(
      //     new Cesium.TileCoordinatesImageryProvider({ tilingScheme: new Cesium.WebMercatorTilingScheme() })
      //   );
      // }

      this.itemsTilesLayer = this.viewer.imageryLayers.addImageryProvider(
        new ItemsTileImageryProvider(this)
      );
    }

    this.cesiumConverter =  this.viewer.cesiumConverter();
    this.drawingTool = this.viewer.drawingToolNew();

    let isThreeDMode = this.isThreeDModeEnabled.getValue();
    this.overlayPrimitiveCollection.show = !isThreeDMode;
    this.overlayGroundPrimitiveCollection.show = isThreeDMode;
    // this.drawingTool.setPolygonsClampToGroundWithOptions(isThreeDMode);
    // this.drawingTool.setPolylineClampToGround(isThreeDMode);

    try {
      self.adapterInitialized.next(true);
    }
    catch (e) {
      console.error('Cesium resource not loaded error', e);
    }

    // this.viewer.terrainProvider = new Cesium.CesiumTerrainProvider({
    //   url: Cesium.IonResource.fromAssetId(1),
    //   requestVertexNormals : (location.search.indexOf('vertex=0') < 0), requestWaterMask: false, requestMetadata: false
    // });
    this.drawingTool.turf = turf;
  }

  public setMultiDrop(value){
    this.isMultiDrop = value;
    if (!this.isMultiDrop){
      this.disableMultiDropWithDraw();
    }
  }

  private getAssetsFromTools(category){
    let items = category.items;
    for (let i in items){
      if (!items.hasOwnProperty(i)){
        continue;
      }
      let item = items[i];
      if (i.indexOf('category') >= 0){
        this.getAssetsFromTools(item);
      }
      else{
        if (item.type == ObjectConfig.TYPE_FIXED_FIGURE && item.cesium_asset_id && item.cesium_asset_id.toString().trim().length > 0){
          this.assetList.push(item.cesium_asset_id);
        }
        if (item.type == ObjectConfig.TYPE_FIXED_FIGURE) {
          this.assetList.push(this.getPreparedMapIcon(item.map_icon));
        }
      }
    }
    // this.additionalAssetList.forEach((gltf)=>{
    //   this.assetList.push(gltf);
    // })
  }

  public getPreparedMapIcon(mapIcon){
    if (mapIcon.indexOf('.png')  == mapIcon.length - 4){
      return mapIcon.slice(0, mapIcon.indexOf('.png'))+'-v5.gltf';
    }
    if (mapIcon.indexOf('.jpg')  == mapIcon.length - 4){
      return mapIcon.slice(0, mapIcon.indexOf('.jpg'))+'-v5.gltf';
    }
    if (mapIcon.indexOf('.jpeg')  == mapIcon.length - 5){
      return mapIcon.slice(0, mapIcon.indexOf('.jpeg'))+'-v5.gltf';
    }
    if (mapIcon.indexOf('?') > 0) {
      return mapIcon + '&format=gltf';
    }
    return mapIcon;
  }


  public loadIonAssets(){
    let tools = this.toolProvider.getTools();
      for (let categoryName in tools){
        if(tools.hasOwnProperty(categoryName)){
          let category = tools[categoryName];
          this.getAssetsFromTools(category);
        }
      }
    if (!window['isIOS']()) {
      this.assetList.forEach((uri) => {
        let url = uri;
        if (uri.toString().indexOf('http') === 0) {
          if (isDisablePreload || isDisableBabyNumber) {
            return;
          }
          return this.drawingTool.prefetchUrlResource(url);
        }
        if (uri.toString().indexOf(':') > 0) {
          url = uri.split(':')[0];
        }
        if (location.search.indexOf('cesium_models=0') < 0) {
          //this.drawingTool.getResource(url);
        }
      });
    }
  }

  public prefetchUrlResource(url) {
    return this.drawingTool.prefetchUrlResource(url);
  }

  private disableMultiDropWithDraw(){
    if (this.currentPositions.length == 0){
     this.endDrawing();
    }
  }

  setGrayScaleByConcrete(value){
    if ((this.isBwActive && !value) || !this.imageryProviders){
      return;
    }
    this.setCurrentViewModeGrayScale(value);
  }

  public setCurrentViewModeGrayScale(value, dontChangeBw?){
    if (!this.imageryProviders[this.DEFAULT_BW_PROVIDER_ID].layer){
      return;
    }

    if (this.isBwActive === !value){
      return;
    }

    this.imageryProviders[this.selectedImageryProvider].layer.saturation = value;
    this.isBwActive = !value;

    if ( !dontChangeBw) {
      this._updateBWStatus$.next(this.isBwActive);
    }
    this.viewer.scene.requestRender();
  }

  getCurrentViewModeGrayScale(){
    return (this.imageryProviders[this.selectedImageryProvider]) ? this.imageryProviders[this.selectedImageryProvider].layer.saturation : null;
  }

  private toggleLayer(layer, flag, cb?){
    if (layer){
      if (layer.ready){
            layer.show = flag;
         if (cb) {cb(layer)}
         return;
      }

      layer.readyEvent.addEventListener(()=>{
           layer.show = flag;
        if (cb) {cb(layer)}
      })
    }
  }

  public async selectViewMode(assetId){
    this.selectedImageryProvider = assetId;
    let currentProvider = this.imageryProviders[assetId];
    if (this.isMacOrIOSEnabled) {
      let terrain = null;
      if (this.imageryProviders[assetId].hasOwnProperty('terrainProvider')) {
        terrain = new Cesium.Terrain(this.imageryProviders[assetId].terrainProvider);
      } else {
        terrain = new Cesium.Terrain(await Cesium.CesiumTerrainProvider.fromIonAssetId(1, {
          requestVertexNormals: (location.search.indexOf('vertex=0') < 0), requestWaterMask: false, requestMetadata: false
        }));
      }

      terrain.readyEvent.addEventListener((event) => {
        this.viewer.scene.setTerrain(terrain);
        for (const [key, value] of Object.entries(this.imageryProviders)) {
          this.toggleLayer(value.layer, false);
        }

          this.toggleLayer(this.imageryProviders[assetId].layer, true, (_layer) => {

            if (this.viewer && this.viewer.imageryLayers) {
              this.viewer.imageryLayers.raiseToTop(this.imageryProviders[assetId].layer);
            }

            if (currentProvider.hasOwnProperty('dependProvider') && currentProvider.dependProvider) {
              this.imageryProviders[currentProvider.dependProvider].layer.show = true;
            }
          });
      });
      return;
      }

      for (const [key, value] of Object.entries(this.imageryProviders)) {
        value.layer.show = false;
      }

       this.imageryProviders[assetId].layer.show = true;

      if (currentProvider.hasOwnProperty('dependProvider') && currentProvider.dependProvider) {
        this.imageryProviders[currentProvider.dependProvider].layer.show = true;
      }

      if (this.imageryProviders[assetId].hasOwnProperty('terrainProvider')) {
        this.viewer.terrainProvider = this.imageryProviders[assetId].terrainProvider;
      } else {
        this.viewer.terrainProvider = new Cesium.CesiumTerrainProvider({
          url: Cesium.IonResource.fromAssetId(1),
          requestVertexNormals: (location.search.indexOf('vertex=0') < 0), requestWaterMask: false, requestMetadata: false
        });
      }
  }

  public redrawViewMode() {
    this.imageryProviders[this.selectedImageryProvider].layer.show = false;
    // this.imageryProviders['4'].layer.show = true;
    this.viewer.scene.requestRender();
    // this.imageryProviders['4'].layer.show = false;
    setTimeout(() => {
      this.imageryProviders[this.selectedImageryProvider].layer.show = true;
      this.viewer.scene.requestRender();
    }, 1000);

  }

  public drawOverlay(url, west, south, east, north, opacity, rotation, overlayHeight?, overlayHeightFixed?, sort?) {
    let self = this;
    return new Promise((resolve, reject) => {
      //for firefox bug, img onload fires two times;
      let isImgLoaded = false;
      let img = new Image();
      img.src = url;
      img.style.width = "100%";
      img.style.height = "100%";
      img.crossOrigin = 'anonymous';
      img.onload = function () {
        if (isImgLoaded){
          return;
        }
        isImgLoaded = true;
        let material =  new Cesium.Material({
          fabric: {
            type: "Image",
            uniforms: {
              image : img,
              repeat: {x: 1, y:1}
            },
          },
        });

        material.uniforms.color.alpha = opacity;

        let positions = [
          Cesium.Cartesian3.fromDegrees(west, north),
          Cesium.Cartesian3.fromDegrees(east, north),
          Cesium.Cartesian3.fromDegrees(east, south),
          Cesium.Cartesian3.fromDegrees(west, south)
        ];

        let height = null;
        if ((sort || sort === 0) && !overlayHeightFixed) {
          if (self.overlayHeights.hasOwnProperty(url)) {
            height = self.overlayHeights[url];
          } else {
            height = 0.1 + sort * 0.05;
            self.overlayHeights[url] = height;
          }
        } else {
          if (self.overlayHeights.hasOwnProperty(url)) {
            height = self.overlayHeights[url];
          } else {
            height = self.currentOverlayHeight + self.overlayHeightStep;
            self.currentOverlayHeight = height;
            self.overlayHeights[url] = height;
          }


          if (overlayHeight) {
            if (!overlayHeightFixed) {
              height = overlayHeight + (self.overlayPrimitiveCollection.length * 0.05);
            } else {
              height = overlayHeight;
            }
            self.overlayHeights[url] = height;
          }
        }

        let currentId = self.overlayCollectionIndex;

        var e = self.overlayPrimitiveCollection.add(
          new Cesium.Primitive({
            releaseGeometryInstances: false,
            geometryInstances: new Cesium.GeometryInstance({
              id: currentId,
              geometry: new Cesium.PolygonGeometry({
                polygonHierarchy : new Cesium.PolygonHierarchy(
                  positions
                ),
                height: height,
              }),
            }),
            appearance: new Cesium.MaterialAppearance({
              flat: true,
              material: material
            }),
            // show: !self.isThreeDModeEnabled.getValue()
          })
        );
        // e._minTerrainHeight = result.minimumTerrainHeight - 10.0;
        // e._maxTerrainHeight = result.maximumTerrainHeight;

        let newPos = self.cesiumConverter.convertFromCartesianToCartesianHeight(positions);

        let e1_1 = self.overlayGroundPrimitiveCollection.add(
          new Cesium.GroundPrimitive({
            releaseGeometryInstances: false,
            geometryInstances: new Cesium.GeometryInstance({
              id: currentId,
              geometry: new Cesium.PolygonGeometry({
                polygonHierarchy : new Cesium.PolygonHierarchy(
                  newPos
                ),
                height: height
              }),
            }),
            appearance: new Cesium.MaterialAppearance({
              flat: true,
              material: material
            }),
            // show: self.isThreeDModeEnabled.getValue()
          })
        );


        self.viewer.scene.requestRender();

        // initially rotation is made in a wrong way. It rotates not in terms of lat/lng
        // but in terms of windows pixels. Therefore it looses projection distortion
        if (rotation) {
          // for the rotated polygon
          let e2;

          // hide original polygon. We keep it for further calculations. But it might be replaced
          // with array of positions
          // e.polygon.material.color = Cesium.Color.fromAlpha(Cesium.Color.WHITE, 0);

          e.show = false;
          e1_1.show = false;

          // draw or redraw rotated polygon
          let drawRotatedOverlay = function () {
            // get initial window coordinates (px) with their center
            let divCoordinates = [];
            let center = new Cesium.Cartesian2(0, 0);

            let geometry = Cesium.PolygonGeometry.createGeometry(e.geometryInstances.geometry);
            let geometryPos = Cesium.Cartesian3.unpackArray(geometry.attributes.position.values);
            geometryPos.forEach((p) => {
              let dot = Cesium.SceneTransforms.wgs84ToWindowCoordinates(self.viewer.scene, p);
              center.x+= dot.x;
              center.y+= dot.y;
              divCoordinates.push(dot);
            });
            if (divCoordinates) {
              center.x = center.x / divCoordinates.length;
              center.y = center.y / divCoordinates.length;

              // rotation polygon around its center. Each point: (xcosθ−ysinθ ,xsinθ+ycosθ)
              let rotatedDiv = [];
              divCoordinates.forEach((p: any) => {
                let t = new Cesium.Cartesian2(p.x - center.x, p.y - center.y);
                let rotated = new Cesium.Cartesian2(
                  t.x * Math.cos(rotation * Math.PI / 180) - t.y * Math.sin(rotation * Math.PI / 180),
                  t.x * Math.sin(rotation * Math.PI / 180) + t.y * Math.cos(rotation * Math.PI / 180)
                );
                rotatedDiv.push(new Cesium.Cartesian2(rotated.x + center.x, rotated.y + center.y))
              });

              // detect correcponding Cartesian coordinates
              let newCoords = [];
              rotatedDiv.forEach((p: any) => {
                newCoords.push(self.viewer.camera.pickEllipsoid(p));
              });

              if (!e2) {
                // draw initial rotated polygon

         /*       let material2 =  new Cesium.ImageMaterialProperty({
                  image: img,
                  transparent: true
                });*/

                let material2 =  new Cesium.Material({
                  fabric: {
                    type: "Image",
                    uniforms: {
                      image : img,
                      repeat: {x: 1, y:1}
                    },
                  },
                });
                material2.uniforms.color.alpha = opacity;

               let id = self.overlayCollectionIndex;

                if (e){
                  e.destroy();
                  self.overlayPrimitiveCollection.remove(e);
                }
                if(e1_1){
                  e1_1.destroy();
                  self.overlayGroundPrimitiveCollection.remove(e1_1);
                }

                 e2 = self.overlayPrimitiveCollection.add(
                  new Cesium.Primitive({
                    releaseGeometryInstances: false,
                    geometryInstances: new Cesium.GeometryInstance({
                      id: id,
                      geometry: new Cesium.PolygonGeometry({
                        polygonHierarchy : new Cesium.PolygonHierarchy(
                          newCoords
                        ),
                        stRotation: rotation * Math.PI / 180,
                        height: height,
                      }),
                    }),
                    appearance: new Cesium.MaterialAppearance({
                      flat: true,
                      material: material2
                    }),
                    // show: !self.isThreeDModeEnabled.getValue()
                  })
                );


                let newPos = self.cesiumConverter.convertFromCartesianToCartesianHeight(newCoords);

                self.overlayGroundPrimitiveCollection.add(
                  new Cesium.GroundPrimitive({
                    releaseGeometryInstances: false,
                    geometryInstances: new Cesium.GeometryInstance({
                      id: id,
                      geometry: new Cesium.PolygonGeometry({
                        polygonHierarchy : new Cesium.PolygonHierarchy(
                          newPos
                        ),
                        stRotation: rotation * Math.PI / 180,
                        height:height
                      }),
                    }),
                    appearance: new Cesium.MaterialAppearance({
                      flat: true,
                      material: material2
                    }),
                    // show: self.isThreeDModeEnabled.getValue()
                  })
                );
                resolve(e2.geometryInstances.id);
              }
              else {
                // redraw existing rotated polygon
                let geometry = Cesium.PolygonGeometry.createGeometry(e2.geometryInstances.geometry);
                let geometryPos = Cesium.Cartesian3.unpackArray(geometry.attributes.position.values);

                let id = e2.id;
                let material = e2.appearance.material;
                self.overlayPrimitiveCollection.remove(e2);
                self.overlayGroundPrimitiveCollection.remove(self.overlayGroundPrimitiveCollection.get(id));

                self.overlayPrimitiveCollection.add(new Cesium.Primitive({
                  releaseGeometryInstances: false,
                  geometryInstances: new Cesium.GeometryInstance({
                    id: id,
                    geometry: new Cesium.PolygonGeometry({
                      polygonHierarchy : new Cesium.PolygonHierarchy(
                        newCoords
                      ),
                      stRotation: rotation * Math.PI / 180,
                      height: height,
                    }),
                  }),
                  appearance: new Cesium.MaterialAppearance({
                    flat: true,
                    material: material
                  }),
                  // show: !self.isThreeDModeEnabled.getValue()
                }), id);

                let newPos = self.cesiumConverter.convertFromCartesianToCartesianHeight(newCoords);

                self.overlayGroundPrimitiveCollection.add(new Cesium.GroundPrimitive({
                  releaseGeometryInstances: false,
                  geometryInstances: new Cesium.GeometryInstance({
                    id: id,
                    geometry: new Cesium.PolygonGeometry({
                      polygonHierarchy : new Cesium.PolygonHierarchy(
                        newPos
                      ),
                      stRotation: rotation * Math.PI / 180,
                      height: height,
                    }),
                  }),
                  appearance: new Cesium.MaterialAppearance({
                    flat: true,
                    material: material
                  }),
                  // show: self.isThreeDModeEnabled.getValue()
                }), id);
              }
              self.viewer.scene.requestRender();
            } else {
              console.log('Div Coordinates are empty');
            }
          };

          drawRotatedOverlay();
          // self.zoom.pipe(debounceTime(1000)).subscribe((zoom) => {
            // redraw it on every zoom because first calculation no focused on the area of interest
            // may result in wrong polygon position.
            // drawRotatedOverlay();
          // });
        }
        else {
          resolve(e.geometryInstances.id);
        }
        self.overlayCollectionIndex++;
      };
    });
  }

  public getMaxOverlayHeights(){
    let max = 0;
    for (let i in this.overlayHeights){
      let height = this.overlayHeights[i];
      if(height > max){
        max = height;
      }
    }
    return max;
  }

  public setOverlayOpacity(id, opacity) {
    let primitives = [this.getOverlayPrimitiveWithIndex(id, this.overlayPrimitiveCollection), this.getOverlayPrimitiveWithIndex(id, this.overlayGroundPrimitiveCollection)];
    primitives.forEach((_primitive)=>{
      if(_primitive){
        _primitive.appearance.material.uniforms.color.alpha = opacity;
      }
    });
    this.viewer.scene.requestRender();
  }

  setConcreteMaterial(entityId, url, opacity){
    this.drawingTool.setConcreteOptions(entityId, {img: url, opacity: opacity});
  }

  public hideOverlay(id) {
    let primitive = (this.isThreeDModeEnabled.getValue()) ? this.getOverlayPrimitiveWithIndex(id, this.overlayGroundPrimitiveCollection) : this.getOverlayPrimitiveWithIndex(id, this.overlayPrimitiveCollection);
    if (!primitive){
      return;
    }
    if (primitive.show){
      primitive.show = false;
      this.viewer.scene.requestRender();
    }
  }

  setActiveOverlay(id){
    this.activeOverlayId = id;
  }

  public showOverlay(id) {
    let primitive = (this.isThreeDModeEnabled.getValue()) ? this.getOverlayPrimitiveWithIndex(id, this.overlayGroundPrimitiveCollection) : this.getOverlayPrimitiveWithIndex(id, this.overlayPrimitiveCollection);
    if (!primitive){
      return;
    }
    if (!primitive.show){
      primitive.show = true;
      this.setActiveOverlay(id);
      this.viewer.scene.requestRender();
    }
  }

  public getOverlayPrimitiveWithIndex(id, primitiveCollection){
    let primitive = null;
    for (let i = 0; i<primitiveCollection.length; i++){
      if(primitiveCollection.get(i).geometryInstances.id == id){
        primitive = primitiveCollection.get(i);
        break;
      }
    }
    return primitive;
  }

  removeOverlay(id){
    let primitive = this.getOverlayPrimitiveWithIndex(id, this.overlayPrimitiveCollection);
    let groundPrimitive = this.getOverlayPrimitiveWithIndex(id, this.overlayGroundPrimitiveCollection);
    if (primitive){
      primitive.destroy();
      this.overlayPrimitiveCollection.remove(primitive);
    }
    if(groundPrimitive){
      groundPrimitive.destroy();
      this.overlayGroundPrimitiveCollection.remove(groundPrimitive);
    }
    this.viewer.scene.requestRender();
  }

  public isOverlayInViewbox (coordinates) {
    let viewRect;
    viewRect = this.viewer.camera.computeViewRectangle(this.viewer.scene.globe.ellipsoid);
    console.log('viewRect', viewRect);
    if(viewRect == undefined)
    {
      var cl2 = new Cesium.Cartesian2(0, 0);
      var leftTop = this.viewer.scene.camera.pickEllipsoid(cl2, this.viewer.scene.globe.ellipsoid);

      var cr2 = new Cesium.Cartesian2(this.viewer.scene.canvas.clientWidth, this.viewer.scene.canvas.clientHeight);
      var rightDown = this.viewer.scene.camera.pickEllipsoid(cr2, this.viewer.scene.globe.ellipsoid);

      leftTop = this.viewer.scene.globe.ellipsoid.cartesianToCartographic(leftTop);
      rightDown = this.viewer.scene.globe.ellipsoid.cartesianToCartographic(rightDown);

      viewRect = new Cesium.Rectangle(Math.min(leftTop.longitude, rightDown.longitude), Math.min(rightDown.latitude, leftTop.latitude), Math.max(leftTop.longitude, rightDown.longitude), Math.max(rightDown.latitude, leftTop.latitude));
    }
    return Cesium.Rectangle.intersection(
      viewRect,
      Cesium.Rectangle.fromDegrees(
        Math.min(coordinates[1], coordinates[3]),
        Math.min(coordinates[0], coordinates[2]),
        Math.max(coordinates[1], coordinates[3]),
        Math.max(coordinates[0], coordinates[2])
      )
    );
  }

  '32.211363041359995,-80.68696392195532,32.211363041359995,-80.69376206228395,32.217268968808156,-80.69376206228395,32.217268968808156,-80.68696392195532,32.211363041359995,-80.68696392195532'
  '32.222612,-80.698811,32.222612,-80.680698,32.209356,-80.680698,32.209356,-80.698811,32.222612,-80.698811'

  public getMapCenter() {
    let viewRect;
    viewRect = this.viewer.camera.computeViewRectangle(this.viewer.scene.globe.ellipsoid);
    if(viewRect == undefined)
    {
      var cl2 = new Cesium.Cartesian2(0, 0);
      var leftTop = this.viewer.scene.camera.pickEllipsoid(cl2, this.viewer.scene.globe.ellipsoid);

      var cr2 = new Cesium.Cartesian2(this.viewer.scene.canvas.width, this.viewer.scene.canvas.height);
      var rightDown = this.viewer.scene.camera.pickEllipsoid(cr2, this.viewer.scene.globe.ellipsoid);

      leftTop = this.viewer.scene.globe.ellipsoid.cartesianToCartographic(leftTop);
      rightDown = this.viewer.scene.globe.ellipsoid.cartesianToCartographic(rightDown);
      viewRect = new Cesium.Rectangle(leftTop.longitude, rightDown.latitude, rightDown.longitude, leftTop.latitude);
    }
    return Cesium.Rectangle.center(viewRect);
  }

  public drawConcreteLayer(item: ConcreteLayer, cb?) {
    let self = this;
    this.drawingTool.drawPolygon(
      item.objectConfig.getPositions(),
      {color: item.bgColor || '#ffffff', opacity: .6},
    ).then((ids) => {
      cb([ids.polygon, ids.border]);
    });
  }

  public hideConcreteLayer(ids) {
    let entity = this.viewer.entities.getById(ids[0]);
    if (entity.polygon.show == undefined || entity.polygon.show.getValue()) {
      entity.polygon.show = false;
      for (let i = 1; i < ids.length; i++) {
        let entity = this.viewer.entities.getById(ids[i]);
        entity.polyline.show = false;
      }
      this.viewer.scene.requestRender();
    }
  }

  public showConcreteLayer(ids) {
    let entity = this.viewer.entities.getById(ids[0]);
    if (entity.polygon.show == undefined || !entity.polygon.show.getValue()) {
      entity.polygon.show = true;
      for (let i = 1; i < ids.length; i++) {
        let entity = this.viewer.entities.getById(ids[i]);
        entity.polyline.show = true;
      }
      this.viewer.scene.requestRender();
    }
  }

  /**
   *
   toggle scene mode function

   3D mode disabled now
   */
  async toggleThreeDMode(){
    if (!this.isThreeDModeEnabled.getValue()){
      return;
    }


     this.viewer.scene.mode = (this.isThreeDModeEnabled.getValue()) ? 2 : 3;

    this.viewer.scene.sceneMode = (this.isThreeDModeEnabled.getValue()) ? Cesium.SceneMode.SCENE2D : Cesium.SceneMode.SCENE3D;
    this.isThreeDModeEnabled.next(!this.isThreeDModeEnabled.getValue());

    if(this.isThreeDModeEnabled.getValue() === true){
      this.viewer.terrainProvider = (this.isMacOrIOSEnabled) ?
        await Cesium.CesiumTerrainProvider.fromIonAssetId(1, {
          requestVertexNormals : (location.search.indexOf('vertex=0') < 0), requestWaterMask: false, requestMetadata: false
        })
        :
        new Cesium.CesiumTerrainProvider({
        url: Cesium.IonResource.fromAssetId(1),
        requestVertexNormals : (location.search.indexOf('vertex=0') < 0), requestWaterMask: false, requestMetadata: false
      });
      this.drawingTool.editablePointsClampToGround();
      this.hintEntity.label.heightReference = Cesium.HeightReference.RELATIVE_TO_GROUND;
    } else {
      // this.viewer.terrainProvider = new Cesium.CesiumTerrainProvider({
      //   url: Cesium.IonResource.fromAssetId(1),
      //   requestVertexNormals : (location.search.indexOf('vertex=0') < 0), requestWaterMask: false, requestMetadata: false
      // });
      this.drawingTool.editablePointsUnclampToGround();
      this.hintEntity.label.heightReference = Cesium.HeightReference.NONE;
    }
    // if(this.isThreeDModeEnabled.getValue() === true){
    //  this.viewer.terrainProvider = new Cesium.CesiumTerrainProvider({
    //    url: Cesium.IonResource.fromAssetId(1),
    //    requestVertexNormals : false, requestWaterMask: false, requestMetadata: true //false
    //  })
    // }
    // else{
    //   this.viewer.terrainProvider = new Cesium.CesiumTerrainProvider({
    //     url: Cesium.IonResource.fromAssetId(1),
    //     requestVertexNormals : false, requestWaterMask: false, requestMetadata: false //false
    //   })
    // }
    // this.zoomLevelHeights = this.getZoomLevelHeights(1);
  }

  showVerticesLabelsForPolyline(entityId) {
    let self = this;
    this.hideVerticesLabelsForPolyline(entityId);
    const entity = this.viewer.entities.getById(entityId);
    if (entity) {
      const line = entity.polyline ? entity.polyline : entity.corridor;
      let coordinates = line.positions.getValue();
      for (let i = 0; i < coordinates.length; i++) {
        const num = i+1;
        this.vertexHints.push(this.viewer.entities.add({
          position: new Cesium.CallbackProperty(function (i) {
            return function () {
              return line.positions.getValue()[i];
            }
          }(i), false),
          label: {
            show: true,
            font: '14px sans-serif',
            showBackground: true,
            horizontalOrigin: Cesium.HorizontalOrigin.LEFT,
            eyeOffset :  new Cesium.Cartesian3(0, 0, -10000),
            pixelOffset: new Cesium.Cartesian2(10, 0),
            text: (num < 10 ? ('00' + num) : (num < 100 ? ('0' + num) : num)),
          },
        }))
      }
      this.viewer.scene.requestRender();
    }
  }
  hideVerticesLabelsForPolyline(entityId) {
    for (let i = 0; i < this.vertexHints.length; i++) {
      this.drawingTool.removeObject(this.vertexHints[i].id);
    }
    this.vertexHints.length = 0;
  }


  highlightPolyline(entityId, flag, showNumbers = false) {
    const entity = this.viewer.entities.getById(entityId);
    if (entity) {
      if (flag) {
        if (entity.beforeHighlightSize) {
          return;
        }
        const entityPart = (entity.polyline) ? entity.polyline : entity.corridor;
        const polyLineColor = (typeof entityPart.material.color.getValue === 'function')
        ? entityPart.material.color.getValue()
        : entityPart.material.color;
        if (!entity.beforeHighlightConfig) {
          entity.beforeHighlightConfig = polyLineColor;
        }
        if (!entity.beforeHighlightSize) {
          entity.beforeHighlightSize = (entity.polyline) ? entity.polyline.width : entity.corridor.width;
        }
        const newColor = Cesium.Color.fromAlpha(Cesium.Color.fromCssColorString('#EB6432'), 1);
        if (typeof entityPart.material.color.setValue === 'function') {
          entityPart.material.color.setValue(newColor);
        } else {
          entityPart.material.color = newColor;
        }
          entityPart.width += (entityPart.polyline) ? 1 : 0.25;
        if (showNumbers) {
          this.showVerticesLabelsForPolyline(entityId);
        }
      } else {
        if (entity.beforeHighlightConfig && entity.beforeHighlightSize) {
          if (entity.polyline) {
            if (typeof entity.polyline.material.color.setValue === 'function') {
              entity.polyline.material.color.setValue(entity.beforeHighlightConfig);
            } else if (entity.polyline.material.color) {
              entity.polyline.material.color = entity.beforeHighlightConfig;
            }
            entity.polyline.width = entity.beforeHighlightSize;
          }

          if (entity.corridor) {
            entity.corridor.material.color.setValue(entity.beforeHighlightConfig);
            entity.corridor.width = entity.beforeHighlightSize;
          }

          delete entity.beforeHighlightSize;
          delete entity.beforeHighlightConfig;
        }
        this.hideVerticesLabelsForPolyline(entityId);
      }
        this.viewer.scene.requestRender();
    }
  }

  public async startDragPolyline(entityId, path, tool?) {
    const self = this;
    const getEntityColor = (entityObject) => {
      let newColor = null;
      if (entityObject.polyline.material.color.getValue) {
        newColor = entityObject.polyline.material.color.getValue();
      } else {
        newColor = entityObject.polyline.material.color;
      }
      newColor.alpha = 1;
      return newColor;
    };

    this.draggingObject = entityId;
    const entity = this.viewer.entities.getById(entityId);

    if (entity) {
      if (entity.previousConfig && entity.previousConfig.color.alpha <= 0.1) {
        const newColor = getEntityColor(entity);
        if (entity.polyline) {
          if (entity.polyline.material.color.setValue){
            entity.polyline.material.color.setValue(newColor);
          }
          else{
            entity.polyline.material.color = newColor;
            entity.polyline.material._color = newColor;
          }
        }

        if (entity.corridor){
          if (entity.corridor.material.color.setValue){
            entity.corridor.material.color.setValue(newColor);
          }
          else{
            entity.polyline.corridor.color = newColor;
            entity.polyline.corridor._color = newColor;
          }
        }
      }
      let callbackProp = null;
      // note: [SHR]: if here will be problem with rendering polyline under overlay - need to replace polyline with corridor
      callbackProp = self.cesiumConverter.convertArrFromDegreesToCartesian(path).map((pos) => {
        const cartographicPos = Cesium.Cartographic.fromCartesian(pos);
        if (cartographicPos.height < 10) {
          cartographicPos.height += 10;
        }
        return Cesium.Cartographic.toCartesian(cartographicPos);
      });


      if (entity.polyline) {
        entity.polyline.positions = callbackProp;
        if (tool && tool.has_smoothing){
          this.smoothPolyline(entity.id);
        }
      }


      if (entity.corridor) {
        entity.corridor.positions = callbackProp;
      }
      // here 123321
      const type = this.drawingTool.getEntityType(entity);
      this.draggingObjectPos = this.drawingTool.getObjectPosition(entity, type);
    }
    this.changeCameraMove(false);
    this.viewer._container.style.cursor = 'grabbing';
    this.viewer.scene.requestRender();
  }



  public updateScene(){
    this.viewer.scene.requestRender();
  }

  startDragPolygon(entityId, borderId, prevBorderId?) {
    if (prevBorderId){
      this.drawingTool.setVisibility(prevBorderId, false);
    }
    if (borderId) {
      this.drawingTool.setVisibility(borderId, false);
    }
    this.startDragObject(entityId);
  }

  public startDragObject(objectId, isMultiSelect?) {
    this.draggingObject = objectId;

    const object = this.drawingTool.getObjectById(objectId);
    const type = this.drawingTool.getObjectType(object);

    this.draggingObjectPos = this.drawingTool.getObjectPosition(object, type);
    this.changeCameraMove(false);

    this.viewer._container.style.cursor = isMultiSelect ? "move" : "grabbing";

    this.overlayLines.forEach((overlay) => {
      overlay.customParams.beforeMoveDisplay = overlay.style.display;
      overlay.style.display = 'none';
    });

    this.overlays.forEach((overlay) => {
      if (!this.modelOverlays.has(overlay.id)){
        overlay.customParams.beforeMoveDisplay = overlay.style.display;
        overlay.style.display = 'none';
      }
    });

    this.viewer.scene.requestRender();
  }

  public startDragEntity(entityId, isMultiSelect?){
    this.startDragObject(entityId, isMultiSelect)
  }

  public startDragMarker(entityId){
    this.draggingObject = entityId;
    let entity = this.viewer.entities.getById(entityId);
    let type = this.drawingTool.getEntityType(entity);
    this.draggingObjectPos = this.drawingTool.getObjectPosition(entity, type);
    this.changeCameraMove(false);
    this.drawingTool.setCursorStyle("grabbing");
    this.viewer.scene.requestRender();
  }

  public getObjectPosition(objectId) {
    const object = this.drawingTool.getObjectById(objectId);
    const type = this.drawingTool.getObjectType(object);
    this.drawingTool.setPositionsFromCallback(object);
    return this.drawingTool.getObjectPosition(object, type);
  }

  stopEditing() {
    if (this.isEditing) {
      this.drawingTool.stopEditing();
      this.isEditing = false;
      this.viewer._container.style.cursor = 'auto';
      this.editingCancelled.next(true);
    }
  }
  stopDragEntity() {
    let pos = null;

    if (this.draggingObjectPos){
      let cesiumPos = (this.draggingObjectPos.getValue) ? this.draggingObjectPos.getValue() : this.draggingObjectPos;
      cesiumPos = (cesiumPos.hasOwnProperty('positions')) ? cesiumPos.positions : cesiumPos;

      if (Array.isArray(cesiumPos)){
        pos = cesiumPos.map((_pos)=>{
          let cartographicPos = Cesium.Cartographic.fromCartesian(_pos);
          if (cartographicPos.height < 10){
            cartographicPos.height+=10;
          }
          return {lat: Cesium.Math.toDegrees(cartographicPos.latitude), lng: Cesium.Math.toDegrees(cartographicPos.longitude), height:cartographicPos.height};
        });
        pos = pos.map((p)=>{
          return new MapPosition(p);
        })
      }
      else{
        pos = new MapPosition(this.cesiumConverter.convertFromCartesianToCartographic(cesiumPos));
      }
      this.draggingObjectPos = null;
    }


    if (pos){
      const object = this.drawingTool.getObjectById(this.draggingObject);

      if (object instanceof Cesium.Entity) {
        if(object.previousConfig && object.previousConfig.color && object.polyline){
          if (object.polyline.material.color.setValue){
            object.polyline.material.color.setValue(object.previousConfig.color);
          }
          else{
            object.polyline.material.color = object.previousConfig.color;
            object.polyline.material._color = object.previousConfig.color;
          }
          delete object.previousConfig;
        }

        if(object.previousConfig && object.previousConfig.color && object.corridor){
          if (object.corridor.material.color.setValue){
            object.corridor.material.color.setValue(object.previousConfig.color);
          }
          else{
            object.corridor.material.color = object.previousConfig.color;
            object.corridor.material._color = object.previousConfig.color;
          }
          delete object.previousConfig;
        }
      }

      if (this.isObjectMoved){
        this.isObjectMoved = null;
        this.drawingTool.setPositionsFromCallback(object);
        this.dragEnd.next({position: pos, id: this.draggingObject});
      }


      if(object.corridor && this.draggingObject){
        this._removeDragHighlight$.next({id: this.draggingObject})
      }
      this.viewer.scene.requestRender();
    }

    this.changeCameraMove(true);
    this.drawingTool.setCursorStyle("auto");
    this.draggingObject = null;
  }

  debugShowFPS(){
    this.viewer.scene.debugShowFramesPerSecond = true;
  }

  debugHideFPS(){
    this.viewer.scene.debugShowFramesPerSecond = false;
  }

  public initializeApp(){
    this.viewer.screenSpaceEventHandler.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_CLICK);
    this.viewer.screenSpaceEventHandler.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_DOUBLE_CLICK);


    this.OSMLoaded.next(false);
    // set 3d mode
    window['viewer'] = this.viewer;

    window['debugShowFPS'] = this.debugShowFPS.bind(this);
    window['debugHideFPS'] = this.debugHideFPS.bind(this);

    this.initializeEventsHandler();
  }


  initConcretes(){
    return this.drawingTool.initConcretes();
  }

  setEntityVisible(entityId, val:boolean){
    this.drawingTool.setEntityVisible(entityId, val);
  }

  setObjectHighlight(objectId, flag) {
    const object = this.drawingTool.getObjectById(objectId);
    const type = this.drawingTool.getObjectType(object);

    if (type === 'model') {
      this.drawingTool.setModelHighlight(objectId, flag);
    }
    // else{
    //   this.drawingTool.setObjectHighlight(entityId, flag);
    // }
  }

  setEntityHighlight(entityId, flag){
    let type = this.drawingTool.getEntityType(this.drawingTool.getEntityById(entityId));
    if(type === 'model'){
      this.drawingTool.setModelHighlight(entityId, flag);
    }
    // else{
    //   this.drawingTool.setEntityHighlight(entityId, flag);
    // }
  }

  changeOSMBuildingsVisible(flag){
    if (this.OSMBuildings){
      this.OSMBuildings.show = flag;
    }
    this.viewer.scene.requestRender();
  }

  setCurrentObject(objectId){
    this.currentObject = objectId;
  }

  rotateCamera(direction:string){
    let camera = this.viewer.camera;
    switch (direction){
      case 'left':
        camera.twistLeft(Cesium.Math.toRadians(5));
        break;
      case 'right':
        camera.twistRight(Cesium.Math.toRadians(5));
        break;
      case 'top':
        camera.lookUp(Cesium.Math.toRadians(5));
        break;
      case 'bottom':
        camera.lookDown(Cesium.Math.toRadians(5));
        break;
      default: break;
    }
  }

  private initMouseEvents(){
    let self = this;
    let esPolylineTextDownTimer = null;
    let esPolylineSvgDownTimer = null;
    jQuery(document).on('click', '.es-polyline-text', function(event){
      // use timer to check if this is a dblclick or not
      clearTimeout(esPolylineTextDownTimer);
      esPolylineTextDownTimer = setTimeout( () => {
        let $this = jQuery(this);
        let tmpArr = $this.attr('class').split(' ');
        let id = null;
        for (let i = 0; i < tmpArr.length; i++) {
          let currentClass = tmpArr[i];
          if (currentClass.indexOf('es-polyline-text-') >= 0) {
            id = currentClass.substring(currentClass.indexOf('es-polyline-text-') + 17, currentClass.length);
            self.clickOnObject.next({entityId: id, isCtrl: event.ctrlKey});
          }
        }
      }, 50);
    });

    jQuery(document).on('click', '.es-polyline-svg', function(event){
      // use timer to check if this is a dblclick or not
      clearTimeout(esPolylineSvgDownTimer);
      esPolylineSvgDownTimer = setTimeout( () => {
        let $this = jQuery(this);
        let tmpArr = $this.attr('class').split(' ');
        let id = null;
        console.log('click', esPolylineSvgDownTimer);
        for (let i = 0; i < tmpArr.length; i++) {
          let currentClass = tmpArr[i];
          if (currentClass.indexOf('es-polyline-svg-') >= 0) {
            id = currentClass.substring(currentClass.indexOf('es-polyline-svg-') + 16, currentClass.length);
            self.clickOnObject.next({entityId: id, isCtrl: event.ctrlKey});
          }
        }
      }, 200);
    });

    jQuery(document).on('dblclick', '.es-polyline-text', function(event){
      if (self.draggingObject) { self.stopDragEntity(); } // force drag stop before starting editing
      clearTimeout(esPolylineTextDownTimer); // use timer to check if this is a dblclick or not
      let $this = jQuery(this);
      let tmpArr = $this.attr('class').split(' ');
      let id = null;
      for (let i = 0; i<tmpArr.length; i++){
        let currentClass = tmpArr[i];
        if (currentClass.indexOf('es-polyline-text-') >= 0){
          id = currentClass.substring(currentClass.indexOf('es-polyline-text-')+17, currentClass.length);
          self.editStart.next(id);
        }
      }
    });


    jQuery(document).on('pointerleave', '.es-polyline-text', function(event){
      self.hideHoverObj = true;
      self.hideHoverText();
    });

    jQuery(document).on('pointerdown', '.es-polyline-text', function (event) {
      if (self.draggingObject) { self.stopDragEntity(); } // force drag stop before starting editing
      clearTimeout(esPolylineTextDownTimer); // use timer to check if this is a dblclick or not
      esPolylineTextDownTimer = setTimeout( () => {
        let $this = jQuery(this);
        let tmpArr = $this.attr('class').split(' ');
        let id = null;
        for (let i = 0; i < tmpArr.length; i++) {
          let currentClass = tmpArr[i];
          if (currentClass.indexOf('es-polyline-text-') >= 0) {
            id = currentClass.substring(currentClass.indexOf('es-polyline-text-') + 17, currentClass.length);
            let pos: any = self.getPosition({x: event.clientX, y: event.clientY});
            if (!pos) {
              return;
            }
            const entity = self.viewer.entities.getById(id);
            const entityPart = (entity.polyline) ? entity.polyline : entity.corridor;
            // entity.lastDragPosition = pos;
            if (entityPart.material.color.getValue) {
              entity.previousConfig = {color: entityPart.material.color.getValue()};
            } else {
              entity.previousConfig = {color: Object.assign({}, entityPart.material.color)};
            }
            self.dragStart.next(id);
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        }
      }, 200);
    });


    jQuery(document).on('pointermove', '.es-polyline-text', function(event){
      let $this = jQuery(this);
      let tmpArr = $this.attr('class').split(' ');
      let id = null;
      for (let i = 0; i<tmpArr.length; i++){
        let currentClass = tmpArr[i];
        if (currentClass.indexOf('es-polyline-text-') >= 0){
          id = currentClass.substring(currentClass.indexOf('es-polyline-text-')+17, currentClass.length);
          let pos: any = self.getPosition({x: event.clientX, y: event.clientY});
          if (!pos) {
            return;
          }
          // pos = self.cesiumConverter.convertFromCartesianToCartographic(pos);
          if (pos) {
            self.hideHoverObj = false;
            self.hoverObj$.next({entityId: id, event: event});
            event.preventDefault();
            event.stopImmediatePropagation();
          } else {
            self.hoverObj$.next(null);
            // self.hoverEntity.label.show = false;
          }

        }
      }
    });


    jQuery(document).on('dblclick', '.es-polyline-svg', function(event){
      if (self.draggingObject) { self.stopDragEntity(); } // force drag stop before starting editing
      clearTimeout(esPolylineSvgDownTimer); // use timer to check if this is a dblclick or not
      let $this = jQuery(this);
      let tmpArr = $this.attr('class').split(' ');
      let id = null;
      for (let i = 0; i<tmpArr.length; i++){
        let currentClass = tmpArr[i];
        if (currentClass.indexOf('es-polyline-svg-') >= 0){
          id = currentClass.substring(currentClass.indexOf('es-polyline-svg-')+16, currentClass.length);
          self.editStart.next(id);
        }
      }
    });

    jQuery(document).on('pointerleave', '.es-polyline-svg', function(event){
      self.hideHoverObj = true;
      self.hideHoverText();
    });

    jQuery(document).on('pointerdown', '.es-polyline-svg', function (event) {
      // use timer to check if this is a dblclick or not
      if (self.draggingObject) { self.stopDragEntity(); }
      clearTimeout(esPolylineSvgDownTimer);
      esPolylineSvgDownTimer = setTimeout( () => {
        let $this = jQuery(this);
        let tmpArr = $this.attr('class').split(' ');
        let id = null;
        for (let i = 0; i < tmpArr.length; i++) {
          let currentClass = tmpArr[i];
          if (currentClass.indexOf('es-polyline-svg-') >= 0) {
            id = currentClass.substring(currentClass.indexOf('es-polyline-svg-') + 16, currentClass.length);
            let pos: any = self.getPosition({x: event.clientX, y: event.clientY});
            if (!pos) {
              return;
            }
            let entity = self.viewer.entities.getById(id);
            // entity.lastDragPosition = pos;
            if (entity.polyline.material.color.getValue) {
              entity.previousConfig = {color: entity.polyline.material.color.getValue()};
            } else {
              entity.previousConfig = {color: Object.assign({}, entity.polyline.material.color)};
            }

            self.dragStart.next(id);
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        }
      }, 200);
    });


    jQuery(document).on('pointermove', '.es-polyline-svg', function(event){
      let $this = jQuery(this);
      let tmpArr = $this.attr('class').split(' ');
      let id = null;
      for (let i = 0; i<tmpArr.length; i++){
        let currentClass = tmpArr[i];
        if (currentClass.indexOf('es-polyline-svg-') >= 0){
          id = currentClass.substring(currentClass.indexOf('es-polyline-svg-')+16, currentClass.length);
          let pos: any = self.getPosition({x: event.clientX, y: event.clientY});
          if (!pos) {
            return;
          }
          // pos = self.cesiumConverter.convertFromCartesianToCartographic(pos);
          if (pos) {
            self.hideHoverObj = false;
            self.hoverObj$.next({entityId: id, event: event});
            event.preventDefault();
            event.stopImmediatePropagation();
          } else {
            self.hoverObj$.next(null);
            // self.hoverEntity.label.show = false;
          }

        }
      }
    });
  }

  protected drawingTemporaryCheck(pos, dontDraw?): void {
    pos = this.cesiumConverter.convertFromCartesianToCartographic(pos);
    if(!dontDraw){
      this.onDrawingMouseMoved.next(pos);
    }
    this._drawingMouseMoveWithPath.next({pos, path: this.currentPositions});
  }

  public getPickedObject(position) {
    const objects = this.viewer.scene.drillPick(position);
    for (const object of objects) {
      if (!object.primitive || !object.primitive.isSkipEvents) {
        return object;
      }
    }
  }

  private isPolygonPointsValid(polygonPoints: MapPosition[]):boolean{
    let points = polygonPoints.filter((point, position, self) => {
      if(position === 0){ return true}
      return !self[position-1].equals(self[position]);
    }).
      map(p => p.asSimpleArray()
    );


    return this.drawingTool.isValidPolygonPoints(points);
  }

  leftClickHandler(click, forcedPos?: MapPosition) {
    const self = this;
    if (self.isDrawing) {
      if (isViewMode) {
        return;
      }

      let pos: any = self.getPosition(click.position);
      const posToDraw = pos;
      // console.log('pos', pos);
      if (self.selectedConcreteFigure) {
        const concreteEntity = self.viewer.entities.getById(self.selectedConcreteFigure);
        if (
          !Cesium.Rectangle.contains(
            Cesium.Rectangle.fromCartesianArray(concreteEntity.polygon.hierarchy.getValue().positions),
            Cesium.Cartographic.fromCartesian(pos)
          )) {
          self.removeDrawingEntity();
          self.endDrawing();
          alert(Yiit.t('Wrong figure position. Please, set point inside selected floor layout.'));
          return;
        }
      }

      pos = new MapPosition(self.cesiumConverter.convertFromCartesianToCartographic(pos));
      // self.onDrawingMouseMoved.next(pos);
      // self._drawingMouseMoveWithPath.next({pos: pos, path: self.currentPositions});
        self.currentPositions.push(forcedPos ? new MapPosition({lat: forcedPos.latitude, lng: forcedPos.longitude, z: 1}) : pos);
        const p = self.currentPositions[self.currentPositions.length - 1];
        p.z += 0.5;

        if (self.currentPositions.length === 1) {
          if (self.toolType === 'model') {
            self.viewer._container.style.cursor = 'wait';
            self.endDrawingFigure(p);
          } else if (self.toolType === 'point') {
            self.endDrawingFigure(p);
          } else {
            if (window['isIOS']()) {
              this.drawingTemporaryCheck(posToDraw);
            }
          }
        } else if (self.currentPositions.length === 2) {
          if (self.toolType === 'circle') {
            const radius = self.cesiumConverter.getDistanceBetweenPoints(...self.currentPositions);
            self.endDrawingFigure(self.currentPositions[0], radius);
          } else {
            if (window['isIOS']()) {
              this.drawingTemporaryCheck(posToDraw);
            }
          }
        } else {
          if (self.toolType == 'polygon' && self.currentPositions.length >= 3) {
            if (!self.isPolygonPointsValid(self.currentPositions.slice())) {
              this.globalEventsNotification.ToastNotificationEvent.emit({
                message: Yiit.t('Area is invalid - Please ensure your area doesn’t self intersect.'),
                autoHideDelay: 5000,
                title: 'Area is invalid',
                classes: ['error'],
                position: {top: '120px', left: '50%', transform: 'translateX(-50%)'}
              });
              self.currentPositions.pop();
            }
          }

          if (window['isIOS']()) {
            this.drawingTemporaryCheck(posToDraw);
          }
        }

    }
    else {
      try {
        clearTimeout(doubleClickTimer);
        doubleClickTimer = setTimeout( () => {
          const pickedObject = self.getPickedObject(click.position);
        if (Cesium.defined(pickedObject) && pickedObject.id && (pickedObject.id.id || pickedObject.hasOwnProperty('primitive'))) {
          const objectId = pickedObject.id.id ? pickedObject.id.id : pickedObject.id;
          self.clickOnObject.next({entityId: objectId, isCtrl: false});

          if (pickedObject && pickedObject.hasOwnProperty('primitive')) {
            self._clickOnPrimitive$.next({primitiveId: pickedObject.id, clickPos: click.position});
          }
        }  else {
          if (!this.htmlClicked) {
            self._emptyClick$.next(true);
          } else {
            this.htmlClicked = false;
          }
        }
      }, 50);
      } catch (e) {
        console.error(e);
      }
    }

    const cartographic = Cesium.Cartographic.fromCartesian(self.getPosition(click.position));
    const degrees = {
      lat: Cesium.Math.toDegrees(cartographic.latitude),
      lng: Cesium.Math.toDegrees(cartographic.longitude),
      height: cartographic.height
    };

    self._clickOnMap.next(new MapPosition(degrees));

  }

  initializeEventsHandler(){

    let self = this;
    // this.handler = new Cesium.ScreenSpaceEventHandler(this.viewer.canvas);
    this.handler = new Cesium.ScreenSpaceEventHandler(document.querySelector('#es-cesium-container .cesium-viewer'));

    // make this handler available in the global scope of application
    window['eventsHandler'] = this.handler;

    this.initMouseEvents();

    this.hoverObj$.pipe(throttleTime(50)).subscribe((val:{entityId, event}|null)=>{
      let popup = document.getElementById('object-tooltip');
      if (val){
      if (this.hoverObjId && self.hoverObjId != val.entityId) {
        this.hideHoverText();
      }
      let pos = this.getPosition({x: val.event.clientX, y:val.event.clientY});

      this.hoverOnObject.next({entityId: val.entityId, position: pos});
      this.hoverObjId = val.entityId;

      }
      else{
      popup.style.display = 'none';
      }
    });
    this.handler.setInputAction(
      (click) => { self.isMultiDrop = false; this.leftClickHandler(click); }, Cesium.ScreenSpaceEventType.LEFT_CLICK);
    this.handler.setInputAction(
      this.leftClickHandler.bind(this), Cesium.ScreenSpaceEventType.LEFT_CLICK, Cesium.KeyboardEventModifier.SHIFT);

    this.handler.setInputAction(
      (event) => {
          self.handleHoverPopup.call(self, event); // hover popup (except for SVG lines)

          if (isViewMode) return;

          this.mouseMoveHandler.call(self, event);

          if (!self.isMouseDown || self.isDragging || !Cesium.defined(self.pickedObject)) return;

          const object = self.pickedObject.id.id ? self.pickedObject.id : self.pickedObject;

          const moveEndPosition = event.endPosition;
          const distanceSquared = Cesium.Cartesian2.distanceSquared(self.mouseDownPosition, moveEndPosition);

          if (distanceSquared <= self.DRAG_THRESHOLD) return;

          self.isDragging = true;
          self.dragStart.next(object.id);

            const _dragStartCartesianPos = (object.model)
              ? object.position.getValue()
              : self.getPosition(self.mouseDownPosition);
            self.dragStartPosition = self.cesiumConverter.convertFromCartesianToCartographic(_dragStartCartesianPos);

      }, Cesium.ScreenSpaceEventType.MOUSE_MOVE
    );

    if (isViewMode) {
      return;
    }
    this.handler.setInputAction(
      function (click) {
        if (self.isDrawing){

          var pos:any = self.getPosition(click.position);

          pos = self.cesiumConverter.convertFromCartesianToCartographic(pos);
          self.currentPositions.push(pos);
          var p = self.currentPositions[self.currentPositions.length - 1];
          p.z+= 0.5;
          if (self.currentPositions.length == 1){
            if (self.toolType == 'model'){
              self.endDrawingFigure(p);
            }
            else{
              if (self.toolType == 'point'){
                self.endDrawingFigure(p);
              }
            }
          }
          else if (self.currentPositions.length == 2){
            if (self.toolType == 'circle'){
              let radius = self.cesiumConverter.getDistanceBetweenPoints(...self.currentPositions);
              self.endDrawingFigure(p, radius);
            }
          }
        }
        else{
          try {
            var pickedObject = self.getPickedObject(click.position);
            if (Cesium.defined(pickedObject) && pickedObject.id && pickedObject.id.id) {
              var entityId = pickedObject.id.id;
              self.clickOnObject.next({entityId: entityId, isCtrl: true});
            }
          } catch (e) {
            console.error(e);
          }
        }

      }, Cesium.ScreenSpaceEventType.LEFT_CLICK, Cesium.KeyboardEventModifier.CTRL
    );


      this.handler.setInputAction(
        (click) => {
          self.isChangeCameraMode = true;

          try {
              if (self.isEditing) return;

              self.isMouseDown = true;
              self.mouseDownPosition = click.position;
              self.pickedObject = self.getPickedObject(click.position);

              if (!self.pickedObject) return;

              const object = self.pickedObject.id && self.pickedObject.id.id ? self.pickedObject.id : self.pickedObject;
              const objectId = object.id;

              // ignore cesium dragging for SVG lines since they have custom listener in DOM
              if (jQuery('.es-polyline-svg-' + objectId + ', .es-polyline-text-' + objectId).length > 0) {
                return;
              }
          } catch (e) {
            console.error(e);
          }
        }, Cesium.ScreenSpaceEventType.LEFT_DOWN
      );

    this.handler.setInputAction(
      function (event) {
        if (!self.groupService.itemsLoadedVal) {
          return;
        }
        self.isChangeCameraMode = true;
        self.initRotatingMapValues();
      }, Cesium.ScreenSpaceEventType.LEFT_DOWN, Cesium.KeyboardEventModifier.CTRL
    );

    this.handler.setInputAction(
      function (event) {
        if (!self.groupService.itemsLoadedVal) {
          return;
        }
        self.initRotatingMapValues();
        self.isChangeCameraMode = true;
      }, Cesium.ScreenSpaceEventType.MIDDLE_DOWN
    );


    this.handler.setInputAction(
      function (event) {
        if (self.isRotating){
          self.additionalMapRotationByEvents = Cesium.Math.toDegrees(self.viewer.camera.heading) - self.originalViewerHeadingBeforeMove;
          self.rotateScene(self.additionalMapRotationByEvents);
          self.originalViewerHeadingBeforeMove = Cesium.Math.toDegrees(self.viewer.camera.heading);
        }
      }, Cesium.ScreenSpaceEventType.MOUSE_MOVE, Cesium.KeyboardEventModifier.CTRL
    );

    this.handler.setInputAction(
      function (event) {
         self.stopRotatingMap();
      }, Cesium.ScreenSpaceEventType.LEFT_UP, Cesium.KeyboardEventModifier.CTRL
    );

    this.handler.setInputAction(
      function (event) {
        self.stopRotatingMap();
      }, Cesium.ScreenSpaceEventType.MIDDLE_UP
    );

    this.handler.setInputAction((movement) => {
      // This action handler is for the trackpad pinch to zoom
      let zoomSpeed = 80;

      const zoomIsBetween = (rangeMin: number, rangeMax: number): boolean => {
        return this._zoom.value >= rangeMin && this._zoom.value <= rangeMax;
      }

      if (zoomIsBetween(14, 15)) {
        zoomSpeed = 600;
      } else if (zoomIsBetween(11, 13)) {
        zoomSpeed = 4500;
      } else if (zoomIsBetween(1, 10)) {
        zoomSpeed = this.viewer.scene.camera.defaultZoomAmount;
      }

      if (movement > 0) {
        this.viewer.camera.zoomIn(zoomSpeed);
      }
      else {
        this.viewer.camera.zoomOut(zoomSpeed);
      }

      self.isChangeCameraMode = true;
    }, Cesium.ScreenSpaceEventType.WHEEL, Cesium.KeyboardEventModifier.CTRL
    );

    this.handler.setInputAction(
      function (click) {
        self.isChangeCameraMode = true;
      }, Cesium.ScreenSpaceEventType.RIGHT_DOWN
    );

    this.handler.setInputAction(
      function (click) {
        if (self.isEditing && self.drawingTool.canRemoveEditablePoints()){
          try {
            var pickedObjects = self.viewer.scene.drillPick(click.position);
            for (let i = 0; i < pickedObjects.length; i++) {
              let pickedObject = pickedObjects[i];
              // var pickedObject = self.viewer.scene.pick(click.position);
              if (Cesium.defined(pickedObject) && pickedObject.id && pickedObject.id.id) {
                let entity = self.drawingTool.getEntityById(self.editingEntityId);
                let editablePoints = self.drawingTool.getEditablePoints();
                let found = false;

                const createDivForLinks = ()=>{
                  let div = document.createElement('div');
                  div.style.position = "absolute";
                  div.style.left = click.position.x + 'px';
                  div.style.top = (click.position.y + 70) + 'px';
                  div.style.backgroundColor = "#ccc";
                  div.style.padding = "5px 10px";
                  div.style.borderRadius = "5px";
                  return div;
                }

                const createLinkWithText = (text)=>{
                  let link = document.createElement('a');
                  link.href = '#';
                  link.style.color = '#000';
                  link.style.display = 'block';
                  link.innerText = text;
                  return link;
                }

                editablePoints.forEach((point, index) => {
                  if (point.id == pickedObject.id.id) {
                    found = true;
                    console.log("DOT!!!", point);
                    if (self.removeEditablePointEntity && self.removeEditablePointEntity.parentNode) {
                      document.body.removeChild(self.removeEditablePointEntity);
                    }
                    let div = createDivForLinks();
                    let a = createLinkWithText(Yiit.t('Delete'));
                    a.addEventListener('click', function (e) {
                      e.preventDefault();
                      let pos = [];
                      self.drawingTool.removeEditableFakePoints();
                      self.drawingTool.removeObject(editablePoints[index].id);
                      editablePoints.splice(index, 1);
                      for (let i = 0; i < editablePoints.length; i++){
                        let point = editablePoints[i];
                        pos.push(point.position.getValue());
                      }
                      self.drawingTool.updatedEditableEntityPositions(pos);
                      document.body.removeChild(div);
                      return false;
                    });
                    div.appendChild(a);

                    // "Break" item
                    if (entity && (entity.polyline || entity.corridor) && index > 0 && index < editablePoints.length-1) {
                      let aBL = createLinkWithText(Yiit.t('Break'));
                      aBL.addEventListener('click', function (e) {
                        e.preventDefault();
                        let pos1 = [];
                        let pos2 = [];
                        self.drawingTool.removeEditableFakePoints();

                        // keep editing of the first part
                        for (let i = 0; i <= index; i++) {
                          let point = editablePoints[i];
                          pos1.push(point.position.getValue());
                        }

                        // coordinates for cut off part
                        for (let i = index; i < editablePoints.length; i++) {
                          if (i > index) {
                            self.drawingTool.removeObject(editablePoints[i].id);
                          }
                          let point = editablePoints[i];
                          let cartographicPos = self.cesiumConverter.convertFromCartesianToCartographic(point.position.getValue());
                          pos2.push(new MapPosition({lat: cartographicPos.lat, lng: cartographicPos.lng}));
                        }

                        // calculate shift in the same direction as previous point
                        let p1 = pos1[pos1.length - 1];
                        let p2 = pos1[pos1.length - 2];
                        let dir = [p2.x - p1.x, p2.y - p1.y, p2.z - p1.z];
                        let xPart = dir[0] / (dir[0] + dir[1] + dir[2]);
                        let yPart = dir[1] / (dir[0] + dir[1] + dir[2]);
                        let zPart = dir[2] / (dir[0] + dir[1] + dir[2]);
                        const offset = 2;
                        if (dir[0]) {
                          pos1[pos1.length - 1].x+= xPart * offset * dir[0] / Math.abs(dir[0]);
                        }
                        if (dir[1]) {
                          pos1[pos1.length - 1].y+= yPart * offset * dir[1] / Math.abs(dir[1]);
                        }
                        if (dir[2]) {
                          pos1[pos1.length - 1].z+= zPart * offset * dir[2] / Math.abs(dir[2]);
                        }
                        if (!dir[0] && !dir[1] && !dir[2]) {
                          pos1[pos1.length - 1].x+= offset * dir[0] / Math.abs(dir[0]);
                        }

                        editablePoints.splice(index + 1, editablePoints.length - index - 1);
                        self.drawingTool.updatedEditableEntityPositions(pos1);
                        self.entityCopyRequested.next({id: self.editingObjectId, objectConfigUpdate: {latLngs: pos2}});
                        document.body.removeChild(div);
                        return false;
                      });
                      div.appendChild(aBL);
                    }

                    document.body.appendChild(div);
                    self.removeEditablePointEntity = div;
                  }
                });


                let editableFakePoints = self.drawingTool.getEditableFakePoints();
                editableFakePoints.forEach((point, index) => {
                  if (point.id == pickedObject.id.id) {
                    found = true;
                    console.log("DOT!!!", point, index);
                    if (self.removeEditablePointEntity && self.removeEditablePointEntity.parentNode) {
                      document.body.removeChild(self.removeEditablePointEntity);
                    }
                    // "Break" item
                    if (entity && (entity.polyline || entity.corridor) && index > 0 && index < editablePoints.length-1) {

                      let div = createDivForLinks();

                      let aBL = createLinkWithText(Yiit.t('Break'));
                      aBL.addEventListener('click', function (e) {
                        e.preventDefault();
                        let pos1 = [];
                        let pos2 = [];


                        // keep editing of the first part
                        for (let i = 0; i <= index; i++) {
                          let point = editablePoints[i];
                          pos1.push(point.position.getValue());
                        }
                        pos1.push(editableFakePoints[index].position.getValue());

                        let cartographicPos = self.cesiumConverter.convertFromCartesianToCartographic(editableFakePoints[index].position.getValue());
                        pos2.push(new MapPosition({lat: cartographicPos.lat, lng: cartographicPos.lng}));

                        // coordinates for cut off part
                        for (let i = index+1; i < editablePoints.length; i++) {
                          if (i > index+1) {
                            self.drawingTool.removeObject(editablePoints[i].id);
                          }
                          let point = editablePoints[i];
                          let cartographicPos = self.cesiumConverter.convertFromCartesianToCartographic(point.position.getValue());
                          pos2.push(new MapPosition({lat: cartographicPos.lat, lng: cartographicPos.lng}));
                        }

                        // calculate shift in the same direction as previous point
                        let p1 = pos1[pos1.length - 1];
                        let p2 = pos1[pos1.length - 2];
                        let dir = [p2.x - p1.x, p2.y - p1.y, p2.z - p1.z];
                        let xPart = dir[0] / (dir[0] + dir[1] + dir[2]);
                        let yPart = dir[1] / (dir[0] + dir[1] + dir[2]);
                        let zPart = dir[2] / (dir[0] + dir[1] + dir[2]);
                        const offset = 2;
                        if (dir[0]) {
                          pos1[pos1.length - 1].x+= xPart * offset * dir[0] / Math.abs(dir[0]);
                        }
                        if (dir[1]) {
                          pos1[pos1.length - 1].y+= yPart * offset * dir[1] / Math.abs(dir[1]);
                        }
                        if (dir[2]) {
                          pos1[pos1.length - 1].z+= zPart * offset * dir[2] / Math.abs(dir[2]);
                        }
                        if (!dir[0] && !dir[1] && !dir[2]) {
                          pos1[pos1.length - 1].x+= offset * dir[0] / Math.abs(dir[0]);
                        }

                        if (editablePoints.length > index+2) {
                          editablePoints.splice(index + 2, editablePoints.length - index - 2);
                        }

                        self.drawingTool.removeEditableFakePoints();
                        self.drawingTool.updatedEditableEntityPositions(pos1);
                        self.entityCopyRequested.next({id: self.editingObjectId, objectConfigUpdate: {latLngs: pos2}});
                        document.body.removeChild(div);
                        return false;
                      });
                      div.appendChild(aBL);

                      document.body.appendChild(div);
                      self.removeEditablePointEntity = div;
                    }
                  }
                });
                if (found) {
                  break;
                }
              }
            }

            console.log(click, pickedObjects);
          } catch (e) {
            console.error(e);
          }
        }
      }, Cesium.ScreenSpaceEventType.RIGHT_UP
    );

    this.handler.setInputAction(
      function () {
        self.isChangeCameraMode = true;

        if (self.draggingObject) {
          self.stopDragEntity();
        }

        self.isDragging = false;
        self.isMouseDown = false;
        self.pickedObject = null;
      },
      Cesium.ScreenSpaceEventType.LEFT_UP
    );

    this.handler.setInputAction(
        function (click) {
          if (self.isDrawing) {
            self.endDrawingFigure();
            return;
          }
          if (!self.isEditing){
            try {
              clearTimeout(doubleClickTimer);
              var pickedObject = self.getPickedObject(click.position);
              if (Cesium.defined(pickedObject) && pickedObject.id && pickedObject.id.id) {
                var entityId = pickedObject.id.id;
                self.editStart.next(entityId);
                if (self.drawingTool.getEntityById(entityId) && self.drawingTool.getEntityType(self.drawingTool.getEntityById(entityId)) == 'model') {
                  // self._startRotate$.next(entityId);
                  let popup = document.getElementById('object-tooltip');
                  popup.style.display = 'none';
                }
              }
            } catch (e) {
              console.error(e);
            }
          }

        }, Cesium.ScreenSpaceEventType.LEFT_DOUBLE_CLICK
    );

    var prevCheckTime = 0;
    // <editor-fold desc="MOUSE_MOVE">
    // </editor-fold>

    this._eventsHandlerLoaded.next(true);

    self._emptyClick$.subscribe(() => {
      if (self.removeEditablePointEntity && self.removeEditablePointEntity.parentNode) {
        document.body.removeChild(self.removeEditablePointEntity);
      }
    });
  }

  /* The method processes the events of mouse movement over objects on the map
  and controls the display of a pop-up window with information about the object. */

  private handleHoverPopup(event){
    var hoverTimer = null;
    var prevPos = null;

    this.ngZone.runOutsideAngular(() => {
      // todo: create mouse out event to hide hoverEntity
      if (!prevPos || event.endPosition.x != prevPos.x || event.endPosition.y != prevPos.y) {
        prevPos = event.endPosition.clone();
        try {
          var pickedObject = this.getPickedObject(event.endPosition);

          let popup = document.getElementById('object-tooltip');
          if (Cesium.defined(pickedObject)) {
            let pos: any = this.getPosition(event.endPosition);
            if (!pos) {
              return;
            }
            // pos = this.cesiumConverter.convertFromCartesianToCartographic(pos);
            if (pos) {
              const objectId = pickedObject.id.id ? pickedObject.id.id : pickedObject.id;
              if (this.hoverObjId && this.hoverObjId != objectId) {
                this.hideHoverText();
              }
              this.hoverOnObject.next({entityId: objectId, position: pos});
              this.hoverObjId = objectId;
            } else {
              // this.hoverEntity.label.show = false;

              popup.style.display = 'none';
            }
          }

          else {
            // this.hoverEntity.label.show = false;

            // The timer is used to remove the pop-up if the user removes the mouse from the object too quickly
            if (hoverTimer) {
              hoverTimer.unsubscribe();
              hoverTimer = null;
            }
            hoverTimer = timer(50).subscribe(() => {
              if (this.hideHoverObj) {
                popup.style.display = 'none';
              } else {
                this.hideHoverObj = true;
              }
              hoverTimer.unsubscribe();
              hoverTimer = null;
            });
          }
        } catch (e) {
          console.error(e);
        }
      }
    });
  }

  private mouseMoveHandler(event){
        const element: HTMLElement = (document.elementFromPoint(event.endPosition.x, event.endPosition.y))
          ? document.elementFromPoint(event.endPosition.x, event.endPosition.y).parentElement
          : null;

        if (!element || !element.classList.contains('cesium-widget')) {
          return;
        }
    // if (!Cesium.defined(this.viewer.scene.pickPosition(event.endPosition))){
        //   console.log('not in Cesium');
        // }

        if (this.isRotating){
          this.additionalMapRotationByEvents = Cesium.Math.toDegrees(this.viewer.camera.heading) - this.originalViewerHeadingBeforeMove;
          this.rotateScene(this.additionalMapRotationByEvents);
          this.originalViewerHeadingBeforeMove = Cesium.Math.toDegrees(this.viewer.camera.heading);
          return;
        }

          if (this.isDrawing) {
            const pos: any = this.getPosition(event.endPosition);
            if (this.selectedConcreteFigure) {

              const concreteEntity = this.viewer.entities.getById(this.selectedConcreteFigure);
              if (concreteEntity && !Cesium.Rectangle.contains(
                Cesium.Rectangle.fromCartesianArray(concreteEntity.polygon.hierarchy.getValue().positions),
                Cesium.Cartographic.fromCartesian(pos)
              )) {
                if (!this.viewer._container.esPrevCursor) {
                  this.viewer._container.esPrevCursor = this.viewer._container.style.cursor;
                }
                this.viewer._container.style.cursor = 'not-allowed';
                // console.error('wrong figure position');
                // alert('Wrong figure position');
                // return;
              } else {
                if (this.viewer._container.esPrevCursor) {
                  this.viewer._container.style.cursor = this.viewer._container.esPrevCursor;
                  this.viewer._container.esPrevCursor = null;
                } else {
                  this.viewer._container.style.cursor = 'auto';
                }
              }
            }

            if (!this.currentPositions || this.currentPositions.length === 0) {
              return;
            }
            let dontDraw = null;
            if(window['isIOS']()){
              dontDraw = true;
            }
            this.drawingTemporaryCheck(pos, dontDraw);
            return;
          }

          if (this.draggingObject) {
            if(this.isDraggingObjectCopy){
              this._onOpenAlert$.next('#drag-copy-item-message');
              this.isDraggingObjectCopy = false;
              this.changeCameraMove(true);
              this.drawingTool.setCursorStyle("auto");
              this.draggingObject = null;
              return;
            }
            let pos = this.getPosition(event.endPosition);
            const object = this.drawingTool.getObjectById(this.draggingObject);

            let cartographicPos = this.cesiumConverter.convertFromCartesianToCartographic(pos);

            // todo: fix "dragStartPosition is undefined" when dragging svg line as a first interaction in event after unlock "objects dragging"
            try {
              if (this.dragStartPosition) {
              let offset = new MapPosition({lat: cartographicPos.lat-this.dragStartPosition.lat, lng: cartographicPos.lng-this.dragStartPosition.lng});
              this._onMouseMovedDifference$.next(offset);
              }
            } catch (e) {
              console.error(e);
            }

            this.drawingTool.moveObject(this.draggingObject, pos, object.lastDragPosition || pos).then((newPos) => {
              let cesiumPos = (newPos.getValue) ? newPos.getValue() : newPos;
              cesiumPos = (cesiumPos.hasOwnProperty('positions')) ? cesiumPos.positions : cesiumPos;

              this.draggingObjectPos = cesiumPos;
              this.isObjectMoved = true;
            });
            object.lastDragPosition = pos;
          }

          // let now = Date.now();
          // if (now - prevCheckTime > 10000) {
          //   prevCheckTime = now;
        if (this.isEditing){
          if (this.hoverEntity.label.show){
            this.hoverEntity.label.show = false;
          }
          return;
        }
  }


  public getPositionFromWindowCoordinates(x, y){
    return (this.viewer.scene.mode == 3) ? this.viewer.scene.pickPosition({x: x, y:y}) : this.viewer.camera.pickEllipsoid({x: x, y:y}, this.viewer.scene.globe.ellipsoid);
  }

  public getWindowCoordinatesToGeo(x: number, y: number): { latitude: number, longitude: number } {
    let cartesian;
    if (this.viewer.scene.mode == 3) {
      cartesian = this.viewer.scene.pickPosition({x: x, y:y});
    } else {
      cartesian = this.viewer.camera.pickEllipsoid({x: x, y:y}, this.viewer.scene.globe.ellipsoid);
    }

    if (!cartesian) {
      return { latitude: 0, longitude: 0 };
    }

    const cartographic = Cesium.Cartographic.fromCartesian(cartesian);

    const latitude = Cesium.Math.toDegrees(cartographic.latitude);
    const longitude = Cesium.Math.toDegrees(cartographic.longitude);

    return {
      latitude: latitude,
      longitude: longitude
    };
  }


  public hideHoverText(){
    let popup = document.getElementById('object-tooltip');
    popup.style.display = 'none';
    this.hoverObjId = null;
  }

  public showHoverText(text, pos) {
    let popup = document.getElementById('object-tooltip');
    let screenCoords = this.viewer.scene.cartesianToCanvasCoordinates(pos);
    popup.innerText = text;
    popup.style.top = screenCoords.y + 'px';
    popup.style.left = (screenCoords.x + 50) + 'px';
    popup.style.display = 'block';
  }

  public editPolyline(polyline: Polyline, cb, addPointDuringEditCb, withNumbers = false) {
    const self = this;
    this.isEditing = true;
    this.editingObjectId = polyline.itemId;
    this.editingEntityId = polyline.getViewEntityId();
    this.viewer._container.style.cursor = 'pointer';
    const method = 'editCorridor';
    // const method = (polyline.width && !polyline.widthPx ? 'editCorridor' : 'editPolyline');
    this.hideHoverText();
    const maxOverlayHeight = this.getMaxOverlayHeights();
    let path = polyline.path;
    if (path[0].height <= maxOverlayHeight) {
      path = path.map((position) => {
        position.height = maxOverlayHeight + 0.1;
        return position;
      });
    }
    if (withNumbers) {
      this.showVerticesLabelsForPolyline(polyline.getViewEntityId());
    }
    this.drawingTool[method](polyline.getViewEntityId(), path, polyline.color, (entityId, points) => {
      self.isEditing = false;
      this.editingObjectId = null;
      this.editingEntityId = null;
      this.viewer._container.style.cursor = 'auto';
      points = points.map(pos => new MapPosition(pos));
      this.hideVerticesLabelsForPolyline(entityId);
      if (cb) {
        cb(entityId, points);
      }
    }, addPointDuringEditCb);
  }

  public editCircle(circle:Circle, cb){
    let self = this;
    this.isEditing = true;
    this.viewer._container.style.cursor = "pointer";
    this.hideHoverText();
    this.drawingTool.editCircle( circle.getViewEntityId(), circle.color,(entityId, radius)=>{
      self.isEditing = false;
      this.viewer._container.style.cursor = "auto";
      // points = points.map( pos => new MapPosition(pos));
      if (cb) cb(entityId, radius);
    });
  }

  public editPolygon(polyData: {entityId: string, color: string, borderColor?: string}, cb) {
    const self = this;
    this.isEditing = true;
    this.editingEntityId = polyData.entityId;
    this.viewer._container.style.cursor = 'pointer';
    this.hideHoverText();
    this.drawingTool.editPolygon({entityId: polyData.entityId, color: polyData.color || '#fff'}, (entityId, points) => {
      self.isEditing = false;
      this.editingEntityId = null;
      this.viewer._container.style.cursor = 'auto';
      points = points.map(pos => new MapPosition(pos));
      if (cb) {
        cb(entityId, points);
      }
    });
  }

  public toggleOSMBuildingsVisibility(){
    if (!this.OSMBuildings){
      console.error('OSMBuildings not loaded');
      return;
    }
    this.OSMBuildings.show = !this.OSMBuildings.show;
  }

  public preventDrawingFigure(){
    if(!this.isDrawing){
      return;
    }
    if(this.toolType != 'model'){
      this.removeDrawingEntity();
    }
    this.endDrawing();
  }

  clearDrawingTool(){
    if(this.isDrawing){
      this.removeDrawingEntity();
      this.hintEntity.label.show = false;
      this.toolType = null;
      this.drawingTool.setTool(null);
      this.drawingTool.setCursorStyle("auto");
      this.currentObject = null;
      this.currentTool = null;
      this.isDrawing = false;
      this.currentPositions = [];
      this._isDrawingFigureChanged.next(false);
      this.currentToolSubject.next(null);
    }
  }

  public endDrawingFigure(pos?, radius?, notFigure = false, isStopDrawing = false) {
    // console.log('[TEST] endDrawingFigure', this.isDrawing, pos, radius, notFigure, isStopDrawing);
    if (!this.isDrawing) {
      return;
    }
    // if (!pos){
    //   this.drawingTool.setCursorStyle("auto");
    //   this.currentObject = null;
    //   this.currentTool = null;
    //   this.isDrawing = false;
    //   return;
    // }
    const self = this;
    let _pos = pos;

    if (notFigure) {
      self.endDrawing();
      return;
    }
    if (!_pos) {
      self.currentPositions.splice(self.currentPositions.length - 1, self.currentPositions.length);
      _pos = self.currentPositions;
    }

    if (self.toolType === 'circle') {
      if (self.drawingTool.getPrevEntityId()) {
        self.drawingTool.removeObject(self.drawingTool.getPrevEntityId(), () => {
          self.drawingTool.setPrevEntity(null);
          if (!isStopDrawing) {
            self.drawingTool.drawCircle(_pos, radius).then((entityId) => {
              if (entityId) {
                self.entityAdded.next({tool: self.currentTool, position: _pos, id: entityId, radius: radius});
              }
              self.endDrawing();
            });
            return;
          } else {
            self.endDrawing();
          }
        })
      }
    } else if (self.toolType == 'model') {
      if (!isStopDrawing) {
        self.entityAdded.next({tool: self.currentTool, position: _pos, id: null, radius: radius});
      }
      self.endDrawing();
    } else {
      if (!_pos || (Array.isArray(_pos) && _pos.length === 0)) {
        self.endDrawing();
        if (self.drawingTool.getPrevEntityId()) {
          self.drawingTool.removeObject(self.drawingTool.getPrevEntityId(), () => {
            self.drawingTool.setPrevEntity(null);
          });
        }
        return;
      }
      self.drawItems(_pos, (entityId) => {
        if (!isStopDrawing) {
          if (entityId) {
            self.entityAdded.next({tool: self.currentTool, position: _pos, id: entityId, radius: radius});
            if (self.drawingPolygonCallback) {
              self.drawingPolygonCallback(self.currentPositions.map(p => new MapPosition(p)));
            }
          }
        }
        self.endDrawing();
        self.removeObject(entityId);
        return;
      });
    }
  }

  public removeObject(currentObjectId, cb?){
    this.drawingTool.removeObject(currentObjectId, cb)
  }

  public startDrawing(tool) {
    this.toolType = this.getToolType(tool);
    // if (this.toolType === 'polyline' || this.toolType === 'polygon') {
    //   if (!window['isIOS']()) {
    //     if (this.selectedOverlay) {
    //       this.selectedOverlay.setOpacity(.4);
    //     }
    //     if (this.visibleOverlays.length > 0) {
    //       this.visibleOverlays.forEach((overlay) => {
    //         overlay.setOpacity(.4);
    //       })
    //     }
    //   }
    // }
    this.currentTool = tool;
    this.viewer._container.style.cursor = 'crosshair';
    this.drawingTool.setTool(this.currentTool);
    this.isDrawing = true;
    this.startedDrawingAt = Date.now();
    this.currentToolSubject.next(this.currentTool);
    if (this.toolType === 'model') {
      this._isDrawingFigureChanged.next(true);
    }
  }

  public startDrawingConcrete(cb: (positions: MapPosition[]) => any){
    let self = this;
    this.isDrawingConcrete = true;
    self.startDrawingPolygon((pos)=>{
        self.isDrawingConcrete = false;
        cb(pos);
    })
  }

  public startDrawingPolygon(cb: (positions: MapPosition[]) => any) {
    this.drawingPolygonCallback = cb;
    this.toolType = 'polygon';
    this.viewer._container.style.cursor = "crosshair";
    this.isDrawing = true;
  }


  public removeDrawingEntity(){
    if (this.drawingTool.getPrevEntityId()){
      this.drawingTool.removeObject(this.drawingTool.getPrevEntityId(), () => {
        this.drawingTool.setPrevEntity(null);
      });
    }
  }

  public endDrawing() {
    // console.log('[TEST] endDrawing');
    if (this.isDrawing) {
      let currentActiveOverlay = this.selectedOverlay;
      // if (this.selectedOverlay) {
      //   this.selectedOverlay.setOpacity(1);
      // }
      // if (this.visibleOverlays.length > 0) {
      //   this.visibleOverlays.forEach((overlay) => {
      //     overlay.setOpacity(1);
      //   });
      // }
      this.currentPositions = [];
      this.currentObject = null;
      this.hintEntity.label.show = false;

      if (this.isMultiDrop || this.keepDrawing) {
        this.keepDrawing = false;
        this.startDrawing(this.currentTool);
        this.viewer._container.style.cursor = 'crosshair';
      } else {
        if (this.toolType !== 'model') {
          this.viewer._container.style.cursor = 'auto';
        }
        this.currentObject = null;
        this.toolType = null;
        this.currentTool = null;
        this.drawingTool.setTool(null);
        this.isDrawing = false;
        this._isDrawingFigureChanged.next(false);
        this.currentToolSubject.next(null);
      }
    }
  }

  public drawPoint(tool, position) {
    this.drawingTool.setTool(tool);
    this.drawingTool.drawPoint(position, (point) => {
      this.drawingTool.setTool(null);
    });
  }

  public setEntityGrayscale(entityId, value) {
    this.drawingTool.setEntityGrayscale(entityId, value);
  }

  public updatePolygonMaterial(entityId, polygon:Polygon){
    this.drawingTool.updatePolygonMaterial(
      entityId,
      <any>{
        color: polygon.color,
        opacity: polygon.opacity,
      }
    );
  }

  public drawPolygonBorder(path, options){
    return this.drawingTool.drawPolygonBorder(this.cesiumConverter.convertArrFromDegreesToCartesian(path), options)
  }

  public drawPolygon(tool, polygon: Polygon, cb): void {
    this.drawingTool.setTool(tool);
    this.drawingTool.drawPolygon(
      polygon.path,
      {
        color: polygon.color,
        opacity: polygon.opacity,
        borderWidth: polygon.borderWidth,
        borderColor: polygon.borderColor
      })
      .then((polyData: {polygon: string, border: string}) => {
        if (cb) {
          cb(polyData);
        }
        this.setCurrentObject(polyData.polygon);
        this.drawingTool.setTool(null);
      });
  }

  public changeFillAndBorderColor(mapObject: Polygon | Polyline, updatedConfig: ItemConfig): void {

    const colorFields = ['fillColor', 'lineColor'];
    const finalInputsNames = Object.keys(updatedConfig.getInputs()).filter(inputName => colorFields.includes(inputName));
    const entityId = mapObject.getViewEntityId();
    const entity = this.drawingTool.getEntityById(entityId);

    if (!entity) {
      return;
    }

    for (const inputName of finalInputsNames) {
      const colorValue = updatedConfig.getInputs()[inputName].value;

      switch (updatedConfig.getObjectConfig().getToolType()) {
        case ObjectConfig.TYPE_POLYGON:
          if (inputName === 'fillColor') {
            this.drawingTool.changeMaterialColor(
              entity.polygon.material,
              colorValue,
              updatedConfig.getObjectConfig().getFillOpacity()
            );
          }
          if (inputName === 'lineColor') {
            const border = this.drawingTool.getEntityById((mapObject as Polygon).borderId);
            this.drawingTool.changeMaterialColor(border.polyline.material, colorValue);
          }
          break;
        case ObjectConfig.TYPE_POLYLINE:
          if (inputName === 'lineColor') {
            this.drawingTool.changeMaterialColor(entity.polyline.material, colorValue);
          }
          break;
      }
    }
    this.viewer.scene.requestRender();
  }

  public movePolygon(entityId, path, cb?) {
    this.drawingTool.movePolygon(entityId, path).then(() => {
      this.viewer.scene.requestRender();
      if (cb) { cb(); }
    });
  }

  public drawPolyline(tool, polyline: Polyline, cb) {
    const afterDraw = (entityId => {
      if (cb) {
        cb(entityId);
      }
      this.setCurrentObject(entityId);
      this.drawingTool.setTool(null);
    });

    this.drawingTool.setTool(tool);
    if (polyline.width && !polyline.widthPx || polyline.height) {
      this.drawingTool.drawCorridor(polyline.path, polyline).then(afterDraw);
    } else {
      let options:any = {
        width: (polyline.widthPx) ? polyline.widthPx : polyline.weight,
        color: polyline.color,
        opacity: polyline.opacity,
      };
      if(polyline.importantOpacity != null){
        options.importantOpacity = polyline.opacity;
      }

      this.drawingTool.drawPolyline(
        polyline.path,
        options
      )
        .then(afterDraw);
    }
  }

  public drawBillboardSVGImage(object: {pos: MapPosition, svg:string}, cb?){
    this.drawingTool.drawBillboardSVGImage({pos:object.pos, svg: object.svg}, cb).then((billboardId)=>{
      if (cb) { cb(billboardId); }
    })
  }

  public drawMarker(marker: CadMarker, cb){
    this.drawingTool.drawMarker({position: marker.mapPosition, label: marker.label}, cb).then((billboardId)=>{
      if (cb) { cb(billboardId); }
      this.viewer.scene.requestRender();
    })
  }

  public updateBorderPath(path, entityId, cb?){
    let _path = path.slice(0);
    _path.push(path[0]);
    this.drawingTool.moveBorder(entityId, _path).then(()=>{
      if (cb) cb();
    })
  }

  public drawHighlightBorder(path){
    return this.drawingTool.drawHighlightBorder(path)
  }

  /**
   * @deprecated
   * @param entityId
   * @param path
   * @param cb
   */
  public movePolyline(entityId, path, cb?) {
    this.drawingTool.movePolyline(entityId, path).then(() => {
      this.viewer.scene.requestRender();
      if (cb) { cb(); }
    });
  }

  movePolylineToPath(entityId, path, cb?) {
    const ent = this.drawingTool.getEntityById(entityId);
    if (ent) {
      const entityType = this.drawingTool.getEntityType(ent);
      const method = entityType === 'corridor' ? this.drawingTool.moveCorridor : this.drawingTool.movePolyline;
      method(entityId, path).then(() => {
        this.viewer.scene.requestRender();
        if (cb) {
          cb();
        }
      });
    }
  }

  public redrawPolyline(polyline:Polyline, cb?) {
    if (polyline.width && !polyline.widthPx) {
      this.viewer.scene.requestRender();
      this.drawingTool.moveCorridor(polyline.getViewEntityId(), polyline.path).then(() => {
        let corridorWidth = polyline && polyline.width  ? polyline.width : 2
        if (polyline.tool && polyline.tool.type === 'polyline') {
          //corridorWidth = corridorWidth / 4;
          if (corridorWidth === 0) {
            corridorWidth = .5;
          }
        }
        this.drawingTool.setCorridorWidth(polyline.getViewEntityId(), corridorWidth);
        this.viewer.scene.requestRender();
        if (polyline.tool.has_smoothing){
          this.smoothPolyline(polyline.getViewEntityId());
        }
        if (cb) { cb(); }
      });
    } else {
      this.drawingTool.movePolyline(polyline.getViewEntityId(), polyline.path).then(() => {
        let isArrowAtTheEnd = (polyline.tool.hasOwnProperty('arrow_on_end') && polyline.tool.arrow_on_end);
        this.drawingTool.setPolylineWidth(polyline.getViewEntityId(), (polyline.widthPx) ? polyline.widthPx : (isArrowAtTheEnd) ? polyline.weight*4: polyline.weight || polyline.width);
        this.viewer.scene.requestRender();
        if (polyline.tool.has_smoothing){
          this.smoothPolyline(polyline.getViewEntityId());
        }
        if (cb) { cb(); }
        const entity = this.viewer.entities.getById(polyline.getViewEntityId());
        this.drawingTool.setPositionsFromCallback(entity);
      });
    }

  }

  public drawRectangle(object){
    let currentTool = this.toolProvider.getToolById(object.tool_id);
    this.drawingTool.setTool(currentTool);
    this.drawingTool.drawRectangle(object.position).then((entityId)=>{
      this.setCurrentObject(entityId);
      this.drawingTool.setTool(null);
    });
  }

  public changeBillboardPrimitiveFixedSize(primitiveId, scale, width, height, initial_config?, additionalOptions?){
    this.drawingTool.setBillboardPrimitiveScale(primitiveId, scale, parseFloat(width), parseFloat(height), initial_config, additionalOptions);
  }

  public changeBillboardEntityFixedSize(entityId, scale, width, height, initial_config?, additionalOptions?){
    this.drawingTool.setBillboardEntityScale(entityId, scale, parseFloat(width), parseFloat(height), initial_config, additionalOptions);
  }

  public changeModelFixedSize(entityId, scale, width, height, initial_config?, additionalOptions?){
    this.drawingTool.setThreeDModelScale(entityId, scale, parseFloat(width), parseFloat(height), initial_config, additionalOptions);
  }

  public changeObjectBoxFixedSize(entityId, scale, width, height){
    this.drawingTool.setBoxScale(entityId, scale, parseFloat(width), parseFloat(height));
  }


  public drawCircle(tool, circle, cb){
    if (typeof circle.radius != 'number'){
      return;
    }
    this.drawingTool.setTool(tool);
    this.drawingTool.drawCircle(circle.center, circle.radius, {color: circle.color, opacity: circle.opacity}).then((entityId)=>{
      if (cb) cb(entityId);
      this.drawingTool.setTool(null);
    });
  }

  public moveCircle(entityId, position, cb?){
    this.drawingTool.moveCircle(entityId, position).then(() => {
      this.viewer.scene.requestRender();
      if (cb) { cb(); }
    });
  }

  public changeCircleRadius(entityId, radius, cb?){
    this.drawingTool.changeCircleRadius(entityId, radius).then(() => {
      this.viewer.scene.requestRender();
      if (cb) { cb(); }
    });
  }

  public setModelBoxDimensionHeight(entityId, val){
    this.drawingTool.setModelBoxDimensionHeight(entityId, val);
  }

  public getScaleDenominator(position: MapPosition){
    let cartesian3 = this.cesiumConverter.convertFromDegreesToCartesian(position);
    return this.drawingTool.getScaleDenominator(cartesian3);
  }

  public drawDynamicBillboardEntity(tool, object:DynamicBillboardEntity, cb?) {
    const position = object.position;
    const icon = object.objectConfig.getMapIcon();
    const width = object.finalWidth;
    const height = object.finalHeight;
    const scale = object.finalScale;
    const rotation = object.resultRotation;

    this.drawingTool.setTool(tool);

    this.drawingTool.drawDynamicBillboardEntity(position, icon, width, height, scale, rotation)
    //this.drawingTool.drawDynamicMaterialEntity(position, icon, width, height, scale, rotation)

    .then((entityId) => {
      if (cb) cb(entityId);
      this.drawingTool.setTool(null);
      // this.setEntityVisible(entityId, true);
      this.viewer.scene.requestRender();
    });
  }

  public drawDynamicBillboardPrimitive(tool, object:DynamicBillboardPrimitive, cb?) {
    const position = object.position;
    const icon = object.objectConfig.getMapIcon();
    const width = object.finalWidth;
    const height = object.finalHeight;
    const scale = object.finalScale;
    const rotation = object.resultRotation;

    this.drawingTool.setTool(tool);

    this.drawingTool.drawDynamicBillboardPrimitive(position, icon, width, height, scale, rotation)
    //this.drawingTool.drawDynamicMaterialPrimitive(position, icon, width, height, scale, rotation)

    .then((primitiveId) => {
      if (cb) cb(primitiveId);
      this.drawingTool.setTool(null);
      // this.setEntityVisible(entityId, true);
      this.viewer.scene.requestRender();
    });
  }

  public drawThreeDModel(tool, modelObject:ThreeDModel, cb?) {
    this.drawingTool.setTool(tool);
    this.viewer._container.style.cursor = 'wait';
    console.time("[WAIT] Total");
    this.drawingTool.drawModel({
      position: modelObject.position,
      uri: window['isIOS']() ? null : tool.cesium_asset_id,
      width: modelObject.finalWidth,
      height: modelObject.finalHeight,
      scale: modelObject.finalScale,
      rotation: modelObject.rotation,
      initial_config: modelObject.initialConfig
    }, tool)
      .then((entityId) => {
    // let entityId = null;
        let show = false;
        if (cb) cb({type: 'model', id: entityId});

        if (!entityId){
          show = true;
        }

        if (!this.isThreeDModeEnabled.getValue() && entityId){
          this.setEntityVisible(entityId, false);
          show = true;
        }


        let resource = modelObject.preparedMapIcon;

        this.drawingTool.drawModel({
          position: modelObject.position,
          uri: resource,
          width: modelObject.finalWidth,
          height: modelObject.finalHeight,
          scale: modelObject.finalScale,
          rotation: modelObject.rotation,
          initial_config: Object.assign({isFallback: true}, modelObject.initialConfig), //{scale: {width: 1.5, depth: 1.5}}
        }, tool).then((boxId)=>{
                if (cb) cb({type: 'box', id: boxId});
                this.drawingTool.setTool(null);
                this.viewer.scene.requestRender();
                this.logger.log(`model loaded ${boxId}`);
            console.timeEnd("[WAIT] Total");
                this.viewer._container.style.cursor = 'auto';
                let entity = this.viewer.entities.getById(boxId);
                if (typeof entity.model.uri.getValue() == 'string' && entity.model.uri.getValue().indexOf('.gltf') >= 0){
                  // entity.model.imageBasedLightingFactor = new Cesium.Cartesian2(2.9, -100);
                }

                let entities = [this.viewer.entities.getById(entityId), this.viewer.entities.getById(boxId)];
                if (window['ZOOM_LEVEL_DISPLAY_CONDITION']) {
                  entities.forEach((e) => {
                    if (e) {
                      e.model.distanceDisplayCondition =
                        new Cesium.DistanceDisplayCondition(
                          0,
                          this.getHeightByZoomLevel(window['ZOOM_LEVEL_DISPLAY_CONDITION']) - 50
                        );
                    }
                  });
                }
                this.viewer.scene.requestRender();
              })
          .catch((entityId)=>{
            if(typeof entityId  == 'object'){
              if(entityId.hasOwnProperty('message') && entityId.message.indexOf('id is required') != -1){
                return;
              }
            }
            console.log('drawModel entityId catch', entityId);
          })
      })
  }

  public moveBillboardPrimitive(primitiveId, position, cb?){
    this.drawingTool.moveBillboardPrimitive(primitiveId, position).then(() => {
      this.viewer.scene.requestRender();
      if (cb) { cb(); }
    });
  }

  public moveBillboardEntity(entityId, position, cb?){
    this.drawingTool.moveBillboardEntity(entityId, position).then(() => {
      this.viewer.scene.requestRender();
      if (cb) { cb(); }
    });
  }

  public moveModel(entityId, position, cb?){
    this.drawingTool.moveModel(entityId, position).then(() => {
      this.viewer.scene.requestRender();
      if (cb) { cb(); }
    });
  }

  public moveMarker(entityId, position, cb?){
    this.drawingTool.moveMarker(entityId, position).then(() => {
      this.viewer.scene.requestRender();
      if (cb) { cb(); }
    });
  }

  public moveBox(entityId, position, cb?){
    this.drawingTool.moveBox(entityId, position).then(() => {
      this.viewer.scene.requestRender();
      if (cb) { cb(); }
    });
  }

  public rotateBillboardPrimitive(primitiveId, degrees, cb?){
    if (!primitiveId){
      console.error('Primitive doesn\'t exist ', primitiveId);
      return false;
    }
    this.drawingTool.rotateBillboardPrimitive(primitiveId, degrees).then((model)=>{
      if (cb) cb(degrees)
    })
  }

  public rotateBillboardEntity(entityId, degrees, cb?){
    if (!entityId){
      console.error('Entity doesn\'t exist ', entityId);
      return false;
    }
    this.drawingTool.rotateBillboardEntity(entityId, degrees).then((model)=>{
      if (cb) cb(degrees)
    })
  }

  public rotateModel(entityId, degrees, cb?){
    if (!entityId){
      console.error('Entity doesn\'t exist ', entityId);
      return false;
    }
    this.drawingTool.rotateModel(entityId, degrees).then((model)=>{
      if (cb) cb(degrees)
    })
  }

  public changeBillboardPrimitiveMapIcon(primitiveId, resource) {
    this.drawingTool.changeBillboardPrimitiveMapIcon(primitiveId, resource);
  }

  public changeBillboardEntityMapIcon(entityId, resource) {
    this.drawingTool.changeBillboardEntityMapIcon(entityId, resource);
  }

  public changeModelMapIcon(entityId, resource) {
    this.drawingTool.changeModelMapIcon(entityId, resource);
  }


  centerOnPosition(position:Rectangle, heightOffset = 0, is3DModel = false, duration: number = 3, forceZoom = 0, orientation?){
    //if(this.isThreeDModeEnabled.getValue()){
    let center = Cesium.Rectangle.center(position);
    let height = 0;
    let temp_height = this.viewer.camera.positionCartographic.height;
    let zoomLevel = this.getZoomLevelByHeight(temp_height);
    if(zoomLevel < 19){
      if (is3DModel){
        height = this.getHeightByZoomLevel(19) / 4;
      }
      else{
        height = this.getHeightByZoomLevel(19) + heightOffset;
      }
    }
    else{
      height = temp_height;
    }
    if (forceZoom) {
      height = this.getHeightByZoomLevel(forceZoom);
    }


    if(this.viewer.scene.mode == 3){
      let boundingSphere = Cesium.BoundingSphere.fromRectangle3D(position, this.viewer.ellipsoid, height);
      this.viewer.camera.flyToBoundingSphere(boundingSphere, {duration: duration, orientation: orientation});
    }
    else{
      if (position.south == position.north || position.west == position.east){
        let center = Cesium.Rectangle.center(position);
        center.height = this.getHeightByZoomLevel(19);
        this.viewer.camera.flyTo({destination: Cesium.Cartographic.toCartesian(center), orientation: orientation});
      }
      else{
        this.viewer.camera.flyTo({destination: position, orientation: orientation});
      }
    }
    //}
    //else{
   //   this.viewer.camera.flyTo({destination: position})
   // }
  }

  centerOnConcreteLayout(position:Rectangle, isFirstZoom?){
    let center = Cesium.Rectangle.center(position);
    let height = 0;
    height = this.viewer.scene.globe.getHeight(center);
    if(this.viewer.camera.positionCartographic.height > height && !isFirstZoom){
      height = this.viewer.camera.positionCartographic.height;
    }
    if (isFirstZoom){
      let boundingSphere = Cesium.BoundingSphere.fromRectangle3D(position, this.viewer.ellipsoid, height);
      this.viewer.camera.flyToBoundingSphere(boundingSphere)
    }
    else{
      this.viewer.camera.flyTo({destination: new Cesium.Cartographic.toCartesian(new Cesium.Cartographic(center.longitude, center.latitude, this.viewer.camera.positionCartographic.height))});
    }
  }

  centerOnPrimitive(primitiveId, position: MapPosition, offsetHeight?){
    let _offsetHeight = offsetHeight || 20;

    let primitive = this.drawingTool.getObjectById(primitiveId);

    let height = this.viewer.scene.globe.getHeight(new Cesium.Cartographic(Cesium.Math.toRadians(position.longitude), Cesium.Math.toRadians(position.latitude)));
    height+= _offsetHeight;
    let cameraHeight = this.viewer.camera.positionCartographic.height;
    let zoomLevel = this.getZoomLevelByHeight(cameraHeight);
    let heightOfShow = (zoomLevel < 19) ? height : cameraHeight;

    let _orientation:Orientation = {
      heading: this.viewer.camera.heading,
      pitch: this.viewer.camera.pitch,
      roll: this.viewer.camera.roll,
    };

    if(primitive.position){
      let degreesPos = Cesium.Cartographic.fromCartesian(primitive.position)
      degreesPos.height = heightOfShow;

      this.viewer.camera.flyTo({
        destination : Cesium.Cartographic.toCartesian(degreesPos),
        orientation: _orientation
      });

    }
  }

  centerOnEntity(entityId, position: MapPosition, offsetHeight?){
    let pos = null;
    //todo: add billboard to highlight   ( billboard to highlight');
    let _offsetHeight = offsetHeight || 20;

    let height = this.viewer.scene.globe.getHeight(new Cesium.Cartographic(Cesium.Math.toRadians(position.longitude), Cesium.Math.toRadians(position.latitude)));
      height+= _offsetHeight;

    let heightOfShow = 0;

    let _orientation:Orientation = {
      heading: this.viewer.camera.heading,
      pitch: this.viewer.camera.pitch,
      roll: this.viewer.camera.roll,
    };

    if(this.viewer.entities.getById(entityId).ellipse != undefined){
      let radius = this.viewer.entities.getById(entityId).ellipse.semiMinorAxis.getValue();
      let temp_height = this.viewer.camera.positionCartographic.height;
      let zoomLevel = this.getZoomLevelByHeight(temp_height);
      if(zoomLevel < 19){
        heightOfShow = radius * 10;
      }
      else{
        heightOfShow = temp_height;
      }

      pos = Cesium.Cartesian3.fromDegrees(position.longitude, position.latitude, heightOfShow);

      this.viewer.camera.flyTo({
        destination : pos,
        orientation: _orientation
      });
    }

    else if(this.viewer.entities.getById(entityId).polygon != undefined){
      let Cartesian3Position = this.viewer.entities.getById(entityId).polygon.hierarchy.getValue().positions;
      let PolylineBoundingRectangle = Cesium.Rectangle.fromCartesianArray(Cartesian3Position);

      this.centerOnPosition(PolylineBoundingRectangle, 500);
      return;
    }
    else if(this.viewer.entities.getById(entityId).polyline != undefined){
      let Cartesian3Position = this.viewer.entities.getById(entityId).polyline.positions.getValue();

      let PolylineBoundingRectangle = Cesium.Rectangle.fromCartesianArray(Cartesian3Position);

      this.centerOnPosition(PolylineBoundingRectangle, 500, false, null, null, _orientation);
      return;
    }
    else{
      let temp_height = this.viewer.camera.positionCartographic.height;
      let zoomLevel = this.getZoomLevelByHeight(temp_height);
      if(zoomLevel < 19){
        heightOfShow = height;
      }
      else{
        heightOfShow = temp_height;
      }
      pos = Cesium.Cartesian3.fromDegrees(position.longitude, position.latitude, heightOfShow);
      this.viewer.camera.flyTo({
        destination : pos,
        orientation: _orientation
      });

      return;
    }
  }

  setObjectTransparency(entityId, value){
    this.drawingTool.setTransparency(entityId, value);
  }

  setVisibility(objectId, visibility){
    this.drawingTool.setVisibility(objectId, visibility);
  }

  /* private methods */

  private getToolType(tool){
    let resultToolType = tool.type;
    if(resultToolType == 'fixed-figure'){
      resultToolType = 'model';
    }
    return resultToolType;
  }


  private drawItems(position, cb?){
    let self = this;

    if (self.toolType == 'point'){
      self.drawingTool.drawPoint(position).then((entityId)=>{
        self.setCurrentObject(entityId);
        if (cb) cb(entityId)
      })
    }
    else if (self.toolType == 'polyline'){
      self.drawingTool.drawPolyline(position).then((entityId)=>{
        self.setCurrentObject(entityId);
        if (cb) cb(entityId)
      })
    }
    else if (self.toolType == 'rectangle'){
      self.drawingTool.drawRectangle(position).then((entityId)=>{
        self.setCurrentObject(entityId);
        if (cb) cb(entityId)
      })
    }
    else if (self.toolType == 'polygon'){
      self.drawingTool.drawPolygon(position).then((config)=>{
        self.setCurrentObject(config);
        if (cb) cb(config)
      })
    }
    else if (self.toolType == 'model'){
      // self.drawingTool.drawModel({position:position, uri: self.currentTool.cesium_asset_id, scale:1, object: null}).then((entityId)=>{

        // console.log('drawItems continue work here', entityId);
        // self.setCurrentObject(entityId);
        // if (cb) cb(entityId);
        // this.viewer.scene.requestRender();
      // }).catch(()=>{
      //   alert('Wrong model asset');
      //   if (cb) cb(null);
      // })
    }
    else{
      console.error('undefined toolType - ', self.toolType );
    }
  }



  public showInfoWindow(overlay){
    overlay.style.display = 'block';
  }

  public getAllConcretesObj(){
    return this.drawingTool.concreteLayersObjects();
  }

  public createInfoWindow(overlay, position){
    var self = this;

    this.viewer.container.appendChild(overlay);

    return this.addOverlayPositionEventListener(overlay, position);
  }

  public hideInfoWindow(overlay){
    overlay.style.display = 'none';
  }

  public showTextOverlay(overlay){
    overlay.style.display = 'flex';
    this.displayOverlayInRightPosition(overlay, false);
    this.viewer.scene.requestRender();
  }

  public showBabyOverlay(overlay){
    if (!window['CANVAS_LABELS_ALLOWED']) {
      overlay.style.display = 'block';
    }
  }

  public hideBabyOverlay(overlay){
    this.hideTextOverlay(overlay);
  }

  public showTextOverlayLineLabel(lineLabel, labelOverlay){
    lineLabel.style.display = 'block';
    this.displayOverlayLineInRightPosition(lineLabel, labelOverlay, false);
  }

  public hideOverlayLabel(overlay){
    overlay.style.display = 'none';
  }

  public calculateOffsetByMeters(position:MapPosition, xMeters, yMeters){
    let dot = this.drawingTool.getWindowCoordinatesFromMapPos(position);
    let metersPerPx = this.getMetersPerPx();
    let meters = {x: xMeters/metersPerPx, y: yMeters/metersPerPx};
    return {x: dot.x+meters.x, y: dot.y+meters.y};
  }

  public getOffsetByAnchor(anchor, margin?, positionType?){
    let offset = {x: 0, y: 0};
    switch (anchor) {
      case 'TOP_CENTER':
        offset.x = 0;
        offset.y = -100;
        break;
      case 'TOP_RIGHT':
        offset.x = 100;
        offset.y = -100;
        break;
      case 'BOTTOM_LEFT':
        offset.x = -100;
        offset.y = 100;
        break;
      case 'BOTTOM_CENTER':
        offset.x = 0;
        offset.y = 100;
        break;
      case 'BOTTOM_RIGHT':
        offset.x = 100;
        offset.y = 100;
        break;
      case 'CENTER_LEFT':
        offset.x = -100;
        offset.y = 0;
        break;
      case 'CENTER_RIGHT':
        offset.x = 100;
        offset.y = 0;
        break;
      case 'CENTER':
        offset.x = 0;
        offset.y = 0;
        break;
      case 'CENTER_CENTER':
        offset.x = 0;
        offset.y = 0;
        break;
      case 'TOP_LEFT':
        offset.x = -100;
        offset.y = -100;
        break;
      default:
        offset.x = 0;
        offset.y = 0;
    }
    if (margin){
      offset.x+=margin[0];
      offset.y+=margin[1];
    }

    if (positionType && positionType=='m'){
      let metersInPx = this.getMetersPerPx();
      let currentOffset = (margin) ? margin : [5,5];
      offset.x = currentOffset[0]/metersInPx;
      offset.y = currentOffset[1]/metersInPx;
    }

    return offset;
  }

  public changeTextOverlayAnchor(listener, overlay, position, anchor){
    let offset = this.getOffsetByAnchor(anchor);
    return this.addOverlayPositionEventListener(overlay, position, offset);
    }

    private isFixedPosition(babyObj){
      return babyObj.fixedPositions && Object.keys(babyObj.fixedPositions).length > 0;
    }

    public changeBabyOverlayAnchor(overlay, position, babyObj?:{anchor, positionType, margin, fixedPositions}){
      if (!window['CANVAS_LABELS_ALLOWED']) {
        if ((babyObj.positionType && babyObj.positionType == 'px') || !this.isFixedPosition(babyObj)) {
          let offset = this.getOffsetByAnchor(babyObj.anchor, babyObj.margin);
          return this.addBabyOverlayPositionEventListener(overlay, position, offset);
        } else if (this.isFixedPosition(babyObj)) {
          return this.addBabyOverlayPositionEventListener(overlay, babyObj.fixedPositions);
        } else if (babyObj.anchor) {
          let offset = this.getOffsetByAnchor(babyObj.anchor, babyObj.margin);
          return this.addBabyOverlayPositionEventListener(overlay, position, offset);
        }
        //
        return this.addBabyOverlayPositionEventListener(overlay, position);
      }
    }


  public changeTextOverlayPosition(listener, overlay, position, anchor?, options?) {
    if (anchor) {
      let offset = this.getOffsetByAnchor(anchor, null, options.positionType);
      return this.addOverlayPositionEventListener(overlay, position, offset, options);
    }
    return this.addOverlayPositionEventListener(overlay, position, options);
  }

  public changeBabyOverlayPosition(listener, overlay, position, babyObj?:{anchor, positionType, margin, fixedPositions} ){
    if (!window['CANVAS_LABELS_ALLOWED']) {
      if (babyObj) {
        return this.changeBabyOverlayAnchor(overlay, position, babyObj);
      }

      return this.addOverlayPositionEventListener(overlay, position);
    }
  }


  public changeTextOverlayContent(overlay, content){
    if(content.indexOf('<img') >= 0){
     overlay.innerHTML = content;
    }
    else{
      let div = document.createElement('div');
      div.textContent = content;
      overlay.innerHTML = div.innerHTML;
    }
  }

  createBabyOverlay(overlay, position, babyObj?:{anchor, positionType, margin, fixedPositions}){
    if (!window['CANVAS_LABELS_ALLOWED']) {
      this.viewer.container.appendChild(overlay);
      return this.changeBabyOverlayAnchor(overlay, position, babyObj);
    }
  }

  public startDragLabelOverlay(overlay){
    this.isOverlayMouseDown = true;
    this.viewer._container.style.cursor = "grab";
    this.draggableOverlay = overlay;
    if (this.modelOverlays.get(overlay.id)){
      this.rotateService.hideRotateHandler();
    }
    if (this.overlayLines.get(overlay.id)) {
      this.overlayLines.get(overlay.id).style.display = 'none';
    }
  }

  public createTextOverlay(overlay, position, anchor, options?){
    let self = this;
    this.viewer.container.querySelector('.cesium-viewer').appendChild(overlay);
    overlay.addEventListener('pointerdown', function (e) {
      overlay.customParams.beforeMoveDisplay = overlay.style.display;
      self._isOverlayMouseDownFires.next(overlay);
    });
    let offset = this.getOffsetByAnchor(anchor, options.margins || null, options.positionType);
    return this.addOverlayPositionEventListener(overlay, position, offset, options);
  }

  private getAngleBetweenPoints(p1,p2){
    let dy = p1.y - p2.y;
    let dx = p1.x - p2.x;

    let rads = Math.atan2(dy,dx);
    let degs = Cesium.Math.toDegrees(rads);
    // if (degs < 0){
    //   degs +=90
    // }
    return degs
  }

  public getWindowLineCoordinates(position, anchor){
    let offset = this.getOffsetByAnchor(anchor);
    let dot = this.drawingTool.getWindowCoordinatesFromMapPos(position);
    let secondDot = {x: dot.x + offset.x, y: dot.y + offset.y};
    return {start: dot, end: secondDot};
  }

  convertStylesToJS(css){
    let properties = css.split(';');
    let frameCSSObj = {};
    properties.forEach(function(property) {
      let cssProp = property.split(':');
      if (cssProp[0].trim().length > 0){
        let cssKey = cssProp[0];
        let cssValue = cssProp[1].trim();
        frameCSSObj[cssKey] = cssValue;
      }
    });
    return frameCSSObj
  }

  getRectangleFromPositions(positions:MapPosition[]){
    let cartesian3Arr = positions.map((pos)=>{
      return Cesium.Cartesian3.fromDegrees(pos.longitude, pos.latitude);
    });
    let rectangle = Cesium.Rectangle.fromCartesianArray(cartesian3Arr);
    return rectangle;
  }

  getDegreesFromCartesian(cartesian3: Cartesian3){
    return new MapPosition(this.cesiumConverter.convertFromCartesianToCartographic(cartesian3))
  }


  public getWindowCoordinatesFromMapPos(pos:MapPosition){
   return this.drawingTool.getWindowCoordinatesFromMapPos(pos.asSimpleObject())
  }

  public getPositionAfterDirectionOffset(pos:MapPosition, event:KeyboardEvent){
    let offsetInPx = 10;
    let windowPos:Cartesian2 = this.getWindowCoordinatesFromMapPos(pos);
    switch (event.code) {
      case 'ArrowUp':
        windowPos.y-=offsetInPx;
        break;
      case 'ArrowDown':
        windowPos.y+=offsetInPx;
        break;
      case 'ArrowLeft':
        windowPos.x-=offsetInPx;
        break;
      case 'ArrowRight':
        windowPos.x+=offsetInPx;
        break;
      default:
        break;
    }
     let cartesian3 = this.getPositionFromWindowCoordinates(windowPos.x, windowPos.y);
    return this.getDegreesFromCartesian(cartesian3);

  }

  /**
   * @param dot - center point
   * @param secondDot - resultPosition dot
   */
  public getLineParamsByTwoPoints(dot, secondDot){
    let length = Math.ceil(Math.sqrt(Math.pow(secondDot.x - dot.x, 2)+Math.pow(secondDot.y - dot.y,2)));
    let rotate = this.getAngleBetweenPoints(dot, secondDot);
    return {length, rotate};
  }

  /**
   *
   * @param id
   * @param position - object position
   * @param options
   * @param div
   */
  public setOverlayLineLabelPosition(id, position, options, div?){

    if (!div){
      div = this.overlayLines.get(id);
    }
    let offset = this.getOffsetByAnchor(options.anchor, (options.labelOptions.margins) ? options.labelOptions.margins : null, options.labelOptions.positionType);
    let dot = this.drawingTool.getWindowCoordinatesFromMapPos(position);

    let secondDot:{x:number, y:number};
    if (this.overlays.has(id) && this.overlays.get(id) && this.overlays.get(id).customParams.WCPosition){
      secondDot = this.overlays.get(id).customParams.WCPosition;
    }
    else{
      secondDot = {x: dot.x + offset.x, y: dot.y + offset.y};
    }

    let length = Math.sqrt(Math.pow(secondDot.x - dot.x, 2)+Math.pow(secondDot.y - dot.y,2));
    // div.style.left = dot.x+'px';


    div.style.left = secondDot.x+'px';
    // div.style.top = dot.y+'px';
    div.style.top = secondDot.y+'px';
    if (options.threshold > 0 && length > options.threshold){
      let rotate = this.getAngleBetweenPoints(dot, secondDot);
      div.style.width = length+'px';
      div.style.transform = 'rotate('+rotate+'deg)';
      div.style.transformOrigin = 'transform-origin: 0px 0px 0px;';
      if (length > 0 && !this.overlayLines.has(id)){
        // @ts-ignore
        div.customParams = {
          offset: offset,
          position: position,
          threshold: options.threshold,
          anchor: options.anchor
        };

        if (!this.overlayLines.has(id)){
          let container = document.querySelector('#es-cesium-container > .cesium-viewer');
          container.appendChild(div);
          this.overlayLines.set(id, div);
        }
      }
    }
    else{
      div.style.width = 0;
      div.style.transform = 'rotate('+0+'deg)';
    }
  }

  public createLineInWindowCoordinates(id, position, anchor, threshold, input, labelOptions){
    let div = this.createNewDiv();
    let styles = this.convertStylesToJS(input.lineStyle.css);
    if (styles.hasOwnProperty('stroke')){
      div.style.background = styles['stroke'];
    }
    if (styles.hasOwnProperty('stroke-width')){
      div.style.height = styles['stroke-width'];
    }

    this.setOverlayLineLabelPosition(id, position, {anchor: anchor, threshold: threshold, labelOptions: labelOptions}, div);
    return div;
  };

  private createNewDiv(){
    var div = document.createElement('div');
    div.style.cssText = 'position: absolute; height:2px; background: rgb(255,0,0); border-radius: 50px; transform-origin: 0 0;';
    return div;
  }

  public hideTextOverlay(overlay){
    overlay.style.display = 'none';
    this.viewer.scene.requestRender();
  }

  public removeTextOverlay(overlay:Element){
    overlay.remove();
  }


  public customUpdateRenderer(){
    this.viewer.scene.requestRender();
  }

  public raiseCameraEvent(eventName){
    if (eventName && this.viewer.camera[eventName] && this.viewer.camera[eventName]['raiseEvent']){
      this.viewer.camera[eventName].raiseEvent();
    }
  }

  private overlays:Map<string, any> = new Map();
  private modelOverlays:Map<string, any> = new Map();
  private babyOverlays:Map<string, any> = new Map();
  private overlayLines:Map<string, any> = new Map();

  private recalculateOverlayLabelLinePosition(lineOverlay){
    let labelOverlay = this.overlays.get(lineOverlay.id);
    if (labelOverlay && lineOverlay){
      this.setOverlayLineLabelPosition(lineOverlay.id, labelOverlay.customParams.position, {anchor: labelOverlay.customParams.anchor, threshold: lineOverlay.customParams.threshold, labelOptions: labelOverlay.customParams.options});
    }
  }

  protected initOverlayRenderer() {
    let self = this;
    const hideMovedOverlays = () => {
      self.overlayLines.forEach((overlay) => {
        overlay.customParams.beforeMoveDisplay = overlay.style.display;
        overlay.style.display = 'none';
      });

      self.overlays.forEach((overlay) => {
        if (!overlay.getAttribute('is_model')) {
          overlay.customParams.beforeMoveDisplay = overlay.style.display;
          overlay.style.display = 'none';
        }
      });

      if (!window['CANVAS_LABELS_ALLOWED']) {
        self.babyOverlays.forEach((overlay) => {
          if (!overlay.babyParams.beforeMoveDisplay) {
            overlay.babyParams.beforeMoveDisplay = overlay.style.display;
          }
          overlay.style.display = 'none';
        });
      }

    };
    const isMouseAction = () => {
      if (!self.drawingTool || !self.drawingTool.getMouseState()){
        return;
      }
      const mState = self.drawingTool.getMouseState();
      return mState.isLeftDown
        || mState.isMouseRightDown
        || mState.isMouseMiddleDown
        || mState.isMouseWheel;
    };

    self.viewer.camera.percentageChanged = .001;
    self.viewer.camera.changed.addEventListener((event) => {
      self._cameraEventMove.next(event);
    });
    self.viewer.camera.changed.addEventListener((event) => {
      if (isMouseAction()) {
        hideMovedOverlays();
      }
    });
    self.viewer.camera.moveStart.addEventListener((event) => {
      self._cameraEventMoveStart.next(event);
      // self._cameraEventFires.next({key: 'start', val: event});
      // if (!isMouseAction()) {
      //   return;
      // }
      // hideMovedOverlays();
    });


    self.viewer.camera.moveEnd.addEventListener((event) => {
      // let changed = false;
      //calculate rotate handler position
      if(self.rotatingObjectId){
        this.calculateHandlerPositionAfterMove();
      }

      self.overlays.forEach((overlay) => {
         self._showOverlay.next(overlay);
      });

      self.overlayLines.forEach((lineOverlay) =>{
        this.recalculateOverlayLabelLinePosition(lineOverlay);
        lineOverlay.style.display = lineOverlay.customParams.beforeMoveDisplay;
      });

      if (!window['CANVAS_LABELS_ALLOWED']) {
        self.babyOverlays.forEach((overlay) => {
          if (!overlay.isOverlayDisabled) {
            this.displayBabyOverlayInRightPosition(overlay).then(() => {
              if (overlay.babyParams.beforeMoveDisplay) {
                overlay.style.display = overlay.babyParams.beforeMoveDisplay;
                overlay.babyParams.beforeMoveDisplay = null;
              }
            });
          }
        });
      }

      self._cameraEventMoveEnd.next(event);
    });
  }

  public addBabyOverlayPositionEventListener(overlay, position, offset?){
    if (window['CANVAS_LABELS_ALLOWED']) {
      return;
    }

    // todo: fix null position
    if (!position) { return; }
    if (Array.isArray(position)) { return; }

    let self = this;

    let pos = null;

    pos = (Array.isArray(position)) ? position[0] : position;

    //anchor - result position in cartesian3

    var anchor = Cesium.Cartesian3.fromDegrees(pos.lng, pos.lat);

    var cartographicPosition = Cesium.Cartographic.fromCartesian( anchor );
    cartographicPosition.height = self.viewer.scene.globe.getHeight( cartographicPosition );
    cartographicPosition.height+= (!offset) ? 10 : 0;
    if (self.viewer.scene.mode === 2){
      cartographicPosition.height = 0;
    }
    //__position - result position in cartesian3

    var  __position = Cesium.Cartesian3.fromRadians( cartographicPosition.longitude, cartographicPosition.latitude, cartographicPosition.height);

    overlay.babyParams = {
      offset: offset,
      cartesian: __position,
      position: pos
    };

    this.babyOverlays.set(overlay.id, overlay);

    this.displayBabyOverlayInRightPosition(overlay);
    return;
  }

  private addOverlayPositionEventListener(overlay, position, offset?, options?){

    // todo: fix null position
    if (!position) { return; }
    if (Array.isArray(position)) { return; }

    let self = this;

    let pos = null;

    pos = (Array.isArray(position)) ? position[0] : position;


    //anchor - result position in cartesian3

    var anchor = Cesium.Cartesian3.fromDegrees(pos.lng, pos.lat);

    var cartographicPosition = Cesium.Cartographic.fromCartesian( anchor );
    cartographicPosition.height = self.viewer.scene.globe.getHeight( cartographicPosition );
    cartographicPosition.height+= (!offset) ? 10 : 0;
    if (self.viewer.scene.mode === 2){
      cartographicPosition.height = 0;
    }
    //__position - result position in cartesian3

    var  __position = Cesium.Cartesian3.fromRadians( cartographicPosition.longitude, cartographicPosition.latitude, cartographicPosition.height);


    overlay.customParams = {
      anchor: anchor,
      options: options || {},
      __position: __position,
      offset: offset,
      position: position
    };

    this.overlays.set(overlay.id, overlay);

    if (overlay.getAttribute('is_model')){
      this.modelOverlays.set(overlay.id, overlay);
    }


    this.displayOverlayInRightPosition(overlay);

    return;
  }

  displayOverlayLineInRightPosition(overlay, labeloverlay, changed?, dontCheck?){
    let self = this;
    if (!overlay.customParams || (!dontCheck && overlay.customParams.beforeMoveDisplay === 'none')) {
      return;
    }
    let top = null; let left = null;

    let pos = null;
    pos = (Array.isArray(overlay.customParams.position)) ? overlay.customParams.position[0] : overlay.customParams.position;

    var anchor = Cesium.Cartesian3.fromDegrees(pos.lng, pos.lat);

    var cartographicPosition = Cesium.Cartographic.fromCartesian( anchor );
    cartographicPosition.height = self.viewer.scene.globe.getHeight( cartographicPosition );
    cartographicPosition.height+= (!overlay.customParams.offset) ? 10 : 0;
    var __position = Cesium.Cartesian3.fromRadians( cartographicPosition.longitude, cartographicPosition.latitude, cartographicPosition.height);
    var result = null;
    if(self.viewer.scene == 3){
      result = self.viewer.scene.cartesianToCanvasCoordinates( __position );
    }
    else{
      result = self.drawingTool.getWindowCoordinatesFromMapPos({longitude: Cesium.Math.toDegrees(cartographicPosition.longitude), latitude: Cesium.Math.toDegrees(cartographicPosition.latitude), height: cartographicPosition.height});
    }

    if(Cesium.defined(result)){
      if (overlay.customParams.offset){
        top = result.y + overlay.customParams.offset.y+'px';
        left = result.x + overlay.customParams.offset.x+'px';
      }
      else {
        top = result.y +'px' ;
        left = result.x + 'px';
      }

      if (labeloverlay && labeloverlay.customParams && labeloverlay.customParams.WCPosition){
        top = labeloverlay.customParams.WCPosition.y +'px' ;
        left = labeloverlay.customParams.WCPosition.x + 'px';
      }

      if (overlay.style.top != top || overlay.style.left != left) {
        overlay.style.top = top ;
        overlay.style.left = left;
        changed = true;
      }
      overlay.style.display = overlay.customParams.beforeMoveDisplay;
    }

    //execute requestRenderer
    if (changed) {
      setTimeout(() => {
        self.viewer.scene.requestRender()
      }, 1)
    }

    // self._cameraEventFires.next({key: 'end', val: event});

      //todo: fix brightness here

      // let longitude = Cesium.Math.toDegrees(self.viewer.camera.positionCartographic.longitude);
      // // let timeOffset = direction * longitude *24/360;
      // let timeOffset = longitude *24/360;
      // let timeToSet = new Date();
      // timeToSet.setUTCHours(12 - timeOffset, 0, 0, 0);
      // self.viewer.clock.currentTime = Cesium.JulianDate.fromDate(timeToSet);
      // self.viewer.scene.requestRender();
  }

  getWindowPosByBabyOverlay(overlay){

    let self = this;
    let pos = null;
    pos = overlay.babyParams.position;

    var anchor = Cesium.Cartesian3.fromDegrees(pos.lng || pos.longitude, pos.lat || pos.latitude);
    var cartographicPosition = Cesium.Cartographic.fromCartesian( anchor );

    cartographicPosition.height = self.viewer.scene.globe.getHeight( cartographicPosition );
    cartographicPosition.height+= (!overlay.babyParams.offset) ? 10 : 0;
    var  __position = Cesium.Cartesian3.fromRadians( cartographicPosition.longitude, cartographicPosition.latitude, cartographicPosition.height);
    var result = null;
    let helper  = new Cesium.EventHelper();
    return new Promise((resolve, reject)=>{

    if(self.viewer.scene == 3){
      if (this.viewer.scene.globe.tilesLoaded){
        resolve(self.viewer.scene.cartesianToCanvasCoordinates( __position ))
      }
      else{
        helper.add(self.viewer.scene.globe.tileLoadProgressEvent, (event)=>{
          if (event == 0){
            resolve(self.viewer.scene.cartesianToCanvasCoordinates( __position ))
          }
        });
      }
    }
    else{
      if (this.viewer.scene.globe.tilesLoaded){
        resolve(self.drawingTool.getWindowCoordinatesFromMapPos({longitude: Cesium.Math.toDegrees(cartographicPosition.longitude), latitude: Cesium.Math.toDegrees(cartographicPosition.latitude), height: cartographicPosition.height}));
      }
      helper.add(self.viewer.scene.globe.tileLoadProgressEvent, (event)=>{
        if (event == 0){
          resolve(self.drawingTool.getWindowCoordinatesFromMapPos({longitude: Cesium.Math.toDegrees(cartographicPosition.longitude), latitude: Cesium.Math.toDegrees(cartographicPosition.latitude), height: cartographicPosition.height}));
        }
      });
    }
    })
  }

  private getOverlayPosition(overlay){
    let pos = null;
    pos = (Array.isArray(overlay.customParams.position)) ? overlay.customParams.position[0] : overlay.customParams.position;

    if (overlay.customParams.options && overlay.customParams.options.fixedPosition){
      pos = overlay.customParams.options.fixedPosition;
    }
    return pos;
  }

  private getWindowPosByOverlay(overlay){
    let self = this;
    let pos = null;
    pos = (Array.isArray(overlay.customParams.position)) ? overlay.customParams.position[0] : overlay.customParams.position;

    if (overlay.customParams.options && overlay.customParams.options.fixedPosition){
      pos = overlay.customParams.options.fixedPosition;
    }

    var anchor = Cesium.Cartesian3.fromDegrees(pos.lng || pos.longitude, pos.lat || pos.latitude);


    var cartographicPosition = Cesium.Cartographic.fromCartesian( anchor );

    if (self.viewer.scene.mode === 3){
      cartographicPosition.height = self.viewer.scene.globe.getHeight( cartographicPosition );
      cartographicPosition.height+= (!overlay.customParams.offset) ? 10 : 0;
    }

    var  __position = Cesium.Cartesian3.fromRadians( cartographicPosition.longitude, cartographicPosition.latitude, cartographicPosition.height);

    var result = null;
    if(self.viewer.scene == 3){
      return self.viewer.scene.cartesianToCanvasCoordinates( __position );
    }
    else{
      return self.drawingTool.getWindowCoordinatesFromMapPos({longitude: Cesium.Math.toDegrees(cartographicPosition.longitude), latitude: Cesium.Math.toDegrees(cartographicPosition.latitude), height: cartographicPosition.height});
    }
  }

  private getMetersInOnePxByPosition(position: {x:number, y:number}){
    let _pos = position;
    let a = this.getPosition(_pos);
    _pos.x += 1;
    let b = this.getPosition(_pos);
    return Cesium.Cartesian3.distance(a, b);
    // Cesium.Cartesian3.distance(a, b);
  }

  private displayBabyOverlayInRightPosition(overlay){
    if (window['CANVAS_LABELS_ALLOWED']) {
      return new Promise((resolve) => { return resolve(); });
    }

    let self = this;
    return new Promise((resolve) => {
      if (overlay.babyParams.beforeMoveDisplay === 'none') {
        return resolve();
      }
      let top = null; let left = null;

      let result = null;
      this.getWindowPosByBabyOverlay(overlay).then((_result)=>{
        // @ts-ignore
        _result.y+=parseFloat(document.querySelector('.cesium-viewer').offsetTop);
         result = _result;

        if(Cesium.defined(result)) {
        if (overlay.babyParams.offset && overlay.babyParams.offset.hasOwnProperty('y') && overlay.babyParams.offset.hasOwnProperty('x')){
          top = result.y + overlay.babyParams.offset.y+ 'px';
          left = result.x + overlay.babyParams.offset.x + 'px';
        }
        else{
          top = result.y+ 'px';
          left = result.x + 'px';
        }

          if (overlay.style.top != top || overlay.style.left != left) {
            overlay.style.top = top;
            overlay.style.left = left;
          }

          overlay.babyParams.WCPosition = {
            x: Math.ceil(parseFloat(left.replace('px', ''))),
            y: Math.ceil(parseFloat(top.replace('px', '')))
          };
          this._overlayOnChangePosition.next({id: overlay.id, pos: overlay.babyParams.WCPosition});
          if (overlay.babyParams.beforeMoveDisplay){
            overlay.style.display = overlay.babyParams.beforeMoveDisplay;
          }
        }
        resolve();
      });
    });
  }

  private displayOverlayInRightPosition(overlay, changed?, dontCheck?){
    let self = this;

    if (!dontCheck && overlay.customParams.beforeMoveDisplay === 'none') {
      return;
    }
    let top = null; let left = null;

    let result = this.getWindowPosByOverlay(overlay);
    let options = overlay.customParams.options;
    if (result && options && Object.keys(options).length > 0){
      if(options.positionType == 'px' || !overlay.customParams.options.fixedPosition){
        var margin = options.margins || [0, 0];
        result.x = result.x - margin[0];
        result.y = result.y - margin[1];
      }
    }


    if(Cesium.defined(result)){

      if (overlay.customParams.offset){

        if(overlay.customParams.anchor){
           overlay.customParams.offset = this.getOffsetByAnchor(overlay.customParams.anchor, overlay.customParams.options.margins, overlay.customParams.options.positionType);
        }

        if(overlay.customParams.options.fixedPosition){
          overlay.customParams.offset.x = 0;
          overlay.customParams.offset.y = 0;
        }

        top = result.y + overlay.customParams.offset.y+'px';
        left = result.x + overlay.customParams.offset.x+'px';
      }
      else {
        top = result.y +'px' ;
        left = result.x + 'px';
      }

      if (overlay.style.top != top || overlay.style.left != left) {
        overlay.style.top = top ;
        overlay.style.left = left;
        if(changed){
          changed = true;
        }
      }

      overlay.customParams.WCPosition = {x: Math.ceil(parseFloat(left.replace('px', ''))), y: Math.ceil(parseFloat(top.replace('px', '')))};
      this._overlayOnChangePosition.next({id: overlay.id, pos: overlay.customParams.WCPosition});
      overlay.style.display = overlay.customParams.beforeMoveDisplay;


      if (overlay.customParams.options.widthInMeters){
          let mInOnePx = this.getMetersPerPx();
          let width = overlay.customParams.options.widthInMeters;
          let height = overlay.customParams.options.heightInMeters;
          let denominator = this.getScaleDenominator(this.getOverlayPosition(overlay));
          overlay.style.width = Math.ceil((width/mInOnePx)/denominator)+'px';
          // if (height && overlay.querySelector('img')){
          //   overlay.querySelector('img').style.height = ((height/mInOnePx)/denominator)+'px';
          // }
          overlay.style.height = 'auto';
          overlay.style.maxWidth = Math.ceil((width/mInOnePx)/denominator)+'px';
      }
    }
  }

  getCameraPosition():MapPosition {
    if (this.viewer.scene.mode == 3) {
      return new MapPosition(this.cesiumConverter.convertFromCartesianToCartographic(this.viewer.camera.position))
    } else {
      let cartographicRadians = this.viewer.camera.positionCartographic;
      return new MapPosition({
        lng: Cesium.Math.toDegrees(cartographicRadians.longitude),
        lat: Cesium.Math.toDegrees(cartographicRadians.latitude),
        height: cartographicRadians.height
      });
    }
  }

  getCameraOrientation():Orientation {
    return new Orientation(
      this.viewer.camera.heading,
      this.viewer.camera.pitch,
      this.viewer.camera.roll
    );
  }

  getMetersPerPx(cartesian?){
    if (!cartesian){
      cartesian = this.viewer.camera.position;
    }
    let boundingSphere = new Cesium.BoundingSphere(cartesian, 1);
    return this.viewer.camera.getPixelSize(boundingSphere, this.viewer.scene.drawingBufferWidth, this.viewer.scene.drawingBufferHeight);
  }

  getCartesianFromDegrees(position:MapPosition){
    return  this.cesiumConverter.convertFromDegreesToCartesian(position);
  }

  setupCamera(position:MapPosition, orientation?:Orientation, duration?:number) {

    // let p = this.cesiumConverter.convertFromDegreesToCartesian(position);
    // p.z = position.height;
    this._hideOverlaysObject$.next(true);
    let isIsSetOrientation = !!orientation;
    if(!orientation){
      orientation = {
        heading: Cesium.Math.toRadians(0),
        pitch: Cesium.Math.toRadians(-90),
        roll: 0.0,
      };
    }

    const positionCamera = () => {
      this.viewer.camera.flyTo({
        destination : Cesium.Cartesian3.fromDegrees(position.longitude, position.latitude, position.height || this.viewer.camera.positionCartographic.height),
        orientation: orientation,
        duration: duration || .5,
        complete: ()=>{
          if(isIsSetOrientation){
            this._hideOverlaysObject$.next(false);
            this._sceneRotated$.next(Cesium.Math.toDegrees(orientation.heading));
          }
        }
      });
    };

    let cameraPosition = this.viewer.camera.positionCartographic;
    if (Cesium.Math.toDegrees(cameraPosition.longitude).toFixed(5) == position.longitude.toFixed(5) && Cesium.Math.toDegrees(cameraPosition.latitude).toFixed(5) == position.latitude.toFixed(5)) {
      this.viewer.camera.flyTo({
        destination : Cesium.Cartesian3.fromDegrees(position.longitude + .1, position.latitude, position.height || this.viewer.camera.positionCartographic.height),
        orientation: orientation,
        duration: duration || .5,
        complete: ()=>{
          positionCamera();
        }
      });
    } else {
      positionCamera();
    }


  }

  setupCameraHeight(height){
    let cameraPos = this.viewer.camera.positionCartographic;
    cameraPos.height = height;
    this.viewer.camera.setView({destination: Cesium.Cartographic.toCartesian(cameraPos)});
  }

  moveCameraTo(position: MapPosition){
    // let p = this.cesiumConverter.convertFromDegreesToCartesian(position);
    // p.z = position.height;

    this.viewer.camera.flyTo({
      destination : Cesium.Cartesian3.fromDegrees(position.longitude, position.latitude, position.height),
      duration: .5
    });
  }

  moveCameraBy(offset:{x, y}){
    // this.viewer.camera.cancelFlight();
    let cartographicPos = this.viewer.camera.positionCartographic.clone();
    let oldHeight = cartographicPos.height;
    let mapPos:MapPosition = new MapPosition({lat: Cesium.Math.toDegrees(cartographicPos.latitude), lng: Cesium.Math.toDegrees(cartographicPos.longitude), height:cartographicPos.height})
    let WCoords = this.getWindowCoordinatesFromMapPos(mapPos);
    WCoords.x+=offset.x;
    WCoords.y+=offset.y;
    let newCartesian3Position = this.getPosition(WCoords);
    let cartographicNew = Cesium.Cartographic.fromCartesian(newCartesian3Position);
    cartographicNew.height = oldHeight;
    this.viewer.camera.flyTo({
      destination: Cesium.Cartographic.toCartesian(cartographicNew),
      orientation: {
        heading: this.viewer.scene.camera.heading,
      },
      duration: .05,
      easingFunction: Cesium.EasingFunction.LINEAR_NONE,
    });
  }

  createScreenshot(options?):Promise<string> {
    if (!options) { options = {}; }
    let defaultOptions = { type: 'image/png', quality: 1 };
    // options = Object.assign(defaultOptions, options);
    return new Promise((resolve, reject) => {
      this.createScreenshotJPEG().then((dataUrl:any) => {
        this.preload.isPreloading$ = false;
        resolve(dataUrl);
      });
    });
  }

  createScreenshotBlob() {
    return new Promise((resolve, reject) => {
      this.preload.preloadMessage$ = Yiit.t('Generating Screenshot');
      this.preload.isPreloading$ = true;
      timer(700).subscribe(()=>{
        this._createScreenshot().then((canvas: HTMLCanvasElement) => {
          let screen:HTMLElement = document.querySelector('#es-cesium-container');
          screen.classList.add('es-do-screenshot');
          this.processSvgLinesOnScreenshot().then(()=>{
            html2canvas(screen).then(canvas => {
              let base64 = canvas.toDataURL('image/jpeg', 0.7);
              canvas.toBlob((blob) => {
                screen.classList.remove('es-do-screenshot');
                this.canvasSvgLines.forEach((canvasElm:HTMLCanvasElement)=>{
                  canvasElm.remove();
                });
                this.canvasSvgLines = [];
                resolve({blob: blob, base64: base64});
                // this.svgLinesId.forEach((svgId)=>{
                //   this.setPolylineOfSvgLineVisible(svgId, false);
                // });
                this.viewer.camera.changed.raiseEvent();
                this.viewer.scene.preRender.raiseEvent();
                this.preload.isPreloading$ = false;
              });
            });
          });
        });
      });
    });
  }

  createScreenshotJPEG() {
    return new Promise((resolve, reject) => {
      this.preload.preloadMessage$ = Yiit.t('Generating Screenshot');
      this.preload.isPreloading$ = true;
      timer(700).subscribe(()=> {
        this._createScreenshot().then((canvas: HTMLCanvasElement) => {
          let screen: HTMLElement = document.querySelector('#es-cesium-container');
          screen.classList.add('es-do-screenshot');
          this.processSvgLinesOnScreenshot().then(() => {
            html2canvas(screen).then(canvas => {
              let dataUrl = canvas.toDataURL('image/jpeg', 0.7);
              screen.classList.remove('es-do-screenshot');
              this.canvasSvgLines.forEach((canvasElm: HTMLCanvasElement) => {
                canvasElm.remove();
              });
              this.canvasSvgLines = [];
              resolve(dataUrl);
              // this.svgLinesId.forEach((svgId)=>{
              //   this.setPolylineOfSvgLineVisible(svgId, false);
              // });
              this.viewer.camera.changed.raiseEvent();
              this.viewer.scene.preRender.raiseEvent();
            });
          });
        });
      });
    });
  }
  private setPolylineOfSvgLineVisible(svgId, visibility){
    const entity = this.viewer.entities.getById(svgId);
    if(!entity.polyline) {
      return;
    }
    let colorOptions = Object.values(entity.polyline.material.color.getValue() ? entity.polyline.material.color.getValue(): entity.polyline.material.color).splice(0,3);
    if (visibility){
      colorOptions.push(1);
    }
    else{
      colorOptions.push(0);
    }
    entity.polyline.material = new Cesium.Color(...colorOptions);
    this.viewer.scene.requestRender();
  }

  private processSvgLinesOnScreenshot(){
    return new Promise((resolve)=>{
    let svgMapper:any = new Map();
    this.svgLinesId.forEach((svgId)=>{
      let svgNodes = Array.from(document.querySelectorAll('.es-polyline-svg-'+svgId));
      let textNodes = Array.from(document.querySelectorAll('.es-polyline-text-'+svgId));
      let resultNodes = {svg: svgNodes, text: textNodes};
      svgMapper.set(svgId, resultNodes);

    //  hide all svg during screenshot
      svgNodes.concat(textNodes).forEach((element:HTMLElement & {beforeHideDisplay: string})=>{
        element.beforeHideDisplay = element.style.display;
        element.style.display = 'none';
      });
      this.setPolylineOfSvgLineVisible(svgId, true);
      this.viewer.scene.requestRender();
    });

      //  hide all svg during screenshot
      timer(1000).subscribe(()=>{
        resolve(true);
      })
    return;

    console.log('svgLinesId', this.svgLinesId);

    //change simple mapper to mapper with
    this.addIndexesToMapper(svgMapper);


    let allLinesParameters = {};
    this.svgLinesId.forEach((entityId, index)=>{
      let lineObject = svgMapper.get(entityId);
      //get line parameters like rotate transform, width, height
      allLinesParameters[entityId] = this.getLineItemParams(lineObject);

      this.setLineParametersToDefault(lineObject);
      this.processDrawSvgLine(allLinesParameters, entityId).then(()=>{
        if (index == this.svgLinesId.length-1){
         resolve(true)
        }
      });
    });


    if(this.svgLinesId.length == 0){
      resolve(true)
    }
  });
  }

  private processDrawSvgLine(allLinesParameters, entityId){
    return new Promise((resolve) => {
      let counter = 0;
      let continueCounter = 0;
      let isChanged = false;
      let drawPromise = new Promise((resolveDraw)=>{
        for (let type in allLinesParameters[entityId]) {
        if (Object.keys(allLinesParameters[entityId][type]).length === 0){
          continueCounter++;
          if (continueCounter == Object.keys(allLinesParameters[entityId]).length){
            return resolveDraw();
          }
          continue;
        }
        for (let _index in allLinesParameters[entityId][type]){
          let div = document.createElement('div');
          let lineParamItems = allLinesParameters[entityId][type][_index];
          div.style.position = 'relative';
          div.style.width = lineParamItems[0].width;
          div.style.height = lineParamItems[0].height;

          for (let _i in lineParamItems) {
            let lineParam = lineParamItems[_i];
            div.appendChild(lineParam.nodeElement);
          }

          document.body.appendChild(div);

          html2canvas(div, {backgroundColor: null}).then(canvas => {
            if (div) {
              div.remove();
            }

            let transformParameters = lineParamItems[0].transform.matchAll(/\(([^\(\)]+)\)/g);
            let esRotation: any = '';
            var iterator;
            do {
              iterator = transformParameters.next();
              if (iterator.value && iterator.value[1].indexOf('deg') >= 0) {
                esRotation = iterator.value[1];
                break;
              }
            }
            while (!iterator.done);
            esRotation = parseFloat(esRotation.replace('deg', ''));

            //problem here
            canvas.style.width = lineParamItems[0].width;
            canvas.style.height = (type == 'text') ? lineParamItems[0].width : lineParamItems[0].height;
            canvas.style.position = "fixed";
            canvas.style.top = "0";
            canvas.style.left = "0";

            document.body.appendChild(canvas);
            this.drawSvgLines(esRotation, lineParamItems[0], canvas, type);
            canvas.remove();
            counter++;
            let commonLength = Object.keys(allLinesParameters[entityId]['svg']).length + Object.keys(allLinesParameters[entityId]['text']).length;
            isChanged = true;
            if (counter == commonLength) {
              resolve();
              resolveDraw();
            }
          });
        }
      }
      });

      drawPromise.then(()=>{
        if (!isChanged){resolve();}
      });
    })
  }

  /**
   *
   * @param esRotation - rotation in degrees
   * @param lineParamItem - line parameters
   * @param canvas - main div canvas
   * @param type - text or svg, if svg have to add some additional offsets and increasize size
   */
  private drawSvgLines(esRotation, lineParamItem, canvas, type){

    var tmpCanvas = document.createElement('canvas');
    var tmpCtx = tmpCanvas.getContext('2d');
    esRotation = this.getNegativeRotation(esRotation);
    let radiansRotate = esRotation / 180 * Math.PI;
    let offset = {left: 0, top: 0};
    if (esRotation < 0 && esRotation >= -90) {
      let calculateAngleDegrees = Math.abs(esRotation);
      let calculateAngleRadians = calculateAngleDegrees / 180 * Math.PI;
      let additionalOffset = this.getAdditionalOffset(esRotation, lineParamItem);
      tmpCanvas.width = Math.abs(Math.sin(calculateAngleRadians) * parseFloat(lineParamItem.height));
      tmpCanvas.height = Math.abs(Math.cos(calculateAngleRadians) * parseFloat(lineParamItem.height));
      tmpCtx.translate(additionalOffset.x, additionalOffset.y);
    } else if (esRotation < -90 && esRotation >= -180) {
      let calculateAngleDegrees = -180 + Math.abs(esRotation);
      let calculateAngleRadians = calculateAngleDegrees / 180 * Math.PI;
      let additionalOffset = this.getAdditionalOffset(esRotation, lineParamItem);
      tmpCanvas.width = Math.abs(Math.sin(calculateAngleRadians) * parseFloat(lineParamItem.height));
      tmpCanvas.height = Math.abs(Math.cos(calculateAngleRadians) * parseFloat(lineParamItem.height));

      if (type == 'text') {
        tmpCanvas.height += parseFloat(lineParamItem.width);
         additionalOffset.y -= parseFloat(lineParamItem.width) / 2;
      }
      tmpCtx.translate(additionalOffset.x, tmpCanvas.height + additionalOffset.y);
      offset.top = -tmpCanvas.height;

      if (type == 'text') {
        offset.top += parseFloat(lineParamItem.width)/2;
      }

    } else if (esRotation < -180 && esRotation >= -270) {
      let calculateAngleDegrees = -270 + Math.abs(esRotation);
      let calculateAngleRadians = calculateAngleDegrees / 180 * Math.PI;
      let additionalOffset = this.getAdditionalOffset(esRotation, lineParamItem);
      let width = Math.abs(Math.cos(calculateAngleRadians) * parseFloat(lineParamItem.height));
      let height = Math.abs(Math.sin(calculateAngleRadians) * parseFloat(lineParamItem.height));
      tmpCanvas.width = width;
      tmpCanvas.height = height;

      if (type == 'text'){
        tmpCanvas.height += parseFloat(lineParamItem.width);
        additionalOffset.y += parseFloat(lineParamItem.width) / 2;
      }

      tmpCtx.translate(width + additionalOffset.x, height + additionalOffset.y);

      offset.left = -tmpCanvas.width;
      offset.top = -tmpCanvas.height;

      if (type == 'text') {
        offset.top += parseFloat(lineParamItem.width)/2;
      }

    } else {
      let calculateAngleDegrees = -360 + Math.abs(esRotation);
      let calculateAngleRadians = calculateAngleDegrees / 180 * Math.PI;
      let additionalOffset = this.getAdditionalOffset(esRotation, lineParamItem);
      let width = Math.abs(Math.sin(calculateAngleRadians) * parseFloat(lineParamItem.height));
      let height = Math.abs(Math.cos(calculateAngleRadians) * parseFloat(lineParamItem.height));
      tmpCanvas.width = width;
      tmpCanvas.height = height;

      if (type == 'text') {
        tmpCanvas.height += parseFloat(lineParamItem.width);
        additionalOffset.y += parseFloat(lineParamItem.width) / 2;
      }

      tmpCtx.translate(width + additionalOffset.x, additionalOffset.y);

      offset.left = -tmpCanvas.width;

      if (type == 'text') {
        offset.top -= parseFloat(lineParamItem.width)/2;
      }
    }

    tmpCtx.rotate(radiansRotate);
    tmpCtx.drawImage(canvas, 0, 0);
    tmpCanvas.style.cssText = `position: absolute; left: ${parseFloat(lineParamItem.left) + offset.left}px; top: ${parseFloat(lineParamItem.top) + offset.top}px;`;
    tmpCanvas.classList.add('es-polyline-canvas');
    tmpCanvas.setAttribute('es-width', lineParamItem.width);


    document.querySelector('#es-cesium-container .cesium-viewer').append(tmpCanvas);
    this.canvasSvgLines.push(tmpCanvas);
  }

  private getAdditionalOffset(rotationDegrees, itemParams){
    let width = parseFloat(itemParams.width);
    let offset = {x: 0, y: 0};
    let alpha;
    if (rotationDegrees < 0 && rotationDegrees >= -90){
      alpha = Math.abs(rotationDegrees);
      offset.x = -1*(width * Math.cos(alpha/180*Math.PI))/2;
      offset.y = (width * Math.sin(alpha/180*Math.PI))/2;
    }
    else if (rotationDegrees < -90 && rotationDegrees >= -180){
      alpha = 270 + rotationDegrees - 90;
      offset.x = (width * Math.cos(alpha/180*Math.PI))/2;
      offset.y = (width * Math.sin(alpha/180*Math.PI))/2;
    }
    else if(rotationDegrees < - 180 && rotationDegrees >= -270){
      alpha = 360 + rotationDegrees - 90;
      offset.x = (width * Math.sin(alpha/180*Math.PI))/2;
      offset.y = -1*(width * Math.cos(alpha/180*Math.PI))/2;
    }
    else{
      alpha = 360 + rotationDegrees;
      offset.x = -1*(width * Math.cos(alpha/180*Math.PI))/2;
      offset.y = -1*(width * Math.sin(alpha/180*Math.PI))/2;
    }
    return offset;
  }


  private getNegativeRotation(esRotation){
    if(esRotation > 0){
      esRotation = -360+esRotation;
    }
    return esRotation;
  }

  // private getLineItemParams(lineObject){
  //   //config for lineObject
  //   let mainIndexLineConfig = {};
  //   for (let i in lineObject){
  //     if (!lineObject.hasOwnProperty(i)){
  //       continue;
  //     }
  //     let lineIndexItems = lineObject[i];
  //     //config for item in lineObject
  //     let lineElementsConfig = {};
  //     lineIndexItems.forEach((nodeElement, index)=>{
  //       lineElementsConfig[index] = {
  //         transform: nodeElement.style.transform,
  //         top: nodeElement.style.top,
  //         left: nodeElement.style.left,
  //         width: nodeElement.style.width,
  //         height: nodeElement.style.height,
  //         nodeElement: nodeElement
  //       }
  //     });
  //     mainIndexLineConfig[i] = lineElementsConfig;
  //   }
  //   return mainIndexLineConfig;
  //
  // }


  private getLineItemParams(lineObject){
    let configByType = {svg: {}, text: {}};
    //config for lineObject
    for (let i in lineObject) {
      if (!lineObject.hasOwnProperty(i)) {
        continue;
      }
      let mainIndexLineConfig = {};
      for (let k in lineObject[i]) {
        let lineIndexItems = lineObject[i][k];
        //config for item in lineObject
        let lineElementsConfig = {};
        lineIndexItems.forEach((nodeElement, index) => {
          lineElementsConfig[index] = {
            transform: nodeElement.style.transform,
            top: nodeElement.style.top,
            left: nodeElement.style.left,
            width: nodeElement.style.width,
            height: nodeElement.style.height,
            nodeElement: nodeElement
          }
        });
        mainIndexLineConfig[k] = lineElementsConfig;
      }
      configByType[i] = mainIndexLineConfig;
    }
    return configByType;
  }

  private setLineParametersToDefault(lineObject){
    for (let i in lineObject){
      for(let k in lineObject[i]){
        if (!lineObject[i].hasOwnProperty(k)){
          continue;
        }
        let lineIndexItems = lineObject[i][k];
        lineIndexItems.forEach((nodeElement, index)=>{
          nodeElement.style.transform = 'none';
          nodeElement.style.left = '0';
          nodeElement.style.top = '0';
        });
      }
    }
  }

  private addIndexesToMapper(svgMapper){
    svgMapper.forEach((value, key, mapper)=>{
      let newMapValue = {svg: {}, text: {}};
      for (let i in value){
        //svg or text
        if (!value.hasOwnProperty(i)){
          continue;
        }
        let _value = value[i];
        _value.forEach((nodeElm)=>{
          let index = nodeElm.dataset.esPolyIndex;
          if (!newMapValue[i].hasOwnProperty(index)){
            newMapValue[i][index] = [];
          }
          newMapValue[i][index].push(nodeElm);
        });
      }
      mapper.set(key, newMapValue);
    });
  }

  protected _createScreenshot() {
    return new Promise((resolve, reject) => {
      if (this.viewer.scene.globe.tilesLoaded) {
        resolve(this.viewer.scene.canvas);
        return;
      }
      let helper  = new Cesium.EventHelper();
      helper.add(this.viewer.scene.globe.tileLoadProgressEvent, (event)=>{
        if (event == 0){
          resolve(this.viewer.scene.canvas);
        }
      });
    });
  }


  private getZoomLevelHeights(precision) {
    precision = precision || 10;
    var step = 500.0;

    var result = [];
    var currentZoomLevel = 0;

    for (var height = 100000000.0; height > step; height = height - step) {
      var level = this.detectZoomLevel(height);
      if (level === null) {
        break;
      }

      if (level !== currentZoomLevel) {
        var minHeight = height;
        var maxHeight = height + step;
        while (maxHeight - minHeight > precision) {
          height = minHeight + (maxHeight - minHeight) / 2;
          if (this.detectZoomLevel(height) === level) {
            minHeight = height;
          }
          else {
            maxHeight = height;
          }
        }

        result.push({
          level: level,
          height: Math.round(height)
        });

        currentZoomLevel = level;

        if (result.length >= 2) {
          step = (result[result.length - 2].height - height) / 1000.0;
        }
      }
    }


    return result;
  }

  private detectZoomLevel(distance) {
    var scene = this.viewer.scene;
    var tileProvider = scene.globe._surface.tileProvider;
    var quadtree = tileProvider._quadtree;
    var drawingBufferHeight = this.viewer.canvas.height;
    var sseDenominator = this.viewer.camera.frustum.sseDenominator;

    for (var level = 0; level <= 22; level++) {
      var maxGeometricError = tileProvider.getLevelMaximumGeometricError(level);
      var error = (maxGeometricError * drawingBufferHeight) / (distance * sseDenominator);
      if (error < quadtree.maximumScreenSpaceError) {
        return level + 1;
      }
    }

    return null;
  }

  public enableImageryProvider(key) {
    this.enabledImageryProviders.push(key);
    let tos = this.getImageryProvidersTO();
    this.imageryProvidersProvider.next(tos);
    this.currentImageryProvider.next(key);
  }
  public disableImageryProvider(key) {
    for (let i = 0; i < this.enabledImageryProviders.length; i++) {
      if (this.enabledImageryProviders[i] == key) {
        this.enabledImageryProviders.splice(i, 1);
        break;
      }
    }
    this.imageryProvidersProvider.next(this.getImageryProvidersTO());
  }

  public highlightForConcreteDrawing3DModel(entityId) {
    let entity = this.viewer.entities.getById(entityId);
    if (entity){
      entity.oldModelColor = entity.model.color;
      entity.model.colorBlendMode = Cesium.ColorBlendMode.REPLACE;
      entity.model.color = Cesium.Color.fromAlpha(Cesium.Color.WHITE, 0.2);
      entity.model.silhouetteColor = Cesium.Color.fromAlpha(Cesium.Color.WHITE, 0.0);
      entity.model.silhouetteSize = 3.0;
    }
  }

  public highlightForConcreteDrawingBox(entityId) {
    let entity = this.viewer.entities.getById(entityId);
    if (entity){
      // entity.box.fill = false;
      // entity.box.outline = true;
      // entity.box.outlineColor = Cesium.Color.YELLOW;
    }
  }

  public removeHighlightForConcreteDrawing3DModel(entityId) {
    let entity = this.viewer.entities.getById(entityId);
    if (entity){
      entity.model.colorBlendMode = Cesium.ColorBlendMode.HIGHLIGHT;
      entity.model.color = Cesium.Color.fromAlpha(Cesium.Color.WHITE, 1.0);
      entity.model.silhouetteColor = Cesium.Color.RED;
      entity.model.silhouetteSize = 0;
    }
  }

  public removeHighlightForConcreteDrawingBox(entityId) {
    let entity = this.viewer.entities.getById(entityId);
    // if (entity) {
    //   entity.box.fill = true;
    //   entity.box.outline = false;
    // }
  }

  public setOverlayGrayscale(imageURL, id){
    this.drawingTool.drawOverlayBW(imageURL, id);
  }
  public setOverlayColored(imageURL, id){
    this.drawingTool.drawOverlayColored(imageURL, id);
  }

  private setZoomLevel(value) {
    if (value && !isNaN(value) && this.zoomLevelHeights[value - 1]) {
      const height = this.zoomLevelHeights[value - 1].height;
      const cameraPos = this.viewer.camera.positionCartographic.clone();
      cameraPos.height = height;
      return this.viewer.camera.flyTo({destination: Cesium.Cartographic.toCartesian(cameraPos), duration: 0});
    }
    console.error('Wrong zoom level!');
  }

  addToVisibleOverlays(overlay){
    this.visibleOverlays.push(overlay);
  }

  removeFromVisibleOverlays(overlay){
    this.visibleOverlays.splice(this.getIndexInVisibleOverlays(overlay), 1);
  }

  private getIndexInVisibleOverlays(item:Overlay){
    // @ts-ignore
    for (let [index, i] of this.visibleOverlays.entries()){
      if (i.getId() == item.getId()) {
        return index;
      }
    }
    return -1;
  }

  makeSvgNonInteractive(entityId) {
    const cls = 'non-interactive-es-polyline-svg-' + entityId;
    if (document.getElementById(cls)) {
      document.getElementById(cls).parentNode.removeChild(document.getElementById(cls));
    }
    const stl = document.createElement('style');
    stl.id = cls;
    stl.innerHTML = '.es-polyline-svg-' + entityId + ',.es-polyline-svg-' + entityId + ' div{pointer-events:none;}\n';
    stl.innerHTML+= '.es-polyline-text-' + entityId + ',.es-polyline-text-' + entityId + ' div{pointer-events:none;}\n';
    document.body.appendChild(stl);
  }

  makeSvgInteractive(entityId) {
    const cls = 'non-interactive-es-polyline-svg-' + entityId;
    if (document.getElementById(cls)) {
      document.getElementById(cls).parentNode.removeChild(document.getElementById(cls));
    }
  }

  public getDefaultImageryProviderId(): string {
    if (window['isIOS']()) {
      return '4';
    }

    return isLocal ? '5' : '6';
  }

  private initRotatingMapValues() {
    this.originalViewerHeadingBeforeMove = Cesium.Math.toDegrees(this.viewer.camera.heading);
    this.isRotating = true;
  }
  private stopRotatingMap(){
    this._cameraEventMoveEnd.pipe(filter(val => this._sceneRotatedDegrees != Cesium.Math.toDegrees(this.viewer.camera.heading) - this.originalViewerHeadingBeforeMove)).pipe(debounceTime(500), take(1)).subscribe(()=>{
      this.additionalMapRotationByEvents = Cesium.Math.toDegrees(this.viewer.camera.heading) - this.originalViewerHeadingBeforeMove;
      this.rotateScene(this.additionalMapRotationByEvents);
      this.originalViewerHeadingBeforeMove = Cesium.Math.toDegrees(this.viewer.camera.heading);
      this.isChangeCameraMode = true;
      this.isRotating = false;
    })
    this.isRotating = false;
  }

  removeAllObjectsFromCesium() {
    this.viewer.entities.removeAll();
  }

  private initImageryProviders(tilingScheme) {
    return new Promise(async r => {
    this.imageryProviders = {
      '-1': {
      label: Yiit.t("B&W"),
        icon: null, //'adjust'
        name: Yiit.t('Black & White'),
        image: 'https://studio.oneplanevents.com/images/canvas/wbw.png',
        description: '<p>' + Yiit.t('A greyscale version of Bing Maps.') + '</p>',
        provider: new Cesium.UrlTemplateImageryProvider({
        url : GOOGLE_SATELLITE_TILE_URL,
        subdomains: GOOGLE_TILE_SUBDOMAINS,
        credit : 'Google Maps',
        tilingScheme: new Cesium.WebMercatorTilingScheme()
      }), layer: null},
      // '2': {
      //   label: "Satellite",
      //   icon: 'globe-europe',
      //   name: 'Satellite',
      //   image: 'https://www.openstreetmap.org/assets/osm_logo-d4979005d8a03d67bbf051b4e7e6ef1b26c6a34a5cd1b65908e2947c360ca391.svg',
      //   description: '<p>Bing Maps satellite imagery provided by Microsoft.</p>',
      //   provider: new Cesium.OpenStreetMapImageryProvider({url : 'https://a.tile.openstreetmap.org/'}),
      //   layer: null
      // },
      '4': {
      label: Yiit.t("Map"),
        // icon: 'map',
        icon: null,
        name: Yiit.t('Map'),
        image: 'https://studio.oneplanevents.com/images/canvas/google_logo.png',
        description: '<p>' + Yiit.t('Google Street Maps') + '</p>',
        // terrainProvider: new Cesium.CesiumTerrainProvider({
        //   url: Cesium.IonResource.fromAssetId(1),
        //   requestVertexNormals : (location.search.indexOf('vertex=0') < 0), requestWaterMask: false, requestMetadata: false
        // }),
        provider: new Cesium.UrlTemplateImageryProvider({
        url : window['CUSTOM_TILE_URL'] + '/roadmap/{width}x{height}/{z}/{x}_{y}.jpg',
        credit : 'Google Maps',
        tilingScheme: new Cesium.WebMercatorTilingScheme()
      }),
        // provider: new Cesium.BingMapsImageryProvider({
        //   url : 'https://dev.virtualearth.net',
        //   key : 'AlyhrkT-J5plcmkwVM3U_tj8zmQfETEmPFE3cGP9RKfjrE_KYPQkFjKpEskTm6qV',
        //   mapStyle : Cesium.BingMapsStyle.ROAD
        // }),
        layer: null},
      '5': {
      label: Yiit.t("Satellite"),
        // icon: 'globe',
        icon: null,
        name: Yiit.t('Satellite'),
        image: 'https://studio.oneplanevents.com/images/canvas/google_logo.png',
        description: '<p>' + Yiit.t('Bing Maps satellite imagery provided by Microsoft.') + '</p>',
        provider:
          (this.isMacOrIOSEnabled) ?
            await Cesium.BingMapsImageryProvider.fromUrl('https://dev.virtualearth.net', {
              key: window['BING_MAP_KEY'],
              mapStyle: Cesium.BingMapsStyle.AERIAL
            })
            :
            new Cesium.BingMapsImageryProvider({
              url : 'https://dev.virtualearth.net',
              key : window['BING_MAP_KEY'],
              mapStyle : Cesium.BingMapsStyle.AERIAL
            }),
        layer: null},
      '6': {
      label: Yiit.t("Satellite"),
        // icon: 'globe-americas',
        icon: null,
        name: Yiit.t('Google Satellite'),
        // image: 'https://studio.oneplanevents.com/images/canvas/satellite2.png',
        image: 'https://studio.oneplanevents.com/images/canvas/google_logo.png',
        description: '<p>' + Yiit.t('Google Maps, Satellite.') + '</p>',
        provider: new Cesium.UrlTemplateImageryProvider({
        url : GOOGLE_SATELLITE_TILE_URL.replace('.jpg', '{cacheVersion}.jpg'),
        subdomains: GOOGLE_TILE_SUBDOMAINS,
        credit : 'Google Maps',
        tilingScheme: new Cesium.WebMercatorTilingScheme(),
        customTags: {
          cacheVersion: function (imageryProvider, x, y, z) {
            let str = '';
            if (
              (z == 21 && y == 754312)
              || (z == 22 && y == 1508623)
              || (z == 22 && y == 1508622)
              || (z == 23 && y == 3017249)
              || (z == 23 && y == 3017247)
              || (z == 23 && y == 3017248)
              || (z == 15 && x >= 9688 && x <= 9689 && y >= 11723 && y <= 11724)
              || (z == 16 && x >= 19377 && x <= 19378 && y >= 23447 && y <= 23448)
              || (z == 17 && x >= 38754 && x <= 38756 && y >= 46894 && y <= 46896)
              || (z == 18 && x >= 77509 && x <= 77512 && y >= 93789 && y <= 93792)
              || (z == 19 && x >= 155018 && x <= 155025 && y >= 187578 && y <= 187584)
              || (z == 20 && x >= 310036 && x <= 310051 && y >= 375156 && y <= 375168)
              || (z == 21 && x >= 620072 && x <= 620102 && y >= 750313 && y <= 750337)
              || (z == 22 && x >= 1240145 && x <= 1240205 && y >= 1500626 && y <= 1500675)
              || (z == 23 && x >= 2480291 && x <= 2480410 && y >= 3001253 && y <= 3001350)
            ) {
              str+= '_v2';
            }
            return str;
          }
        }
      }),
        layer: null},
      '7': {
      label: Yiit.t("Roadmap"),
        icon: 'road',
        name: Yiit.t('Google Roadmap'),
        image: 'https://studio.oneplanevents.com/images/canvas/road.png',
        description: '<p>' + Yiit.t('Google Roadmaps, Satellite.') + '</p>',
        provider: new Cesium.UrlTemplateImageryProvider({
        url : window['CUSTOM_TILE_URL'] + '/roadmap/{width}x{height}/{z}/{x}_{y}.jpg',
        // url : window['CUSTOM_TILE_URL'] + '?zoom={z}&tile={x}_{y}&size={width}x{height}&maptype=roadmap',
        credit : 'Google Maps',
        tilingScheme: new Cesium.WebMercatorTilingScheme()
      }),
        layer: null},
      '8': {
      // label: Yiit.t("Hi-Res"),
      label: 'HD map',
        // icon: 'globe-americas',
        icon: null,
        name: Yiit.t('Hi-Res'),
        image: 'https://studio.oneplanevents.com/images/canvas/HD.png',
        description: '<p>' + Yiit.t('Hi-Res') + '</p>',
        terrainProvider: (this.isMacOrIOSEnabled) ?
        await Cesium.CesiumTerrainProvider.fromIonAssetId(1, {
          requestVertexNormals: (location.search.indexOf('vertex=0') < 0), requestWaterMask: false, requestMetadata: false,
        })
        :
        new Cesium.CesiumTerrainProvider({
          url: Cesium.IonResource.fromAssetId(1),
          requestVertexNormals: (location.search.indexOf('vertex=0') < 0), requestWaterMask: false, requestMetadata: false,
        }),
        provider: null,
        dependProvider: null,
        layer: null
    },
      '9': {
      // label: Yiit.t("Hi-Res"),
      label: '',
        // icon: 'globe-americas',
        icon: null,
        name: Yiit.t('Hi-Res (UK)'),
        image: 'https://studio.oneplanevents.com/images/canvas/HD.png',
        description: '<p>' + Yiit.t('Hi-Res (UK)') + '</p>',
        provider: new Cesium.UrlTemplateImageryProvider({
        url : window['CUSTOM_TILE_URL_2'] + '/satellite/{width}x{height}/{z}/{x}_{y}.jpg',
        credit : 'Blue Sky',
        tilingScheme: new Cesium.WebMercatorTilingScheme()
      }),
        layer: null},
      '10': {
      //label: Yiit.t("OS Maps"),
      label: '',
        // icon: 'globe-americas',
        icon: null,
        name: Yiit.t('OS Maps'),
        image: 'https://studio.oneplanevents.com/images/canvas/osmaps.png',
        description: '<p>' + Yiit.t('OS Maps') + '</p>',
        terrainProvider: (this.isMacOrIOSEnabled) ?
        await Cesium.CesiumTerrainProvider.fromIonAssetId(1, {
          requestVertexNormals : (location.search.indexOf('vertex=0') < 0), requestWaterMask: false, requestMetadata: false
        })
        :
        new Cesium.CesiumTerrainProvider({
          url: Cesium.IonResource.fromAssetId(1),
          requestVertexNormals : (location.search.indexOf('vertex=0') < 0), requestWaterMask: false, requestMetadata: false
        }),
        provider: new Cesium.UrlTemplateImageryProvider({
        url : window['CT2_KEY'] ? ('https://api.os.uk/maps/raster/v1/zxy/EPSG:3857/Outdoor%203857/{z}/{x}/{y}.png?key=' + window['CT2_KEY']) : '',
        tilingScheme: new Cesium.WebMercatorTilingScheme(),
        maximumLevel: 21
      }),
        layer: null},
      '11': {
      label: Yiit.t("Streets"),
        // icon: 'map',
        icon: null,
        name: Yiit.t('IGN Streets'),
        image: '/images/canvas/ign_logo.png',
        description: '<p>' + Yiit.t('IGN Streets') + '</p>',
        provider: new Cesium.WebMapTileServiceImageryProvider({
        url: 'https://wxs.ign.fr/decouverte/geoportail/wmts',
        layer: 'GEOGRAPHICALGRIDSYSTEMS.PLANIGNV2',
        style : 'normal',
        format : 'image/png',
        tileMatrixSetID : 'PM'
      }),
        layer: null},
      '12': {
      label: Yiit.t("Satellite"),
        icon: null,
        name: Yiit.t('IGN Satellite'),
        image: '/images/canvas/ign_logo.png',
        description: '<p>' + Yiit.t('IGN Satellite') + '</p>',
        provider: new Cesium.WebMapTileServiceImageryProvider({
        url:"https://wxs.ign.fr/decouverte/geoportail/wmts",
        layer: 'ORTHOIMAGERY.ORTHOPHOTOS',
        tileMatrixSetID: 'PM',
        style: 'normal',
        format: 'image/jpeg',
        service: 'WMTS',
        opacity: 0.5,
        credit: "IGN",
      }),
        layer: null},
      '13': {
      // label: Yiit.t("Hi-Res"),
      label: 'HD map',
        // icon: 'globe-americas',
        icon: null,
        name: Yiit.t('Hi-Res'),
        image: 'https://studio.oneplanevents.com/images/canvas/HD.png',
        description: '<p>' + Yiit.t('Hi-Res') + '</p>',
        terrainProvider: (this.isMacOrIOSEnabled) ?
        await Cesium.CesiumTerrainProvider.fromIonAssetId(1, {
          requestVertexNormals : (location.search.indexOf('vertex=0') < 0), requestWaterMkask: false, requestMetadata: false
        })
        :
        new Cesium.CesiumTerrainProvider({
          url: Cesium.IonResource.fromAssetId(1),
          requestVertexNormals : (location.search.indexOf('vertex=0') < 0), requestWaterMkask: false, requestMetadata: false
        }),
        provider: null,
        dependProvider: null,
        layer: null},
      '14': {
      label: Yiit.t("Bing"),
        // icon: 'map',
        icon: null,
        name: Yiit.t('Bing'),
        image: 'https://studio.oneplanevents.com/images/canvas/bing-maps.png',
        description: '<p>' + Yiit.t('Bing') + '</p>',
        provider:
          (this.isMacOrIOSEnabled) ?
            await Cesium.BingMapsImageryProvider.fromUrl('https://dev.virtualearth.net', {
              key: window['BING_MAP_KEY'],
              mapStyle: Cesium.BingMapsStyle.AERIAL
            })
         :
          new Cesium.BingMapsImageryProvider({
        url : 'https://dev.virtualearth.net',
        key : window['BING_MAP_KEY'],
        mapStyle : Cesium.BingMapsStyle.AERIAL
      }),
      layer: null
      }
    }

    this.imageryProviders['8'].provider = new Cesium.UrlTemplateImageryProvider({
      url: window.hasOwnProperty('NEARMAP_TILE_URL') ? window['NEARMAP_TILE_URL'] : '',
      subdomains: window.hasOwnProperty('NEARMAP_TILE_SUBDOMAINS') ? window['NEARMAP_TILE_SUBDOMAINS'] : '',
      rectangle: this.hdMapRectangle,
      tilingScheme,
      customTags: {
        mosaic: function(imageryProvider, x, y, level) {
          let d = nearmapService.getSelectedDateValue();
          if (!d || d == 'Latest' || d.length == 0) {
            return 'latest';
          }
          return 'earliest';
        },
        since: function(imageryProvider, x, y, level) {
          let d = nearmapService.getSelectedDateValue();
          if (!d || d == 'Latest' || d.length == 0) {
            return '1970-01-01';
          }
          return nearmapService.getSelectedDateValue();
        },
        key: function(imageryProvider, x, y, level) {
          return window.hasOwnProperty('CT1_KEY') ? window['CT1_KEY'] : '';
        }
      },
      // Hotfix of error when any images for current level not found.
      // Need add middle layer, and return transparent images if image not found,
      // or add any addition ImageryProvider provider with existing images in current level,
      // or update Cesium version / Cesuim initial setting (it works in sanbox)
      // Any of above - fix the problem
      // minimumLevel: 6
    });
    this.imageryProviders['8'].dependProvider = '6';

    this.imageryProviders['13'].provider = new Cesium.UrlTemplateImageryProvider({
      url: window.hasOwnProperty('METROMAP_TILE_URL') ? window['METROMAP_TILE_URL'] : '',
      subdomains: window.hasOwnProperty('METROMAP_TILE_SUBDOMAINS') ? window['METROMAP_TILE_SUBDOMAINS'] : '',
      rectangle: this.hdMapRectangle,
      tilingScheme,
      customTags: {
        key: function(imageryProvider, x, y, level) {
          return window.hasOwnProperty('CT5_KEY') ? window['CT5_KEY'] : '';
        }
      },
      minimumLevel: 2 // Metromap return an error "Sorry, we're unable to handle this request." with long delay for level 1
    });
    this.imageryProviders['13'].dependProvider = '6';

    if (window.hasOwnProperty('NEARMAP_IS_USE')) {
      this.enabledImageryProviders.push("8");
    }
    if (window.hasOwnProperty('CT3_KEY')) {
      this.enabledImageryProviders.push("9");
    }
    if (window.hasOwnProperty('CT2_KEY')) {
      this.enabledImageryProviders.push("10");
    }
    if (window.hasOwnProperty('CT4_KEY')) {
      this.enabledImageryProviders = this.enabledImageryProviders.concat(['11', '12']);
    }
    if (window.hasOwnProperty('METROMAP_IS_USE')) {
      this.enabledImageryProviders.push("13");
    }
    if (window['BING_MAP_KEY']) {
      this.enabledImageryProviders.push("14");
    }
    if (this.getDefaultImageryProviderId() !== '5') {
      delete this.imageryProviders['5'];
    }
      this.imageryProvidersProvider.next(this.getImageryProvidersTO());
      r(this.getImageryProvidersTO());
    })
  }
}
